(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.bodyScrollLock = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  // Older browsers don't support event options, feature detect it.

  // Adopted and modified solution from Bohdan Didukh (2017)
  // https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

  var hasPassiveEvents = false;
  if (typeof window !== 'undefined') {
    var passiveTestOptions = {
      get passive() {
        hasPassiveEvents = true;
        return undefined;
      }
    };
    window.addEventListener('testPassive', null, passiveTestOptions);
    window.removeEventListener('testPassive', null, passiveTestOptions);
  }

  var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


  var locks = [];
  var documentListenerAdded = false;
  var initialClientY = -1;
  var previousBodyOverflowSetting = void 0;
  var previousBodyPosition = void 0;
  var previousBodyPaddingRight = void 0;

  // returns true if `el` should be allowed to receive touchmove events.
  var allowTouchMove = function allowTouchMove(el) {
    return locks.some(function (lock) {
      if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
        return true;
      }

      return false;
    });
  };

  var preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;

    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if (allowTouchMove(e.target)) {
      return true;
    }

    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;

    if (e.preventDefault) e.preventDefault();

    return false;
  };

  var setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if (previousBodyPaddingRight === undefined) {
      var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
      var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

      if (_reserveScrollBarGap && scrollBarGap > 0) {
        var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
        previousBodyPaddingRight = document.body.style.paddingRight;
        document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
      }
    }

    // If previousBodyOverflowSetting is already set, don't set it again.
    if (previousBodyOverflowSetting === undefined) {
      previousBodyOverflowSetting = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  };

  var restoreOverflowSetting = function restoreOverflowSetting() {
    if (previousBodyPaddingRight !== undefined) {
      document.body.style.paddingRight = previousBodyPaddingRight;

      // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
      // can be set again.
      previousBodyPaddingRight = undefined;
    }

    if (previousBodyOverflowSetting !== undefined) {
      document.body.style.overflow = previousBodyOverflowSetting;

      // Restore previousBodyOverflowSetting to undefined
      // so setOverflowHidden knows it can be set again.
      previousBodyOverflowSetting = undefined;
    }
  };

  var setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function () {
      // If previousBodyPosition is already set, don't set it again.
      if (previousBodyPosition === undefined) {
        previousBodyPosition = {
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left
        };

        // Update the dom inside an animation frame
        var _window = window,
          scrollY = _window.scrollY,
          scrollX = _window.scrollX,
          innerHeight = _window.innerHeight;

        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.left = -scrollX + 'px';

        setTimeout(function () {
          return window.requestAnimationFrame(function () {
            // Attempt to check if the bottom bar appeared due to the position change
            var bottomBarHeight = innerHeight - window.innerHeight;
            if (bottomBarHeight && scrollY >= innerHeight) {
              // Move the content further up so that the bottom bar doesn't hide it
              document.body.style.top = -(scrollY + bottomBarHeight);
            }
          });
        }, 300);
      }
    });
  };

  var restorePositionSetting = function restorePositionSetting() {
    if (previousBodyPosition !== undefined) {
      // Convert the position from "px" to Int
      var y = -parseInt(document.body.style.top, 10);
      var x = -parseInt(document.body.style.left, 10);

      // Restore styles
      document.body.style.position = previousBodyPosition.position;
      document.body.style.top = previousBodyPosition.top;
      document.body.style.left = previousBodyPosition.left;

      // Restore scroll
      window.scrollTo(x, y);

      previousBodyPosition = undefined;
    }
  };

  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
  var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
  };

  var handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - initialClientY;

    if (allowTouchMove(event.target)) {
      return false;
    }

    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
      // element is at the top of its scroll.
      return preventDefault(event);
    }

    if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
      // element is at the bottom of its scroll.
      return preventDefault(event);
    }

    event.stopPropagation();
    return true;
  };

  var disableBodyScroll = exports.disableBodyScroll = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
      // eslint-disable-next-line no-console
      console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
      return;
    }

    // disableBodyScroll must not have been called on this targetElement before
    if (locks.some(function (lock) {
      return lock.targetElement === targetElement;
    })) {
      return;
    }

    var lock = {
      targetElement: targetElement,
      options: options || {}
    };

    locks = [].concat(_toConsumableArray(locks), [lock]);

    if (isIosDevice) {
      setPositionFixed();
    } else {
      setOverflowHidden(options);
    }

    if (isIosDevice) {
      targetElement.ontouchstart = function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch.
          initialClientY = event.targetTouches[0].clientY;
        }
      };
      targetElement.ontouchmove = function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch.
          handleScroll(event, targetElement);
        }
      };

      if (!documentListenerAdded) {
        document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
        documentListenerAdded = true;
      }
    }
  };

  var clearAllBodyScrollLocks = exports.clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
    if (isIosDevice) {
      // Clear all locks ontouchstart/ontouchmove handlers, and the references.
      locks.forEach(function (lock) {
        lock.targetElement.ontouchstart = null;
        lock.targetElement.ontouchmove = null;
      });

      if (documentListenerAdded) {
        document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
        documentListenerAdded = false;
      }

      // Reset initial clientY.
      initialClientY = -1;
    }

    if (isIosDevice) {
      restorePositionSetting();
    } else {
      restoreOverflowSetting();
    }

    locks = [];
  };

  var enableBodyScroll = exports.enableBodyScroll = function enableBodyScroll(targetElement) {
    if (!targetElement) {
      // eslint-disable-next-line no-console
      console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
      return;
    }

    locks = locks.filter(function (lock) {
      return lock.targetElement !== targetElement;
    });

    if (isIosDevice) {
      targetElement.ontouchstart = null;
      targetElement.ontouchmove = null;

      if (documentListenerAdded && locks.length === 0) {
        document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
        documentListenerAdded = false;
      }
    }

    if (isIosDevice) {
      restorePositionSetting();
    } else {
      restoreOverflowSetting();
    }
  };
});
var tns = (function () {
  var win = window;

  var raf = win.requestAnimationFrame
    || win.webkitRequestAnimationFrame
    || win.mozRequestAnimationFrame
    || win.msRequestAnimationFrame
    || function (cb) { return setTimeout(cb, 16); };

  var win$1 = window;

  var caf = win$1.cancelAnimationFrame
    || win$1.mozCancelAnimationFrame
    || function (id) { clearTimeout(id); };

  function extend() {
    var obj, name, copy,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length;

    for (; i < length; i++) {
      if ((obj = arguments[i]) !== null) {
        for (name in obj) {
          copy = obj[name];

          if (target === copy) {
            continue;
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }
    return target;
  }

  function checkStorageValue(value) {
    return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
  }

  function setLocalStorage(storage, key, value, access) {
    if (access) {
      try { storage.setItem(key, value); } catch (e) { }
    }
    return value;
  }

  function getSlideId() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;

    return 'tns' + window.tnsId;
  }

  function getBody() {
    var doc = document,
      body = doc.body;

    if (!body) {
      body = doc.createElement('body');
      body.fake = true;
    }

    return body;
  }

  var docElement = document.documentElement;

  function setFakeBody(body) {
    var docOverflow = '';
    if (body.fake) {
      docOverflow = docElement.style.overflow;
      //avoid crashing IE8, if background image is used
      body.style.background = '';
      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
      body.style.overflow = docElement.style.overflow = 'hidden';
      docElement.appendChild(body);
    }

    return docOverflow;
  }

  function resetFakeBody(body, docOverflow) {
    if (body.fake) {
      body.remove();
      docElement.style.overflow = docOverflow;
      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
      // eslint-disable-next-line
      docElement.offsetHeight;
    }
  }

  // get css-calc 

  function calc() {
    var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      div = doc.createElement('div'),
      result = false;

    body.appendChild(div);
    try {
      var str = '(10px * 10)',
        vals = ['calc' + str, '-moz-calc' + str, '-webkit-calc' + str],
        val;
      for (var i = 0; i < 3; i++) {
        val = vals[i];
        div.style.width = val;
        if (div.offsetWidth === 100) {
          result = val.replace(str, '');
          break;
        }
      }
    } catch (e) { }

    body.fake ? resetFakeBody(body, docOverflow) : div.remove();

    return result;
  }

  // get subpixel support value

  function percentageLayout() {
    // check subpixel layout supporting
    var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      wrapper = doc.createElement('div'),
      outer = doc.createElement('div'),
      str = '',
      count = 70,
      perPage = 3,
      supported = false;

    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";

    for (var i = 0; i < count; i++) {
      str += '<div></div>';
    }

    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);

    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;

    body.fake ? resetFakeBody(body, docOverflow) : wrapper.remove();

    return supported;
  }

  function mediaquerySupport() {
    if (window.matchMedia || window.msMatchMedia) {
      return true;
    }

    var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      div = doc.createElement('div'),
      style = doc.createElement('style'),
      rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}',
      position;

    style.type = 'text/css';
    div.className = 'tns-mq-test';

    body.appendChild(style);
    body.appendChild(div);

    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(doc.createTextNode(rule));
    }

    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];

    body.fake ? resetFakeBody(body, docOverflow) : div.remove();

    return position === "absolute";
  }

  // create and append style sheet
  function createStyleSheet(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style");
    // style.setAttribute("type", "text/css");

    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) { style.setAttribute("media", media); }

    // Add nonce attribute for Content Security Policy
    if (nonce) { style.setAttribute("nonce", nonce); }

    // WebKit hack :(
    // style.appendChild(document.createTextNode(""));

    // Add the <style> element to the page
    document.querySelector('head').appendChild(style);

    return style.sheet ? style.sheet : style.styleSheet;
  }

  // cross browsers addRule method
  function addCSSRule(sheet, selector, rules, index) {
    // return raf(function() {
    'insertRule' in sheet ?
      sheet.insertRule(selector + '{' + rules + '}', index) :
      sheet.addRule(selector, rules, index);
    // });
  }

  // cross browsers addRule method
  function removeCSSRule(sheet, index) {
    // return raf(function() {
    'deleteRule' in sheet ?
      sheet.deleteRule(index) :
      sheet.removeRule(index);
    // });
  }

  function getCssRulesLength(sheet) {
    var rule = ('insertRule' in sheet) ? sheet.cssRules : sheet.rules;
    return rule.length;
  }

  function toDegree(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
  }

  function getTouchDirection(angle, range) {
    var direction = false,
      gap = Math.abs(90 - Math.abs(angle));

    if (gap >= 90 - range) {
      direction = 'horizontal';
    } else if (gap <= range) {
      direction = 'vertical';
    }

    return direction;
  }

  // https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
  function forEach(arr, callback, scope) {
    for (var i = 0, l = arr.length; i < l; i++) {
      callback.call(scope, arr[i], i);
    }
  }

  var classListSupport = 'classList' in document.createElement('_');

  var hasClass = classListSupport ?
    function (el, str) { return el.classList.contains(str); } :
    function (el, str) { return el.className.indexOf(str) >= 0; };

  var addClass = classListSupport ?
    function (el, str) {
      if (!hasClass(el, str)) { el.classList.add(str); }
    } :
    function (el, str) {
      if (!hasClass(el, str)) { el.className += ' ' + str; }
    };

  var removeClass = classListSupport ?
    function (el, str) {
      if (hasClass(el, str)) { el.classList.remove(str); }
    } :
    function (el, str) {
      if (hasClass(el, str)) { el.className = el.className.replace(str, ''); }
    };

  function hasAttr(el, attr) {
    return el.hasAttribute(attr);
  }

  function getAttr(el, attr) {
    return el.getAttribute(attr);
  }

  function isNodeList(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
  }

  function setAttrs(els, attrs) {
    els = (isNodeList(els) || els instanceof Array) ? els : [els];
    if (Object.prototype.toString.call(attrs) !== '[object Object]') { return; }

    for (var i = els.length; i--;) {
      for (var key in attrs) {
        els[i].setAttribute(key, attrs[key]);
      }
    }
  }

  function removeAttrs(els, attrs) {
    els = (isNodeList(els) || els instanceof Array) ? els : [els];
    attrs = (attrs instanceof Array) ? attrs : [attrs];

    var attrLength = attrs.length;
    for (var i = els.length; i--;) {
      for (var j = attrLength; j--;) {
        els[i].removeAttribute(attrs[j]);
      }
    }
  }

  function arrayFromNodeList(nl) {
    var arr = [];
    for (var i = 0, l = nl.length; i < l; i++) {
      arr.push(nl[i]);
    }
    return arr;
  }

  function hideElement(el, forceHide) {
    if (el.style.display !== 'none') { el.style.display = 'none'; }
  }

  function showElement(el, forceHide) {
    if (el.style.display === 'none') { el.style.display = ''; }
  }

  function isVisible(el) {
    return window.getComputedStyle(el).display !== 'none';
  }

  function whichProperty(props) {
    if (typeof props === 'string') {
      var arr = [props],
        Props = props.charAt(0).toUpperCase() + props.substr(1),
        prefixes = ['Webkit', 'Moz', 'ms', 'O'];

      prefixes.forEach(function (prefix) {
        if (prefix !== 'ms' || props === 'transform') {
          arr.push(prefix + Props);
        }
      });

      props = arr;
    }

    var el = document.createElement('fakeelement'),
      len = props.length;
    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      if (el.style[prop] !== undefined) { return prop; }
    }

    return false; // explicit for ie9-
  }

  function has3DTransforms(tf) {
    if (!tf) { return false; }
    if (!window.getComputedStyle) { return false; }

    var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      el = doc.createElement('p'),
      has3d,
      cssTF = tf.length > 9 ? '-' + tf.slice(0, -9).toLowerCase() + '-' : '';

    cssTF += 'transform';

    // Add it to the body to get the computed style
    body.insertBefore(el, null);

    el.style[tf] = 'translate3d(1px,1px,1px)';
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);

    body.fake ? resetFakeBody(body, docOverflow) : el.remove();

    return (has3d !== undefined && has3d.length > 0 && has3d !== "none");
  }

  // get transitionend, animationend based on transitionDuration
  // @propin: string
  // @propOut: string, first-letter uppercase
  // Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
  function getEndProperty(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) {
      endProp = 'webkit' + propOut + 'End';
    } else if (/^O/.test(propIn)) {
      endProp = 'o' + propOut + 'End';
    } else if (propIn) {
      endProp = propOut.toLowerCase() + 'end';
    }
    return endProp;
  }

  // Test via a getter in the options object to see if the passive property is accessed
  var supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function () {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) { }
  var passiveOption = supportsPassive ? { passive: true } : false;

  function addEvents(el, obj, preventScrolling) {
    for (var prop in obj) {
      var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 && !preventScrolling ? passiveOption : false;
      el.addEventListener(prop, obj[prop], option);
    }
  }

  function removeEvents(el, obj) {
    for (var prop in obj) {
      var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 ? passiveOption : false;
      el.removeEventListener(prop, obj[prop], option);
    }
  }

  function Events() {
    return {
      topics: {},
      on: function (eventName, fn) {
        this.topics[eventName] = this.topics[eventName] || [];
        this.topics[eventName].push(fn);
      },
      off: function (eventName, fn) {
        if (this.topics[eventName]) {
          for (var i = 0; i < this.topics[eventName].length; i++) {
            if (this.topics[eventName][i] === fn) {
              this.topics[eventName].splice(i, 1);
              break;
            }
          }
        }
      },
      emit: function (eventName, data) {
        data.type = eventName;
        if (this.topics[eventName]) {
          this.topics[eventName].forEach(function (fn) {
            fn(data, eventName);
          });
        }
      }
    };
  }

  function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10),
      unit = (to.indexOf('%') >= 0) ? '%' : 'px',
      to = to.replace(unit, ''),
      from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')),
      positionTick = (to - from) / duration * tick,
      running;

    setTimeout(moveElement, tick);
    function moveElement() {
      duration -= tick;
      from += positionTick;
      element.style[attr] = prefix + from + unit + postfix;
      if (duration > 0) {
        setTimeout(moveElement, tick);
      } else {
        callback();
      }
    }
  }

  // Object.keys
  if (!Object.keys) {
    Object.keys = function (object) {
      var keys = [];
      for (var name in object) {
        if (Object.prototype.hasOwnProperty.call(object, name)) {
          keys.push(name);
        }
      }
      return keys;
    };
  }

  // ChildNode.remove
  if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }

  var tns = function (options) {
    options = extend({
      container: '.slider',
      mode: 'carousel',
      axis: 'horizontal',
      items: 1,
      gutter: 0,
      edgePadding: 0,
      fixedWidth: false,
      autoWidth: false,
      viewportMax: false,
      slideBy: 1,
      center: false,
      controls: true,
      controlsPosition: 'top',
      controlsText: ['prev', 'next'],
      controlsContainer: false,
      prevButton: false,
      nextButton: false,
      nav: true,
      navPosition: 'top',
      navContainer: false,
      navAsThumbnails: false,
      arrowKeys: false,
      speed: 300,
      autoplay: false,
      autoplayPosition: 'top',
      autoplayTimeout: 5000,
      autoplayDirection: 'forward',
      autoplayText: ['start', 'stop'],
      autoplayHoverPause: false,
      autoplayButton: false,
      autoplayButtonOutput: true,
      autoplayResetOnVisibility: true,
      animateIn: 'tns-fadeIn',
      animateOut: 'tns-fadeOut',
      animateNormal: 'tns-normal',
      animateDelay: false,
      loop: true,
      rewind: false,
      autoHeight: false,
      responsive: false,
      lazyload: false,
      lazyloadSelector: '.tns-lazy-img',
      touch: true,
      mouseDrag: false,
      swipeAngle: 15,
      nested: false,
      preventActionWhenRunning: false,
      preventScrollOnTouch: false,
      freezable: true,
      onInit: false,
      useLocalStorage: true,
      nonce: false
    }, options || {});

    var doc = document,
      win = window,
      KEYS = {
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        RIGHT: 39
      },
      tnsStorage = {},
      localStorageAccess = options.useLocalStorage;

    if (localStorageAccess) {
      // check browser version and local storage access
      var browserInfo = navigator.userAgent;
      var uid = new Date;

      try {
        tnsStorage = win.localStorage;
        if (tnsStorage) {
          tnsStorage.setItem(uid, uid);
          localStorageAccess = tnsStorage.getItem(uid) == uid;
          tnsStorage.removeItem(uid);
        } else {
          localStorageAccess = false;
        }
        if (!localStorageAccess) { tnsStorage = {}; }
      } catch (e) {
        localStorageAccess = false;
      }

      if (localStorageAccess) {
        // remove storage when browser version changes
        if (tnsStorage['tnsApp'] && tnsStorage['tnsApp'] !== browserInfo) {
          ['tC', 'tPL', 'tMQ', 'tTf', 't3D', 'tTDu', 'tTDe', 'tADu', 'tADe', 'tTE', 'tAE'].forEach(function (item) { tnsStorage.removeItem(item); });
        }
        // update browserInfo
        localStorage['tnsApp'] = browserInfo;
      }
    }

    var CALC = tnsStorage['tC'] ? checkStorageValue(tnsStorage['tC']) : setLocalStorage(tnsStorage, 'tC', calc(), localStorageAccess),
      PERCENTAGELAYOUT = tnsStorage['tPL'] ? checkStorageValue(tnsStorage['tPL']) : setLocalStorage(tnsStorage, 'tPL', percentageLayout(), localStorageAccess),
      CSSMQ = tnsStorage['tMQ'] ? checkStorageValue(tnsStorage['tMQ']) : setLocalStorage(tnsStorage, 'tMQ', mediaquerySupport(), localStorageAccess),
      TRANSFORM = tnsStorage['tTf'] ? checkStorageValue(tnsStorage['tTf']) : setLocalStorage(tnsStorage, 'tTf', whichProperty('transform'), localStorageAccess),
      HAS3DTRANSFORMS = tnsStorage['t3D'] ? checkStorageValue(tnsStorage['t3D']) : setLocalStorage(tnsStorage, 't3D', has3DTransforms(TRANSFORM), localStorageAccess),
      TRANSITIONDURATION = tnsStorage['tTDu'] ? checkStorageValue(tnsStorage['tTDu']) : setLocalStorage(tnsStorage, 'tTDu', whichProperty('transitionDuration'), localStorageAccess),
      TRANSITIONDELAY = tnsStorage['tTDe'] ? checkStorageValue(tnsStorage['tTDe']) : setLocalStorage(tnsStorage, 'tTDe', whichProperty('transitionDelay'), localStorageAccess),
      ANIMATIONDURATION = tnsStorage['tADu'] ? checkStorageValue(tnsStorage['tADu']) : setLocalStorage(tnsStorage, 'tADu', whichProperty('animationDuration'), localStorageAccess),
      ANIMATIONDELAY = tnsStorage['tADe'] ? checkStorageValue(tnsStorage['tADe']) : setLocalStorage(tnsStorage, 'tADe', whichProperty('animationDelay'), localStorageAccess),
      TRANSITIONEND = tnsStorage['tTE'] ? checkStorageValue(tnsStorage['tTE']) : setLocalStorage(tnsStorage, 'tTE', getEndProperty(TRANSITIONDURATION, 'Transition'), localStorageAccess),
      ANIMATIONEND = tnsStorage['tAE'] ? checkStorageValue(tnsStorage['tAE']) : setLocalStorage(tnsStorage, 'tAE', getEndProperty(ANIMATIONDURATION, 'Animation'), localStorageAccess);

    // get element nodes from selectors
    var supportConsoleWarn = win.console && typeof win.console.warn === "function",
      tnsList = ['container', 'controlsContainer', 'prevButton', 'nextButton', 'navContainer', 'autoplayButton'],
      optionsElements = {};

    tnsList.forEach(function (item) {
      if (typeof options[item] === 'string') {
        var str = options[item],
          el = doc.querySelector(str);
        optionsElements[item] = str;

        if (el && el.nodeName) {
          options[item] = el;
        } else {
          if (supportConsoleWarn) { console.warn('Can\'t find', options[item]); }
          return;
        }
      }
    });

    // make sure at least 1 slide
    if (options.container.children.length < 1) {
      if (supportConsoleWarn) { console.warn('No slides found in', options.container); }
      return;
    }

    // update options
    var responsive = options.responsive,
      nested = options.nested,
      carousel = options.mode === 'carousel' ? true : false;

    if (responsive) {
      // apply responsive[0] to options and remove it
      if (0 in responsive) {
        options = extend(options, responsive[0]);
        delete responsive[0];
      }

      var responsiveTem = {};
      for (var key in responsive) {
        var val = responsive[key];
        // update responsive
        // from: 300: 2
        // to:
        //   300: {
        //     items: 2
        //   }
        val = typeof val === 'number' ? { items: val } : val;
        responsiveTem[key] = val;
      }
      responsive = responsiveTem;
      responsiveTem = null;
    }

    // update options
    function updateOptions(obj) {
      for (var key in obj) {
        if (!carousel) {
          if (key === 'slideBy') { obj[key] = 'page'; }
          if (key === 'edgePadding') { obj[key] = false; }
          if (key === 'autoHeight') { obj[key] = false; }
        }

        // update responsive options
        if (key === 'responsive') { updateOptions(obj[key]); }
      }
    }
    if (!carousel) { updateOptions(options); }


    // === define and set variables ===
    if (!carousel) {
      options.axis = 'horizontal';
      options.slideBy = 'page';
      options.edgePadding = false;

      var animateIn = options.animateIn,
        animateOut = options.animateOut,
        animateDelay = options.animateDelay,
        animateNormal = options.animateNormal;
    }

    var horizontal = options.axis === 'horizontal' ? true : false,
      outerWrapper = doc.createElement('div'),
      innerWrapper = doc.createElement('div'),
      middleWrapper,
      container = options.container,
      containerParent = container.parentNode,
      containerHTML = container.outerHTML,
      slideItems = container.children,
      slideCount = slideItems.length,
      breakpointZone,
      windowWidth = getWindowWidth(),
      isOn = false;
    if (responsive) { setBreakpointZone(); }
    if (carousel) { container.className += ' tns-vpfix'; }

    // fixedWidth: viewport > rightBoundary > indexMax
    var autoWidth = options.autoWidth,
      fixedWidth = getOption('fixedWidth'),
      edgePadding = getOption('edgePadding'),
      gutter = getOption('gutter'),
      viewport = getViewportWidth(),
      center = getOption('center'),
      items = !autoWidth ? Math.floor(getOption('items')) : 1,
      slideBy = getOption('slideBy'),
      viewportMax = options.viewportMax || options.fixedWidthViewportWidth,
      arrowKeys = getOption('arrowKeys'),
      speed = getOption('speed'),
      rewind = options.rewind,
      loop = rewind ? false : options.loop,
      autoHeight = getOption('autoHeight'),
      controls = getOption('controls'),
      controlsText = getOption('controlsText'),
      nav = getOption('nav'),
      touch = getOption('touch'),
      mouseDrag = getOption('mouseDrag'),
      autoplay = getOption('autoplay'),
      autoplayTimeout = getOption('autoplayTimeout'),
      autoplayText = getOption('autoplayText'),
      autoplayHoverPause = getOption('autoplayHoverPause'),
      autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'),
      sheet = createStyleSheet(null, getOption('nonce')),
      lazyload = options.lazyload,
      lazyloadSelector = options.lazyloadSelector,
      slidePositions, // collection of slide positions
      slideItemsOut = [],
      cloneCount = loop ? getCloneCountForLoop() : 0,
      slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2,
      hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false,
      rightBoundary = fixedWidth ? getRightBoundary() : null,
      updateIndexBeforeTransform = (!carousel || !loop) ? true : false,
      // transform
      transformAttr = horizontal ? 'left' : 'top',
      transformPrefix = '',
      transformPostfix = '',
      // index
      getIndexMax = (function () {
        if (fixedWidth) {
          return function () { return center && !loop ? slideCount - 1 : Math.ceil(- rightBoundary / (fixedWidth + gutter)); };
        } else if (autoWidth) {
          return function () {
            for (var i = 0; i < slideCountNew; i++) {
              if (slidePositions[i] >= - rightBoundary) { return i; }
            }
          };
        } else {
          return function () {
            if (center && carousel && !loop) {
              return slideCount - 1;
            } else {
              return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
            }
          };
        }
      })(),
      index = getStartIndex(getOption('startIndex')),
      indexCached = index,
      displayIndex = getCurrentSlide(),
      indexMin = 0,
      indexMax = !autoWidth ? getIndexMax() : null,
      // resize
      resizeTimer,
      preventActionWhenRunning = options.preventActionWhenRunning,
      swipeAngle = options.swipeAngle,
      moveDirectionExpected = swipeAngle ? '?' : true,
      running = false,
      onInit = options.onInit,
      events = new Events(),
      // id, class
      newContainerClasses = ' tns-slider tns-' + options.mode,
      slideId = container.id || getSlideId(),
      disable = getOption('disable'),
      disabled = false,
      freezable = options.freezable,
      freeze = freezable && !autoWidth ? getFreeze() : false,
      frozen = false,
      controlsEvents = {
        'click': onControlsClick,
        'keydown': onControlsKeydown
      },
      navEvents = {
        'click': onNavClick,
        'keydown': onNavKeydown
      },
      hoverEvents = {
        'mouseover': mouseoverPause,
        'mouseout': mouseoutRestart
      },
      visibilityEvent = { 'visibilitychange': onVisibilityChange },
      docmentKeydownEvent = { 'keydown': onDocumentKeydown },
      touchEvents = {
        'touchstart': onPanStart,
        'touchmove': onPanMove,
        'touchend': onPanEnd,
        'touchcancel': onPanEnd
      }, dragEvents = {
        'mousedown': onPanStart,
        'mousemove': onPanMove,
        'mouseup': onPanEnd,
        'mouseleave': onPanEnd
      },
      hasControls = hasOption('controls'),
      hasNav = hasOption('nav'),
      navAsThumbnails = autoWidth ? true : options.navAsThumbnails,
      hasAutoplay = hasOption('autoplay'),
      hasTouch = hasOption('touch'),
      hasMouseDrag = hasOption('mouseDrag'),
      slideActiveClass = 'tns-slide-active',
      slideClonedClass = 'tns-slide-cloned',
      imgCompleteClass = 'tns-complete',
      imgEvents = {
        'load': onImgLoaded,
        'error': onImgFailed
      },
      imgsComplete,
      liveregionCurrent,
      preventScroll = options.preventScrollOnTouch === 'force' ? true : false;

    // controls
    if (hasControls) {
      var controlsContainer = options.controlsContainer,
        controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : '',
        prevButton = options.prevButton,
        nextButton = options.nextButton,
        prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : '',
        nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : '',
        prevIsButton,
        nextIsButton;
    }

    // nav
    if (hasNav) {
      var navContainer = options.navContainer,
        navContainerHTML = options.navContainer ? options.navContainer.outerHTML : '',
        navItems,
        pages = autoWidth ? slideCount : getPages(),
        pagesCached = 0,
        navClicked = -1,
        navCurrentIndex = getCurrentNavIndex(),
        navCurrentIndexCached = navCurrentIndex,
        navActiveClass = 'tns-nav-active',
        navStr = 'Carousel Page ',
        navStrCurrent = ' (Current Slide)';
    }

    // autoplay
    if (hasAutoplay) {
      var autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1,
        autoplayButton = options.autoplayButton,
        autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : '',
        autoplayHtmlStrings = ['<span class=\'tns-visually-hidden\'>', ' animation</span>'],
        autoplayTimer,
        animating,
        autoplayHoverPaused,
        autoplayUserPaused,
        autoplayVisibilityPaused,
        autoplayStopped = false;
    }

    if (hasTouch || hasMouseDrag) {
      var initPosition = {},
        lastPosition = {},
        translateInit,
        disX,
        disY,
        panStart = false,
        rafIndex,
        getDist = horizontal ?
          function (a, b) { return a.x - b.x; } :
          function (a, b) { return a.y - b.y; };
    }

    // disable slider when slidecount <= items
    if (!autoWidth) { resetVariblesWhenDisable(disable || freeze); }

    if (TRANSFORM) {
      transformAttr = TRANSFORM;
      transformPrefix = 'translate';

      if (HAS3DTRANSFORMS) {
        transformPrefix += horizontal ? '3d(' : '3d(0px, ';
        transformPostfix = horizontal ? ', 0px, 0px)' : ', 0px)';
      } else {
        transformPrefix += horizontal ? 'X(' : 'Y(';
        transformPostfix = ')';
      }

    }

    if (carousel) { container.className = container.className.replace('tns-vpfix', ''); }
    initStructure();
    initSheet();
    initSliderTransform();

    // === COMMON FUNCTIONS === //
    function resetVariblesWhenDisable(condition) {
      if (condition) {
        controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
      }
    }

    function getCurrentSlide() {
      var tem = carousel ? index - cloneCount : index;
      while (tem < 0) { tem += slideCount; }
      return tem % slideCount + 1;
    }

    function getStartIndex(ind) {
      ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
      return carousel ? ind + cloneCount : ind;
    }

    function getAbsIndex(i) {
      if (i == null) { i = index; }

      if (carousel) { i -= cloneCount; }
      while (i < 0) { i += slideCount; }

      return Math.floor(i % slideCount);
    }

    function getCurrentNavIndex() {
      var absIndex = getAbsIndex(),
        result;

      result = navAsThumbnails ? absIndex :
        fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) :
          Math.floor(absIndex / items);

      // set active nav to the last one when reaches the right edge
      if (!loop && carousel && index === indexMax) { result = pages - 1; }

      return result;
    }

    function getItemsMax() {
      // fixedWidth or autoWidth while viewportMax is not available
      if (autoWidth || (fixedWidth && !viewportMax)) {
        return slideCount - 1;
        // most cases
      } else {
        var str = fixedWidth ? 'fixedWidth' : 'items',
          arr = [];

        if (fixedWidth || options[str] < slideCount) { arr.push(options[str]); }

        if (responsive) {
          for (var bp in responsive) {
            var tem = responsive[bp][str];
            if (tem && (fixedWidth || tem < slideCount)) { arr.push(tem); }
          }
        }

        if (!arr.length) { arr.push(0); }

        return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
      }
    }

    function getCloneCountForLoop() {
      var itemsMax = getItemsMax(),
        result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : (itemsMax * 4 - slideCount);
      result = Math.max(itemsMax, result);

      return hasOption('edgePadding') ? result + 1 : result;
    }

    function getWindowWidth() {
      return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }

    function getInsertPosition(pos) {
      return pos === 'top' ? 'afterbegin' : 'beforeend';
    }

    function getClientWidth(el) {
      if (el == null) { return; }
      var div = doc.createElement('div'), rect, width;
      el.appendChild(div);
      rect = div.getBoundingClientRect();
      width = rect.right - rect.left;
      div.remove();
      return width || getClientWidth(el.parentNode);
    }

    function getViewportWidth() {
      var gap = edgePadding ? edgePadding * 2 - gutter : 0;
      return getClientWidth(containerParent) - gap;
    }

    function hasOption(item) {
      if (options[item]) {
        return true;
      } else {
        if (responsive) {
          for (var bp in responsive) {
            if (responsive[bp][item]) { return true; }
          }
        }
        return false;
      }
    }

    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    function getOption(item, ww) {
      if (ww == null) { ww = windowWidth; }

      if (item === 'items' && fixedWidth) {
        return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;

      } else {
        var result = options[item];

        if (responsive) {
          for (var bp in responsive) {
            // bp: convert string to number
            if (ww >= parseInt(bp)) {
              if (item in responsive[bp]) { result = responsive[bp][item]; }
            }
          }
        }

        if (item === 'slideBy' && result === 'page') { result = getOption('items'); }
        if (!carousel && (item === 'slideBy' || item === 'items')) { result = Math.floor(result); }

        return result;
      }
    }

    function getSlideMarginLeft(i) {
      return CALC ?
        CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' :
        i * 100 / slideCountNew + '%';
    }

    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
      var str = '';

      if (edgePaddingTem !== undefined) {
        var gap = edgePaddingTem;
        if (gutterTem) { gap -= gutterTem; }
        str = horizontal ?
          'margin: 0 ' + gap + 'px 0 ' + edgePaddingTem + 'px;' :
          'margin: ' + edgePaddingTem + 'px 0 ' + gap + 'px 0;';
      } else if (gutterTem && !fixedWidthTem) {
        var gutterTemUnit = '-' + gutterTem + 'px',
          dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
        str = 'margin: 0 ' + dir + ';';
      }

      if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) { str += getTransitionDurationStyle(speedTem); }
      return str;
    }

    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
      if (fixedWidthTem) {
        return (fixedWidthTem + gutterTem) * slideCountNew + 'px';
      } else {
        return CALC ?
          CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' :
          slideCountNew * 100 / itemsTem + '%';
      }
    }

    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
      var width;

      if (fixedWidthTem) {
        width = (fixedWidthTem + gutterTem) + 'px';
      } else {
        if (!carousel) { itemsTem = Math.floor(itemsTem); }
        var dividend = carousel ? slideCountNew : itemsTem;
        width = CALC ?
          CALC + '(100% / ' + dividend + ')' :
          100 / dividend + '%';
      }

      width = 'width:' + width;

      // inner slider: overwrite outer slider styles
      return nested !== 'inner' ? width + ';' : width + ' !important;';
    }

    function getSlideGutterStyle(gutterTem) {
      var str = '';

      // gutter maybe interger || 0
      // so can't use 'if (gutter)'
      if (gutterTem !== false) {
        var prop = horizontal ? 'padding-' : 'margin-',
          dir = horizontal ? 'right' : 'bottom';
        str = prop + dir + ': ' + gutterTem + 'px;';
      }

      return str;
    }

    function getCSSPrefix(name, num) {
      var prefix = name.substring(0, name.length - num).toLowerCase();
      if (prefix) { prefix = '-' + prefix + '-'; }

      return prefix;
    }

    function getTransitionDurationStyle(speed) {
      return getCSSPrefix(TRANSITIONDURATION, 18) + 'transition-duration:' + speed / 1000 + 's;';
    }

    function getAnimationDurationStyle(speed) {
      return getCSSPrefix(ANIMATIONDURATION, 17) + 'animation-duration:' + speed / 1000 + 's;';
    }

    function initStructure() {
      var classOuter = 'tns-outer',
        classInner = 'tns-inner',
        hasGutter = hasOption('gutter');

      outerWrapper.className = classOuter;
      innerWrapper.className = classInner;
      outerWrapper.id = slideId + '-ow';
      innerWrapper.id = slideId + '-iw';

      // set container properties
      if (container.id === '') { container.id = slideId; }
      newContainerClasses += PERCENTAGELAYOUT || autoWidth ? ' tns-subpixel' : ' tns-no-subpixel';
      newContainerClasses += CALC ? ' tns-calc' : ' tns-no-calc';
      if (autoWidth) { newContainerClasses += ' tns-autowidth'; }
      newContainerClasses += ' tns-' + options.axis;
      container.className += newContainerClasses;

      // add constrain layer for carousel
      if (carousel) {
        middleWrapper = doc.createElement('div');
        middleWrapper.id = slideId + '-mw';
        middleWrapper.className = 'tns-ovh';

        outerWrapper.appendChild(middleWrapper);
        middleWrapper.appendChild(innerWrapper);
      } else {
        outerWrapper.appendChild(innerWrapper);
      }

      if (autoHeight) {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.className += ' tns-ah';
      }

      containerParent.insertBefore(outerWrapper, container);
      innerWrapper.appendChild(container);

      // add id, class, aria attributes
      // before clone slides
      forEach(slideItems, function (item, i) {
        addClass(item, 'tns-item');
        if (!item.id) { item.id = slideId + '-item' + i; }
        if (!carousel && animateNormal) { addClass(item, animateNormal); }
        setAttrs(item, {
          'data-hidden': 'true'
        });
      });

      // ## clone slides
      // carousel: n + slides + n
      // gallery:      slides + n
      if (cloneCount) {
        var fragmentBefore = doc.createDocumentFragment(),
          fragmentAfter = doc.createDocumentFragment();

        for (var j = cloneCount; j--;) {
          var num = j % slideCount,
            cloneFirst = slideItems[num].cloneNode(true);
          addClass(cloneFirst, slideClonedClass);
          removeAttrs(cloneFirst, 'id');
          fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);

          if (carousel) {
            var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
            addClass(cloneLast, slideClonedClass);
            removeAttrs(cloneLast, 'id');
            fragmentBefore.appendChild(cloneLast);
          }
        }

        container.insertBefore(fragmentBefore, container.firstChild);
        container.appendChild(fragmentAfter);
        slideItems = container.children;
      }

    }

    function initSliderTransform() {
      // ## images loaded/failed
      if (hasOption('autoHeight') || autoWidth || !horizontal) {
        var imgs = container.querySelectorAll('img');

        // add img load event listener
        forEach(imgs, function (img) {
          var src = img.src;

          if (!lazyload) {
            // not data img
            if (src && src.indexOf('data:image') < 0) {
              img.src = '';
              addEvents(img, imgEvents);
              addClass(img, 'loading');

              img.src = src;
              // data img
            } else {
              imgLoaded(img);
            }
          }
        });

        // set imgsComplete
        raf(function () { imgsLoadedCheck(arrayFromNodeList(imgs), function () { imgsComplete = true; }); });

        // reset imgs for auto height: check visible imgs only
        if (hasOption('autoHeight')) { imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1)); }

        lazyload ? initSliderTransformStyleCheck() : raf(function () { imgsLoadedCheck(arrayFromNodeList(imgs), initSliderTransformStyleCheck); });

      } else {
        // set container transform property
        if (carousel) { doContainerTransformSilent(); }

        // update slider tools and events
        initTools();
        initEvents();
      }
    }

    function initSliderTransformStyleCheck() {
      if (autoWidth && slideCount > 1) {
        // check styles application
        var num = loop ? index : slideCount - 1;

        (function stylesApplicationCheck() {
          var left = slideItems[num].getBoundingClientRect().left;
          var right = slideItems[num - 1].getBoundingClientRect().right;

          (Math.abs(left - right) <= 1) ?
            initSliderTransformCore() :
            setTimeout(function () { stylesApplicationCheck(); }, 16);
        })();

      } else {
        initSliderTransformCore();
      }
    }


    function initSliderTransformCore() {
      // run Fn()s which are rely on image loading
      if (!horizontal || autoWidth) {
        setSlidePositions();

        if (autoWidth) {
          rightBoundary = getRightBoundary();
          if (freezable) { freeze = getFreeze(); }
          indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
          resetVariblesWhenDisable(disable || freeze);
        } else {
          updateContentWrapperHeight();
        }
      }

      // set container transform property
      if (carousel) { doContainerTransformSilent(); }

      // update slider tools and events
      initTools();
      initEvents();
    }

    function initSheet() {
      // gallery:
      // set animation classes and left value for gallery slider
      if (!carousel) {
        for (var i = index, l = index + Math.min(slideCount, items); i < l; i++) {
          var item = slideItems[i];
          item.style.left = (i - index) * 100 / items + '%';
          addClass(item, animateIn);
          removeClass(item, animateNormal);
        }
      }

      // #### LAYOUT

      // ## INLINE-BLOCK VS FLOAT

      // ## PercentageLayout:
      // slides: inline-block
      // remove blank space between slides by set font-size: 0

      // ## Non PercentageLayout:
      // slides: float
      //         margin-right: -100%
      //         margin-left: ~

      // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
      if (horizontal) {
        if (PERCENTAGELAYOUT || autoWidth) {
          addCSSRule(sheet, '#' + slideId + ' > .tns-item', 'font-size:' + win.getComputedStyle(slideItems[0]).fontSize + ';', getCssRulesLength(sheet));
          addCSSRule(sheet, '#' + slideId, 'font-size:0;', getCssRulesLength(sheet));
        } else if (carousel) {
          forEach(slideItems, function (slide, i) {
            slide.style.marginLeft = getSlideMarginLeft(i);
          });
        }
      }


      // ## BASIC STYLES
      if (CSSMQ) {
        // middle wrapper style
        if (TRANSITIONDURATION) {
          var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : '';
          addCSSRule(sheet, '#' + slideId + '-mw', str, getCssRulesLength(sheet));
        }

        // inner wrapper styles
        str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
        addCSSRule(sheet, '#' + slideId + '-iw', str, getCssRulesLength(sheet));

        // container styles
        if (carousel) {
          str = horizontal && !autoWidth ? 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ';' : '';
          if (TRANSITIONDURATION) { str += getTransitionDurationStyle(speed); }
          addCSSRule(sheet, '#' + slideId, str, getCssRulesLength(sheet));
        }

        // slide styles
        str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : '';
        if (options.gutter) { str += getSlideGutterStyle(options.gutter); }
        // set gallery items transition-duration
        if (!carousel) {
          if (TRANSITIONDURATION) { str += getTransitionDurationStyle(speed); }
          if (ANIMATIONDURATION) { str += getAnimationDurationStyle(speed); }
        }
        if (str) { addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet)); }

        // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
      } else {
        // middle wrapper styles
        update_carousel_transition_duration();

        // inner wrapper styles
        innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);

        // container styles
        if (carousel && horizontal && !autoWidth) {
          container.style.width = getContainerWidth(fixedWidth, gutter, items);
        }

        // slide styles
        var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : '';
        if (gutter) { str += getSlideGutterStyle(gutter); }

        // append to the last line
        if (str) { addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet)); }
      }

      // ## MEDIAQUERIES
      if (responsive && CSSMQ) {
        for (var bp in responsive) {
          // bp: convert string to number
          bp = parseInt(bp);

          var opts = responsive[bp],
            str = '',
            middleWrapperStr = '',
            innerWrapperStr = '',
            containerStr = '',
            slideStr = '',
            itemsBP = !autoWidth ? getOption('items', bp) : null,
            fixedWidthBP = getOption('fixedWidth', bp),
            speedBP = getOption('speed', bp),
            edgePaddingBP = getOption('edgePadding', bp),
            autoHeightBP = getOption('autoHeight', bp),
            gutterBP = getOption('gutter', bp);

          // middle wrapper string
          if (TRANSITIONDURATION && middleWrapper && getOption('autoHeight', bp) && 'speed' in opts) {
            middleWrapperStr = '#' + slideId + '-mw{' + getTransitionDurationStyle(speedBP) + '}';
          }

          // inner wrapper string
          if ('edgePadding' in opts || 'gutter' in opts) {
            innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + '}';
          }

          // container string
          if (carousel && horizontal && !autoWidth && ('fixedWidth' in opts || 'items' in opts || (fixedWidth && 'gutter' in opts))) {
            containerStr = 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ';';
          }
          if (TRANSITIONDURATION && 'speed' in opts) {
            containerStr += getTransitionDurationStyle(speedBP);
          }
          if (containerStr) {
            containerStr = '#' + slideId + '{' + containerStr + '}';
          }

          // slide string
          if ('fixedWidth' in opts || (fixedWidth && 'gutter' in opts) || !carousel && 'items' in opts) {
            slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
          }
          if ('gutter' in opts) {
            slideStr += getSlideGutterStyle(gutterBP);
          }
          // set gallery items transition-duration
          if (!carousel && 'speed' in opts) {
            if (TRANSITIONDURATION) { slideStr += getTransitionDurationStyle(speedBP); }
            if (ANIMATIONDURATION) { slideStr += getAnimationDurationStyle(speedBP); }
          }
          if (slideStr) { slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}'; }

          // add up
          str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;

          if (str) {
            sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
          }
        }
      }
    }

    function initTools() {
      // == slides ==
      updateSlideStatus();

      // == live region ==
      outerWrapper.insertAdjacentHTML('afterbegin', '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + '</span>  of ' + slideCount + '</div>');
      liveregionCurrent = outerWrapper.querySelector('.tns-liveregion .current');

      // == autoplayInit ==
      if (hasAutoplay) {
        var txt = autoplay ? 'stop' : 'start';
        if (autoplayButton) {
          setAttrs(autoplayButton, { 'data-action': txt });
        } else if (options.autoplayButtonOutput) {
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
          autoplayButton = outerWrapper.querySelector('[data-action]');
        }

        // add event
        if (autoplayButton) {
          addEvents(autoplayButton, { 'click': toggleAutoplay });
        }

        if (autoplay) {
          startAutoplay();
          if (autoplayHoverPause) { addEvents(container, hoverEvents); }
          if (autoplayResetOnVisibility) { addEvents(container, visibilityEvent); }
        }
      }

      // == navInit ==
      if (hasNav) {
        var initIndex = !carousel ? 0 : cloneCount;
        // customized nav
        // will not hide the navs in case they're thumbnails
        if (navContainer) {
          setAttrs(navContainer, { 'aria-label': 'Carousel Pagination' });
          navItems = navContainer.children;
          forEach(navItems, function (item, i) {
            setAttrs(item, {
              'data-nav': i,
              'tabindex': '-1',
              'aria-label': navStr + (i + 1),
              'aria-controls': slideId,
            });
          });

          // generated nav
        } else {
          var navHtml = '',
            hiddenStr = navAsThumbnails ? '' : 'style="display:none"';
          for (var i = 0; i < slideCount; i++) {
            // hide nav items by default
            navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
          }
          navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);

          navContainer = outerWrapper.querySelector('.tns-nav');
          navItems = navContainer.children;
        }

        updateNavVisibility();

        // add transition
        if (TRANSITIONDURATION) {
          var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(),
            str = 'transition: all ' + speed / 1000 + 's';

          if (prefix) {
            str = '-' + prefix + '-' + str;
          }

          addCSSRule(sheet, '[aria-controls^=' + slideId + '-item]', str, getCssRulesLength(sheet));
        }

        setAttrs(navItems[navCurrentIndex], { 'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent });
        removeAttrs(navItems[navCurrentIndex], 'tabindex');
        addClass(navItems[navCurrentIndex], navActiveClass);

        // add events
        addEvents(navContainer, navEvents);
      }



      // == controlsInit ==
      if (hasControls) {
        if (!controlsContainer && (!prevButton || !nextButton)) {
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" aria-controls="' + slideId + '">' + controlsText[1] + '</button></div>');

          controlsContainer = outerWrapper.querySelector('.tns-controls');
        }

        if (!prevButton || !nextButton) {
          prevButton = controlsContainer.children[0];
          nextButton = controlsContainer.children[1];
        }

        if (options.controlsContainer) {
          setAttrs(controlsContainer, {
            'aria-label': 'Carousel Navigation',
            'tabindex': '0'
          });
        }

        if (options.controlsContainer || (options.prevButton && options.nextButton)) {
          setAttrs([prevButton, nextButton], {
            'aria-controls': slideId,
            'tabindex': '-1',
          });
        }

        if (options.controlsContainer || (options.prevButton && options.nextButton)) {
          setAttrs(prevButton, { 'data-controls': 'prev' });
          setAttrs(nextButton, { 'data-controls': 'next' });
        }

        prevIsButton = isButton(prevButton);
        nextIsButton = isButton(nextButton);

        updateControlsStatus();

        // add events
        if (controlsContainer) {
          addEvents(controlsContainer, controlsEvents);
        } else {
          addEvents(prevButton, controlsEvents);
          addEvents(nextButton, controlsEvents);
        }
      }

      // hide tools if needed
      disableUI();
    }

    function initEvents() {
      // add events
      if (carousel && TRANSITIONEND) {
        var eve = {};
        eve[TRANSITIONEND] = onTransitionEnd;
        addEvents(container, eve);
      }

      if (touch) { addEvents(container, touchEvents, options.preventScrollOnTouch); }
      if (mouseDrag) { addEvents(container, dragEvents); }
      if (arrowKeys) { addEvents(doc, docmentKeydownEvent); }

      if (nested === 'inner') {
        events.on('outerResized', function () {
          resizeTasks();
          events.emit('innerLoaded', info());
        });
      } else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) {
        addEvents(win, { 'resize': onResize });
      }

      if (autoHeight) {
        if (nested === 'outer') {
          events.on('innerLoaded', doAutoHeight);
        } else if (!disable) { doAutoHeight(); }
      }

      doLazyLoad();
      if (disable) { disableSlider(); } else if (freeze) { freezeSlider(); }

      events.on('indexChanged', additionalUpdates);
      if (nested === 'inner') { events.emit('innerLoaded', info()); }
      if (typeof onInit === 'function') { onInit(info()); }
      isOn = true;
    }

    function destroy() {
      // sheet
      sheet.disabled = true;
      if (sheet.ownerNode) { sheet.ownerNode.remove(); }

      // remove win event listeners
      removeEvents(win, { 'resize': onResize });

      // arrowKeys, controls, nav
      if (arrowKeys) { removeEvents(doc, docmentKeydownEvent); }
      if (controlsContainer) { removeEvents(controlsContainer, controlsEvents); }
      if (navContainer) { removeEvents(navContainer, navEvents); }

      // autoplay
      removeEvents(container, hoverEvents);
      removeEvents(container, visibilityEvent);
      if (autoplayButton) { removeEvents(autoplayButton, { 'click': toggleAutoplay }); }
      if (autoplay) { clearInterval(autoplayTimer); }

      // container
      if (carousel && TRANSITIONEND) {
        var eve = {};
        eve[TRANSITIONEND] = onTransitionEnd;
        removeEvents(container, eve);
      }
      if (touch) { removeEvents(container, touchEvents); }
      if (mouseDrag) { removeEvents(container, dragEvents); }

      // cache Object values in options && reset HTML
      var htmlList = [containerHTML, controlsContainerHTML, prevButtonHTML, nextButtonHTML, navContainerHTML, autoplayButtonHTML];

      tnsList.forEach(function (item, i) {
        var el = item === 'container' ? outerWrapper : options[item];

        if (typeof el === 'object' && el) {
          var prevEl = el.previousElementSibling ? el.previousElementSibling : false,
            parentEl = el.parentNode;
          el.outerHTML = htmlList[i];
          options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
        }
      });


      // reset variables
      tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
      // check variables
      // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });

      for (var a in this) {
        if (a !== 'rebuild') { this[a] = null; }
      }
      isOn = false;
    }

    // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal
    function onResize(e) {
      raf(function () { resizeTasks(getEvent(e)); });
    }

    function resizeTasks(e) {
      if (!isOn) { return; }
      if (nested === 'outer') { events.emit('outerResized', info(e)); }
      windowWidth = getWindowWidth();
      var bpChanged,
        breakpointZoneTem = breakpointZone,
        needContainerTransform = false;

      if (responsive) {
        setBreakpointZone();
        bpChanged = breakpointZoneTem !== breakpointZone;
        // if (hasRightDeadZone) { needContainerTransform = true; } // *?
        if (bpChanged) { events.emit('newBreakpointStart', info(e)); }
      }

      var indChanged,
        itemsChanged,
        itemsTem = items,
        disableTem = disable,
        freezeTem = freeze,
        arrowKeysTem = arrowKeys,
        controlsTem = controls,
        navTem = nav,
        touchTem = touch,
        mouseDragTem = mouseDrag,
        autoplayTem = autoplay,
        autoplayHoverPauseTem = autoplayHoverPause,
        autoplayResetOnVisibilityTem = autoplayResetOnVisibility,
        indexTem = index;

      if (bpChanged) {
        var fixedWidthTem = fixedWidth,
          autoHeightTem = autoHeight,
          controlsTextTem = controlsText,
          centerTem = center,
          autoplayTextTem = autoplayText;

        if (!CSSMQ) {
          var gutterTem = gutter,
            edgePaddingTem = edgePadding;
        }
      }

      // get option:
      // fixed width: viewport, fixedWidth, gutter => items
      // others: window width => all variables
      // all: items => slideBy
      arrowKeys = getOption('arrowKeys');
      controls = getOption('controls');
      nav = getOption('nav');
      touch = getOption('touch');
      center = getOption('center');
      mouseDrag = getOption('mouseDrag');
      autoplay = getOption('autoplay');
      autoplayHoverPause = getOption('autoplayHoverPause');
      autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');

      if (bpChanged) {
        disable = getOption('disable');
        fixedWidth = getOption('fixedWidth');
        speed = getOption('speed');
        autoHeight = getOption('autoHeight');
        controlsText = getOption('controlsText');
        autoplayText = getOption('autoplayText');
        autoplayTimeout = getOption('autoplayTimeout');

        if (!CSSMQ) {
          edgePadding = getOption('edgePadding');
          gutter = getOption('gutter');
        }
      }
      // update options
      resetVariblesWhenDisable(disable);

      viewport = getViewportWidth(); // <= edgePadding, gutter
      if ((!horizontal || autoWidth) && !disable) {
        setSlidePositions();
        if (!horizontal) {
          updateContentWrapperHeight(); // <= setSlidePositions
          needContainerTransform = true;
        }
      }
      if (fixedWidth || autoWidth) {
        rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
        // fixedWidth: <= viewport, fixedWidth, gutter
        indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
      }

      if (bpChanged || fixedWidth) {
        items = getOption('items');
        slideBy = getOption('slideBy');
        itemsChanged = items !== itemsTem;

        if (itemsChanged) {
          if (!fixedWidth && !autoWidth) { indexMax = getIndexMax(); } // <= items
          // check index before transform in case
          // slider reach the right edge then items become bigger
          updateIndex();
        }
      }

      if (bpChanged) {
        if (disable !== disableTem) {
          if (disable) {
            disableSlider();
          } else {
            enableSlider(); // <= slidePositions, rightBoundary, indexMax
          }
        }
      }

      if (freezable && (bpChanged || fixedWidth || autoWidth)) {
        freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
        // <= fixedWidth: fixedWidth, gutter, rightBoundary
        // <= others: items

        if (freeze !== freezeTem) {
          if (freeze) {
            doContainerTransform(getContainerTransformValue(getStartIndex(0)));
            freezeSlider();
          } else {
            unfreezeSlider();
            needContainerTransform = true;
          }
        }
      }

      resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
      if (!autoplay) { autoplayHoverPause = autoplayResetOnVisibility = false; }

      if (arrowKeys !== arrowKeysTem) {
        arrowKeys ?
          addEvents(doc, docmentKeydownEvent) :
          removeEvents(doc, docmentKeydownEvent);
      }
      if (controls !== controlsTem) {
        if (controls) {
          if (controlsContainer) {
            showElement(controlsContainer);
          } else {
            if (prevButton) { showElement(prevButton); }
            if (nextButton) { showElement(nextButton); }
          }
        } else {
          if (controlsContainer) {
            hideElement(controlsContainer);
          } else {
            if (prevButton) { hideElement(prevButton); }
            if (nextButton) { hideElement(nextButton); }
          }
        }
      }
      if (nav !== navTem) {
        if (nav) {
          showElement(navContainer);
          updateNavVisibility();
        } else {
          hideElement(navContainer);
        }
      }
      if (touch !== touchTem) {
        touch ?
          addEvents(container, touchEvents, options.preventScrollOnTouch) :
          removeEvents(container, touchEvents);
      }
      if (mouseDrag !== mouseDragTem) {
        mouseDrag ?
          addEvents(container, dragEvents) :
          removeEvents(container, dragEvents);
      }
      if (autoplay !== autoplayTem) {
        if (autoplay) {
          if (autoplayButton) { showElement(autoplayButton); }
          if (!animating && !autoplayUserPaused) { startAutoplay(); }
        } else {
          if (autoplayButton) { hideElement(autoplayButton); }
          if (animating) { stopAutoplay(); }
        }
      }
      if (autoplayHoverPause !== autoplayHoverPauseTem) {
        autoplayHoverPause ?
          addEvents(container, hoverEvents) :
          removeEvents(container, hoverEvents);
      }
      if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) {
        autoplayResetOnVisibility ?
          addEvents(doc, visibilityEvent) :
          removeEvents(doc, visibilityEvent);
      }

      if (bpChanged) {
        if (fixedWidth !== fixedWidthTem || center !== centerTem) { needContainerTransform = true; }

        if (autoHeight !== autoHeightTem) {
          if (!autoHeight) { innerWrapper.style.height = ''; }
        }

        if (controls && controlsText !== controlsTextTem) {
          prevButton.innerHTML = controlsText[0];
          nextButton.innerHTML = controlsText[1];
        }

        if (autoplayButton && autoplayText !== autoplayTextTem) {
          var i = autoplay ? 1 : 0,
            html = autoplayButton.innerHTML,
            len = html.length - autoplayTextTem[i].length;
          if (html.substring(len) === autoplayTextTem[i]) {
            autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
          }
        }
      } else {
        if (center && (fixedWidth || autoWidth)) { needContainerTransform = true; }
      }

      if (itemsChanged || fixedWidth && !autoWidth) {
        pages = getPages();
        updateNavVisibility();
      }

      indChanged = index !== indexTem;
      if (indChanged) {
        events.emit('indexChanged', info());
        needContainerTransform = true;
      } else if (itemsChanged) {
        if (!indChanged) { additionalUpdates(); }
      } else if (fixedWidth || autoWidth) {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
      }

      if (itemsChanged && !carousel) { updateGallerySlidePositions(); }

      if (!disable && !freeze) {
        // non-mediaqueries: IE8
        if (bpChanged && !CSSMQ) {
          // middle wrapper styles

          // inner wrapper styles
          if (edgePadding !== edgePaddingTem || gutter !== gutterTem) {
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
          }

          if (horizontal) {
            // container styles
            if (carousel) {
              container.style.width = getContainerWidth(fixedWidth, gutter, items);
            }

            // slide styles
            var str = getSlideWidthStyle(fixedWidth, gutter, items) +
              getSlideGutterStyle(gutter);

            // remove the last line and
            // add new styles
            removeCSSRule(sheet, getCssRulesLength(sheet) - 1);
            addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
          }
        }

        // auto height
        if (autoHeight) { doAutoHeight(); }

        if (needContainerTransform) {
          doContainerTransformSilent();
          indexCached = index;
        }
      }

      if (bpChanged) { events.emit('newBreakpointEnd', info(e)); }
    }





    // === INITIALIZATION FUNCTIONS === //
    function getFreeze() {
      if (!fixedWidth && !autoWidth) {
        var a = center ? items - (items - 1) / 2 : items;
        return slideCount <= a;
      }

      var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount],
        vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;

      if (center) {
        vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
      }

      return width <= vp;
    }

    function setBreakpointZone() {
      breakpointZone = 0;
      for (var bp in responsive) {
        bp = parseInt(bp); // convert string to number
        if (windowWidth >= bp) { breakpointZone = bp; }
      }
    }

    // (slideBy, indexMin, indexMax) => index
    var updateIndex = (function () {
      return loop ?
        carousel ?
          // loop + carousel
          function () {
            var leftEdge = indexMin,
              rightEdge = indexMax;

            leftEdge += slideBy;
            rightEdge -= slideBy;

            // adjust edges when has edge paddings
            // or fixed-width slider with extra space on the right side
            if (edgePadding) {
              leftEdge += 1;
              rightEdge -= 1;
            } else if (fixedWidth) {
              if ((viewport + gutter) % (fixedWidth + gutter)) { rightEdge -= 1; }
            }

            if (cloneCount) {
              if (index > rightEdge) {
                index -= slideCount;
              } else if (index < leftEdge) {
                index += slideCount;
              }
            }
          } :
          // loop + gallery
          function () {
            if (index > indexMax) {
              while (index >= indexMin + slideCount) { index -= slideCount; }
            } else if (index < indexMin) {
              while (index <= indexMax - slideCount) { index += slideCount; }
            }
          } :
        // non-loop
        function () {
          index = Math.max(indexMin, Math.min(indexMax, index));
        };
    })();

    function disableUI() {
      if (!autoplay && autoplayButton) { hideElement(autoplayButton); }
      if (!nav && navContainer) { hideElement(navContainer); }
      if (!controls) {
        if (controlsContainer) {
          hideElement(controlsContainer);
        } else {
          if (prevButton) { hideElement(prevButton); }
          if (nextButton) { hideElement(nextButton); }
        }
      }
    }

    function enableUI() {
      if (autoplay && autoplayButton) { showElement(autoplayButton); }
      if (nav && navContainer) { showElement(navContainer); }
      if (controls) {
        if (controlsContainer) {
          showElement(controlsContainer);
        } else {
          if (prevButton) { showElement(prevButton); }
          if (nextButton) { showElement(nextButton); }
        }
      }
    }

    function freezeSlider() {
      if (frozen) { return; }

      // remove edge padding from inner wrapper
      if (edgePadding) { innerWrapper.style.margin = '0px'; }

      // add class tns-transparent to cloned slides
      if (cloneCount) {
        var str = 'tns-transparent';
        for (var i = cloneCount; i--;) {
          if (carousel) { addClass(slideItems[i], str); }
          addClass(slideItems[slideCountNew - i - 1], str);
        }
      }

      // update tools
      disableUI();

      frozen = true;
    }

    function unfreezeSlider() {
      if (!frozen) { return; }

      // restore edge padding for inner wrapper
      // for mordern browsers
      if (edgePadding && CSSMQ) { innerWrapper.style.margin = ''; }

      // remove class tns-transparent to cloned slides
      if (cloneCount) {
        var str = 'tns-transparent';
        for (var i = cloneCount; i--;) {
          if (carousel) { removeClass(slideItems[i], str); }
          removeClass(slideItems[slideCountNew - i - 1], str);
        }
      }

      // update tools
      enableUI();

      frozen = false;
    }

    function disableSlider() {
      if (disabled) { return; }

      sheet.disabled = true;
      container.className = container.className.replace(newContainerClasses.substring(1), '');
      removeAttrs(container, ['style']);
      if (loop) {
        for (var j = cloneCount; j--;) {
          if (carousel) { hideElement(slideItems[j]); }
          hideElement(slideItems[slideCountNew - j - 1]);
        }
      }

      // vertical slider
      if (!horizontal || !carousel) { removeAttrs(innerWrapper, ['style']); }

      // gallery
      if (!carousel) {
        for (var i = index, l = index + slideCount; i < l; i++) {
          var item = slideItems[i];
          removeAttrs(item, ['style']);
          removeClass(item, animateIn);
          removeClass(item, animateNormal);
        }
      }

      // update tools
      disableUI();

      disabled = true;
    }

    function enableSlider() {
      if (!disabled) { return; }

      sheet.disabled = false;
      container.className += newContainerClasses;
      doContainerTransformSilent();

      if (loop) {
        for (var j = cloneCount; j--;) {
          if (carousel) { showElement(slideItems[j]); }
          showElement(slideItems[slideCountNew - j - 1]);
        }
      }

      // gallery
      if (!carousel) {
        for (var i = index, l = index + slideCount; i < l; i++) {
          var item = slideItems[i],
            classN = i < index + items ? animateIn : animateNormal;
          item.style.left = (i - index) * 100 / items + '%';
          addClass(item, classN);
        }
      }

      // update tools
      enableUI();

      disabled = false;
    }

    function updateLiveRegion() {
      var str = getLiveRegionStr();
      if (liveregionCurrent.innerHTML !== str) { liveregionCurrent.innerHTML = str; }
    }

    function getLiveRegionStr() {
      var arr = getVisibleSlideRange(),
        start = arr[0] + 1,
        end = arr[1] + 1;
      return start === end ? start + '' : start + ' to ' + end;
    }

    function getVisibleSlideRange(val) {
      if (val == null) { val = getContainerTransformValue(); }
      var start = index, end, rangestart, rangeend;

      // get range start, range end for autoWidth and fixedWidth
      if (center || edgePadding) {
        if (autoWidth || fixedWidth) {
          rangestart = - (parseFloat(val) + edgePadding);
          rangeend = rangestart + viewport + edgePadding * 2;
        }
      } else {
        if (autoWidth) {
          rangestart = slidePositions[index];
          rangeend = rangestart + viewport;
        }
      }

      // get start, end
      // - check auto width
      if (autoWidth) {
        slidePositions.forEach(function (point, i) {
          if (i < slideCountNew) {
            if ((center || edgePadding) && point <= rangestart + 0.5) { start = i; }
            if (rangeend - point >= 0.5) { end = i; }
          }
        });

        // - check percentage width, fixed width
      } else {

        if (fixedWidth) {
          var cell = fixedWidth + gutter;
          if (center || edgePadding) {
            start = Math.floor(rangestart / cell);
            end = Math.ceil(rangeend / cell - 1);
          } else {
            end = start + Math.ceil(viewport / cell) - 1;
          }

        } else {
          if (center || edgePadding) {
            var a = items - 1;
            if (center) {
              start -= a / 2;
              end = index + a / 2;
            } else {
              end = index + a;
            }

            if (edgePadding) {
              var b = edgePadding * items / viewport;
              start -= b;
              end += b;
            }

            start = Math.floor(start);
            end = Math.ceil(end);
          } else {
            end = start + items - 1;
          }
        }

        start = Math.max(start, 0);
        end = Math.min(end, slideCountNew - 1);
      }

      return [start, end];
    }

    function doLazyLoad() {
      if (lazyload && !disable) {
        var arg = getVisibleSlideRange();
        arg.push(lazyloadSelector);

        getImageArray.apply(null, arg).forEach(function (img) {
          if (!hasClass(img, imgCompleteClass)) {
            // stop propagation transitionend event to container
            var eve = {};
            eve[TRANSITIONEND] = function (e) { e.stopPropagation(); };
            addEvents(img, eve);

            addEvents(img, imgEvents);

            // update src
            img.src = getAttr(img, 'data-src');

            // update srcset
            var srcset = getAttr(img, 'data-srcset');
            if (srcset) { img.srcset = srcset; }

            addClass(img, 'loading');
          }
        });
      }
    }

    function onImgLoaded(e) {
      imgLoaded(getTarget(e));
    }

    function onImgFailed(e) {
      imgFailed(getTarget(e));
    }

    function imgLoaded(img) {
      addClass(img, 'loaded');
      imgCompleted(img);
    }

    function imgFailed(img) {
      addClass(img, 'failed');
      imgCompleted(img);
    }

    function imgCompleted(img) {
      addClass(img, imgCompleteClass);
      removeClass(img, 'loading');
      removeEvents(img, imgEvents);
    }

    function getImageArray(start, end, imgSelector) {
      var imgs = [];
      if (!imgSelector) { imgSelector = 'img'; }

      while (start <= end) {
        forEach(slideItems[start].querySelectorAll(imgSelector), function (img) { imgs.push(img); });
        start++;
      }

      return imgs;
    }

    // check if all visible images are loaded
    // and update container height if it's done
    function doAutoHeight() {
      var imgs = getImageArray.apply(null, getVisibleSlideRange());
      raf(function () { imgsLoadedCheck(imgs, updateInnerWrapperHeight); });
    }

    function imgsLoadedCheck(imgs, cb) {
      // execute callback function if all images are complete
      if (imgsComplete) { return cb(); }

      // check image classes
      imgs.forEach(function (img, index) {
        if (!lazyload && img.complete) { imgCompleted(img); } // Check image.complete
        if (hasClass(img, imgCompleteClass)) { imgs.splice(index, 1); }
      });

      // execute callback function if selected images are all complete
      if (!imgs.length) { return cb(); }

      // otherwise execute this functiona again
      raf(function () { imgsLoadedCheck(imgs, cb); });
    }

    function additionalUpdates() {
      doLazyLoad();
      updateSlideStatus();
      updateLiveRegion();
      updateControlsStatus();
      updateNavStatus();
    }


    function update_carousel_transition_duration() {
      if (carousel && autoHeight) {
        middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + 's';
      }
    }

    function getMaxSlideHeight(slideStart, slideRange) {
      var heights = [];
      for (var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) {
        heights.push(slideItems[i].offsetHeight);
      }

      return Math.max.apply(null, heights);
    }

    // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
      var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount),
        wp = middleWrapper ? middleWrapper : innerWrapper;

      if (wp.style.height !== maxHeight) { wp.style.height = maxHeight + 'px'; }
    }

    // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions
    function setSlidePositions() {
      slidePositions = [0];
      var attr = horizontal ? 'left' : 'top',
        attr2 = horizontal ? 'right' : 'bottom',
        base = slideItems[0].getBoundingClientRect()[attr];

      forEach(slideItems, function (item, i) {
        // skip the first slide
        if (i) { slidePositions.push(item.getBoundingClientRect()[attr] - base); }
        // add the end edge
        if (i === slideCountNew - 1) { slidePositions.push(item.getBoundingClientRect()[attr2] - base); }
      });
    }

    // update slide
    function updateSlideStatus() {
      var range = getVisibleSlideRange(),
        start = range[0],
        end = range[1];

      forEach(slideItems, function (item, i) {
        // show slides
        if (i >= start && i <= end) {
          if (hasAttr(item, 'data-hidden')) {
            removeAttrs(item, ['data-hidden']);
            addClass(item, slideActiveClass);
          }
          // hide slides
        } else {
          if (!hasAttr(item, 'data-hidden')) {
            setAttrs(item, {
              'data-hidden': 'true'
            });
            removeClass(item, slideActiveClass);
          }
        }
      });
    }

    // gallery: update slide position
    function updateGallerySlidePositions() {
      var l = index + Math.min(slideCount, items);
      for (var i = slideCountNew; i--;) {
        var item = slideItems[i];

        if (i >= index && i < l) {
          // add transitions to visible slides when adjusting their positions
          addClass(item, 'tns-moving');

          item.style.left = (i - index) * 100 / items + '%';
          addClass(item, animateIn);
          removeClass(item, animateNormal);
        } else if (item.style.left) {
          item.style.left = '';
          addClass(item, animateNormal);
          removeClass(item, animateIn);
        }

        // remove outlet animation
        removeClass(item, animateOut);
      }

      // removing '.tns-moving'
      setTimeout(function () {
        forEach(slideItems, function (el) {
          removeClass(el, 'tns-moving');
        });
      }, 300);
    }

    // set tabindex on Nav
    function updateNavStatus() {
      // get current nav
      if (nav) {
        navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
        navClicked = -1;

        if (navCurrentIndex !== navCurrentIndexCached) {
          var navPrev = navItems[navCurrentIndexCached],
            navCurrent = navItems[navCurrentIndex];

          setAttrs(navPrev, {
            'tabindex': '-1',
            'aria-label': navStr + (navCurrentIndexCached + 1)
          });
          removeClass(navPrev, navActiveClass);

          setAttrs(navCurrent, { 'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent });
          removeAttrs(navCurrent, 'tabindex');
          addClass(navCurrent, navActiveClass);

          navCurrentIndexCached = navCurrentIndex;
        }
      }
    }

    function getLowerCaseNodeName(el) {
      return el.nodeName.toLowerCase();
    }

    function isButton(el) {
      return getLowerCaseNodeName(el) === 'button';
    }

    function isAriaDisabled(el) {
      return el.getAttribute('aria-disabled') === 'true';
    }

    function disEnableElement(isButton, el, val) {
      if (isButton) {
        el.disabled = val;
      } else {
        el.setAttribute('aria-disabled', val.toString());
      }
    }

    // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
      if (!controls || rewind || loop) { return; }

      var prevDisabled = (prevIsButton) ? prevButton.disabled : isAriaDisabled(prevButton),
        nextDisabled = (nextIsButton) ? nextButton.disabled : isAriaDisabled(nextButton),
        disablePrev = (index <= indexMin) ? true : false,
        disableNext = (!rewind && index >= indexMax) ? true : false;

      if (disablePrev && !prevDisabled) {
        disEnableElement(prevIsButton, prevButton, true);
      }
      if (!disablePrev && prevDisabled) {
        disEnableElement(prevIsButton, prevButton, false);
      }
      if (disableNext && !nextDisabled) {
        disEnableElement(nextIsButton, nextButton, true);
      }
      if (!disableNext && nextDisabled) {
        disEnableElement(nextIsButton, nextButton, false);
      }
    }

    // set duration
    function resetDuration(el, str) {
      if (TRANSITIONDURATION) { el.style[TRANSITIONDURATION] = str; }
    }

    function getSliderWidth() {
      return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }

    function getCenterGap(num) {
      if (num == null) { num = index; }

      var gap = edgePadding ? gutter : 0;
      return autoWidth ? ((viewport - gap) - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 :
        fixedWidth ? (viewport - fixedWidth) / 2 :
          (items - 1) / 2;
    }

    function getRightBoundary() {
      var gap = edgePadding ? gutter : 0,
        result = (viewport + gap) - getSliderWidth();

      if (center && !loop) {
        result = fixedWidth ? - (fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() :
          getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
      }
      if (result > 0) { result = 0; }

      return result;
    }

    function getContainerTransformValue(num) {
      if (num == null) { num = index; }

      var val;
      if (horizontal && !autoWidth) {
        if (fixedWidth) {
          val = - (fixedWidth + gutter) * num;
          if (center) { val += getCenterGap(); }
        } else {
          var denominator = TRANSFORM ? slideCountNew : items;
          if (center) { num -= getCenterGap(); }
          val = - num * 100 / denominator;
        }
      } else {
        val = - slidePositions[num];
        if (center && autoWidth) {
          val += getCenterGap();
        }
      }

      if (hasRightDeadZone) { val = Math.max(val, rightBoundary); }

      val += (horizontal && !autoWidth && !fixedWidth) ? '%' : 'px';

      return val;
    }

    function doContainerTransformSilent(val) {
      resetDuration(container, '0s');
      doContainerTransform(val);
    }

    function doContainerTransform(val) {
      if (val == null) { val = getContainerTransformValue(); }
      container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }

    function animateSlide(number, classOut, classIn, isOut) {
      var l = number + items;
      if (!loop) { l = Math.min(l, slideCountNew); }

      for (var i = number; i < l; i++) {
        var item = slideItems[i];

        // set item positions
        if (!isOut) { item.style.left = (i - index) * 100 / items + '%'; }

        if (animateDelay && TRANSITIONDELAY) {
          item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
        }
        removeClass(item, classOut);
        addClass(item, classIn);

        if (isOut) { slideItemsOut.push(item); }
      }
    }

    // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = (function () {
      return carousel ?
        function () {
          resetDuration(container, '');
          if (TRANSITIONDURATION || !speed) {
            // for morden browsers with non-zero duration or
            // zero duration for all browsers
            doContainerTransform();
            // run fallback function manually
            // when duration is 0 / container is hidden
            if (!speed || !isVisible(container)) { onTransitionEnd(); }

          } else {
            // for old browser with non-zero duration
            jsTransform(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
          }

          if (!horizontal) { updateContentWrapperHeight(); }
        } :
        function () {
          slideItemsOut = [];

          var eve = {};
          eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
          removeEvents(slideItems[indexCached], eve);
          addEvents(slideItems[index], eve);

          animateSlide(indexCached, animateIn, animateOut, true);
          animateSlide(index, animateNormal, animateIn);

          // run fallback function manually
          // when transition or animation not supported / duration is 0
          if (!TRANSITIONEND || !ANIMATIONEND || !speed || !isVisible(container)) { onTransitionEnd(); }
        };
    })();

    function render(e, sliderMoved) {
      if (updateIndexBeforeTransform) { updateIndex(); }

      // render when slider was moved (touch or drag) even though index may not change
      if (index !== indexCached || sliderMoved) {
        // events
        events.emit('indexChanged', info());
        events.emit('transitionStart', info());
        if (autoHeight) { doAutoHeight(); }

        // pause autoplay when click or keydown from user
        if (animating && e && ['click', 'keydown'].indexOf(e.type) >= 0) { stopAutoplay(); }

        running = true;
        transformCore();
      }
    }

    /*
     * Transfer prefixed properties to the same format
     * CSS: -Webkit-Transform => webkittransform
     * JS: WebkitTransform => webkittransform
     * @param {string} str - property
     *
     */
    function strTrans(str) {
      return str.toLowerCase().replace(/-/g, '');
    }

    // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
      // check running on gallery mode
      // make sure trantionend/animationend events run only once
      if (carousel || running) {
        events.emit('transitionEnd', info(event));

        if (!carousel && slideItemsOut.length > 0) {
          for (var i = 0; i < slideItemsOut.length; i++) {
            var item = slideItemsOut[i];
            // set item positions
            item.style.left = '';

            if (ANIMATIONDELAY && TRANSITIONDELAY) {
              item.style[ANIMATIONDELAY] = '';
              item.style[TRANSITIONDELAY] = '';
            }
            removeClass(item, animateOut);
            addClass(item, animateNormal);
          }
        }

        /* update slides, nav, controls after checking ...
         * => legacy browsers who don't support 'event'
         *    have to check event first, otherwise event.target will cause an error
         * => or 'gallery' mode:
         *   + event target is slide item
         * => or 'carousel' mode:
         *   + event target is container,
         *   + event.property is the same with transform attribute
         */
        if (!event ||
          !carousel && event.target.parentNode === container ||
          event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {

          if (!updateIndexBeforeTransform) {
            var indexTem = index;
            updateIndex();
            if (index !== indexTem) {
              events.emit('indexChanged', info());

              doContainerTransformSilent();
            }
          }

          if (nested === 'inner') { events.emit('innerLoaded', info()); }
          running = false;
          indexCached = index;
        }
      }

    }

    // # ACTIONS
    function goTo(targetIndex, e) {
      if (freeze) { return; }

      // prev slideBy
      if (targetIndex === 'prev') {
        onControlsClick(e, -1);

        // next slideBy
      } else if (targetIndex === 'next') {
        onControlsClick(e, 1);

        // go to exact slide
      } else {
        if (running) {
          if (preventActionWhenRunning) { return; } else { onTransitionEnd(); }
        }

        var absIndex = getAbsIndex(),
          indexGap = 0;

        if (targetIndex === 'first') {
          indexGap = - absIndex;
        } else if (targetIndex === 'last') {
          indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
        } else {
          if (typeof targetIndex !== 'number') { targetIndex = parseInt(targetIndex); }

          if (!isNaN(targetIndex)) {
            // from directly called goTo function
            if (!e) { targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex)); }

            indexGap = targetIndex - absIndex;
          }
        }

        // gallery: make sure new page won't overlap with current page
        if (!carousel && indexGap && Math.abs(indexGap) < items) {
          var factor = indexGap > 0 ? 1 : -1;
          indexGap += (index + indexGap - slideCount) >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
        }

        index += indexGap;

        // make sure index is in range
        if (carousel && loop) {
          if (index < indexMin) { index += slideCount; }
          if (index > indexMax) { index -= slideCount; }
        }

        // if index is changed, start rendering
        if (getAbsIndex(index) !== getAbsIndex(indexCached)) {
          render(e);
        }

      }
    }

    // on controls click
    function onControlsClick(e, dir) {
      if (running) {
        if (preventActionWhenRunning) { return; } else { onTransitionEnd(); }
      }
      var passEventObject;

      if (!dir) {
        e = getEvent(e);
        var target = getTarget(e);

        while (target !== controlsContainer && [prevButton, nextButton].indexOf(target) < 0) { target = target.parentNode; }

        var targetIn = [prevButton, nextButton].indexOf(target);
        if (targetIn >= 0) {
          passEventObject = true;
          dir = targetIn === 0 ? -1 : 1;
        }
      }

      if (rewind) {
        if (index === indexMin && dir === -1) {
          goTo('last', e);
          return;
        } else if (index === indexMax && dir === 1) {
          goTo('first', e);
          return;
        }
      }

      if (dir) {
        index += slideBy * dir;
        if (autoWidth) { index = Math.floor(index); }
        // pass e when click control buttons or keydown
        render((passEventObject || (e && e.type === 'keydown')) ? e : null);
      }
    }

    // on nav click
    function onNavClick(e) {
      if (running) {
        if (preventActionWhenRunning) { return; } else { onTransitionEnd(); }
      }

      e = getEvent(e);
      var target = getTarget(e), navIndex;

      // find the clicked nav item
      while (target !== navContainer && !hasAttr(target, 'data-nav')) { target = target.parentNode; }
      if (hasAttr(target, 'data-nav')) {
        var navIndex = navClicked = Number(getAttr(target, 'data-nav')),
          targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items,
          targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
        goTo(targetIndex, e);

        if (navCurrentIndex === navIndex) {
          if (animating) { stopAutoplay(); }
          navClicked = -1; // reset navClicked
        }
      }
    }

    // autoplay functions
    function setAutoplayTimer() {
      if (!autoplayStopped) {
        autoplayTimer = setInterval(function () {
          onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);

        animating = true;
      }
    }

    function stopAutoplayTimer() {
      clearInterval(autoplayTimer);
      animating = false;
    }

    function updateAutoplayButton(action, txt) {
      setAttrs(autoplayButton, { 'data-action': action });
      autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }

    function startAutoplay() {
      setAutoplayTimer();
      if (autoplayButton) { updateAutoplayButton('stop', autoplayText[1]); }
    }

    function stopAutoplay() {
      stopAutoplayTimer();
      if (autoplayButton) { updateAutoplayButton('start', autoplayText[0]); }
    }

    // programaitcally play/pause the slider
    function play() {
      if (autoplay && !animating) {
        startAutoplay();
        autoplayUserPaused = false;
      }
    }
    function pause() {
      if (animating) {
        stopAutoplay();
        autoplayUserPaused = true;
      }
    }

    function stop() {
      stopAutoplay();
      autoplayUserPaused = true;
      autoplayStopped = true;
    }

    function start() {
      autoplayUserPaused = false;
      autoplayStopped = false;
      startAutoplay();
    }

    function toggleAutoplay() {
      if (animating) {
        stopAutoplay();
        autoplayUserPaused = true;
      } else {
        startAutoplay();
        autoplayUserPaused = false;
      }
    }

    function onVisibilityChange() {
      if (doc.hidden) {
        if (animating) {
          stopAutoplayTimer();
          autoplayVisibilityPaused = true;
        }
      } else if (autoplayVisibilityPaused) {
        setAutoplayTimer();
        autoplayVisibilityPaused = false;
      }
    }

    function mouseoverPause() {
      if (animating) {
        stopAutoplayTimer();
        autoplayHoverPaused = true;
      }
    }

    function mouseoutRestart() {
      if (autoplayHoverPaused) {
        setAutoplayTimer();
        autoplayHoverPaused = false;
      }
    }

    // keydown events on document
    function onDocumentKeydown(e) {
      e = getEvent(e);
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);

      if (keyIndex >= 0) {
        onControlsClick(e, keyIndex === 0 ? -1 : 1);
      }
    }

    // on key control
    function onControlsKeydown(e) {
      e = getEvent(e);
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);

      if (keyIndex >= 0) {
        if (keyIndex === 0) {
          if (!prevButton.disabled) { onControlsClick(e, -1); }
        } else if (!nextButton.disabled) {
          onControlsClick(e, 1);
        }
      }
    }

    // set focus
    function setFocus(el) {
      el.focus();
    }

    // on key nav
    function onNavKeydown(e) {
      e = getEvent(e);
      var curElement = doc.activeElement;
      if (!hasAttr(curElement, 'data-nav')) { return; }

      // var code = e.keyCode,
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT, KEYS.ENTER, KEYS.SPACE].indexOf(e.keyCode),
        navIndex = Number(getAttr(curElement, 'data-nav'));

      if (keyIndex >= 0) {
        if (keyIndex === 0) {
          if (navIndex > 0) { setFocus(navItems[navIndex - 1]); }
        } else if (keyIndex === 1) {
          if (navIndex < pages - 1) { setFocus(navItems[navIndex + 1]); }
        } else {
          navClicked = navIndex;
          goTo(navIndex, e);
        }
      }
    }

    function getEvent(e) {
      e = e || win.event;
      return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
      return e.target || win.event.srcElement;
    }

    function isTouchEvent(e) {
      return e.type.indexOf('touch') >= 0;
    }

    function preventDefaultBehavior(e) {
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }

    function getMoveDirectionExpected() {
      return getTouchDirection(toDegree(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }

    function onPanStart(e) {
      if (running) {
        if (preventActionWhenRunning) { return; } else { onTransitionEnd(); }
      }

      if (autoplay && animating) { stopAutoplayTimer(); }

      panStart = true;
      if (rafIndex) {
        caf(rafIndex);
        rafIndex = null;
      }

      var $ = getEvent(e);
      events.emit(isTouchEvent(e) ? 'touchStart' : 'dragStart', info(e));

      if (!isTouchEvent(e) && ['img', 'a'].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) {
        preventDefaultBehavior(e);
      }

      lastPosition.x = initPosition.x = $.clientX;
      lastPosition.y = initPosition.y = $.clientY;
      if (carousel) {
        translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ''));
        resetDuration(container, '0s');
      }
    }

    function onPanMove(e) {
      if (panStart) {
        var $ = getEvent(e);
        lastPosition.x = $.clientX;
        lastPosition.y = $.clientY;

        if (carousel) {
          if (!rafIndex) { rafIndex = raf(function () { panUpdate(e); }); }
        } else {
          if (moveDirectionExpected === '?') { moveDirectionExpected = getMoveDirectionExpected(); }
          if (moveDirectionExpected) { preventScroll = true; }
        }

        if ((typeof e.cancelable !== 'boolean' || e.cancelable) && preventScroll) {
          e.preventDefault();
        }
      }
    }

    function panUpdate(e) {
      if (!moveDirectionExpected) {
        panStart = false;
        return;
      }
      caf(rafIndex);
      if (panStart) { rafIndex = raf(function () { panUpdate(e); }); }

      if (moveDirectionExpected === '?') { moveDirectionExpected = getMoveDirectionExpected(); }
      if (moveDirectionExpected) {
        if (!preventScroll && isTouchEvent(e)) { preventScroll = true; }

        try {
          if (e.type) { events.emit(isTouchEvent(e) ? 'touchMove' : 'dragMove', info(e)); }
        } catch (err) { }

        var x = translateInit,
          dist = getDist(lastPosition, initPosition);
        if (!horizontal || fixedWidth || autoWidth) {
          x += dist;
          x += 'px';
        } else {
          var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
          x += percentageX;
          x += '%';
        }

        container.style[transformAttr] = transformPrefix + x + transformPostfix;
      }
    }

    function onPanEnd(e) {
      if (panStart) {
        if (rafIndex) {
          caf(rafIndex);
          rafIndex = null;
        }
        if (carousel) { resetDuration(container, ''); }
        panStart = false;

        var $ = getEvent(e);
        lastPosition.x = $.clientX;
        lastPosition.y = $.clientY;
        var dist = getDist(lastPosition, initPosition);

        if (Math.abs(dist)) {
          // drag vs click
          if (!isTouchEvent(e)) {
            // prevent "click"
            var target = getTarget(e);
            addEvents(target, {
              'click': function preventClick(e) {
                preventDefaultBehavior(e);
                removeEvents(target, { 'click': preventClick });
              }
            });
          }

          if (carousel) {
            rafIndex = raf(function () {
              if (horizontal && !autoWidth) {
                var indexMoved = - dist * items / (viewport + gutter);
                indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                index += indexMoved;
              } else {
                var moved = - (translateInit + dist);
                if (moved <= 0) {
                  index = indexMin;
                } else if (moved >= slidePositions[slideCountNew - 1]) {
                  index = indexMax;
                } else {
                  var i = 0;
                  while (i < slideCountNew && moved >= slidePositions[i]) {
                    index = i;
                    if (moved > slidePositions[i] && dist < 0) { index += 1; }
                    i++;
                  }
                }
              }

              render(e, dist);
              events.emit(isTouchEvent(e) ? 'touchEnd' : 'dragEnd', info(e));
            });
          } else {
            if (moveDirectionExpected) {
              onControlsClick(e, dist > 0 ? -1 : 1);
            }
          }
        }
      }

      // reset
      if (options.preventScrollOnTouch === 'auto') { preventScroll = false; }
      if (swipeAngle) { moveDirectionExpected = '?'; }
      if (autoplay && !animating) { setAutoplayTimer(); }
    }

    // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
      var wp = middleWrapper ? middleWrapper : innerWrapper;
      wp.style.height = slidePositions[index + items] - slidePositions[index] + 'px';
    }

    function getPages() {
      var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
      return Math.min(Math.ceil(rough), slideCount);
    }

    /*
     * 1. update visible nav items list
     * 2. add "hidden" attributes to previous visible nav items
     * 3. remove "hidden" attrubutes to new visible nav items
     */
    function updateNavVisibility() {
      if (!nav || navAsThumbnails) { return; }

      if (pages !== pagesCached) {
        var min = pagesCached,
          max = pages,
          fn = showElement;

        if (pagesCached > pages) {
          min = pages;
          max = pagesCached;
          fn = hideElement;
        }

        while (min < max) {
          fn(navItems[min]);
          min++;
        }

        // cache pages
        pagesCached = pages;
      }
    }

    function info(e) {
      return {
        container: container,
        slideItems: slideItems,
        navContainer: navContainer,
        navItems: navItems,
        controlsContainer: controlsContainer,
        hasControls: hasControls,
        prevButton: prevButton,
        nextButton: nextButton,
        items: items,
        slideBy: slideBy,
        cloneCount: cloneCount,
        slideCount: slideCount,
        slideCountNew: slideCountNew,
        index: index,
        indexCached: indexCached,
        displayIndex: getCurrentSlide(),
        navCurrentIndex: navCurrentIndex,
        navCurrentIndexCached: navCurrentIndexCached,
        pages: pages,
        pagesCached: pagesCached,
        sheet: sheet,
        isOn: isOn,
        event: e || {},
      };
    }

    return {
      version: '2.9.3',
      getInfo: info,
      events: events,
      goTo: goTo,
      play: play,
      pause: pause,
      stop: stop,
      start: start,
      isOn: isOn,
      updateSliderHeight: updateInnerWrapperHeight,
      refresh: initSliderTransform,
      destroy: destroy,
      rebuild: function () {
        return tns(extend(options, optionsElements));
      }
    };
  };

  return tns;
})();
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
      (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
        var current = global.tabbable;
        var exports = global.tabbable = {};
        factory(exports);
        exports.noConflict = function () { global.tabbable = current; return exports; };
      })());
})(this, (function (exports) {
  'use strict';

  var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not(slot)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
  var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
  var NoElement = typeof Element === 'undefined';
  var matches = NoElement ? function () { } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
    return element.getRootNode();
  } : function (element) {
    return element.ownerDocument;
  };
  /**
   * @param {Element} el container to check in
   * @param {boolean} includeContainer add container to check
   * @param {(node: Element) => boolean} filter filter candidates
   * @returns {Element[]}
   */

  var getCandidates = function getCandidates(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }

    candidates = candidates.filter(filter);
    return candidates;
  };
  /**
   * @callback GetShadowRoot
   * @param {Element} element to check for shadow root
   * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
   */

  /**
   * @callback ShadowRootFilter
   * @param {Element} shadowHostNode the element which contains shadow content
   * @returns {boolean} true if a shadow root could potentially contain valid candidates.
   */

  /**
   * @typedef {Object} CandidatesScope
   * @property {Element} scope contains inner candidates
   * @property {Element[]} candidates
   */

  /**
   * @typedef {Object} IterativeOptions
   * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
   *  if a function, implies shadow support is enabled and either returns the shadow root of an element
   *  or a boolean stating if it has an undisclosed shadow root
   * @property {(node: Element) => boolean} filter filter candidates
   * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
   * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
   */

  /**
   * @param {Element[]} elements list of element containers to match candidates from
   * @param {boolean} includeContainer add container list to check
   * @param {IterativeOptions} options
   * @returns {Array.<Element|CandidatesScope>}
   */


  var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);

    while (elementsToCheck.length) {
      var element = elementsToCheck.shift();

      if (element.tagName === 'SLOT') {
        // add shadow dom slot scope (slot itself cannot be focusable)
        var assigned = element.assignedElements();
        var content = assigned.length ? assigned : element.children;
        var nestedCandidates = getCandidatesIteratively(content, true, options);

        if (options.flatten) {
          candidates.push.apply(candidates, nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: nestedCandidates
          });
        }
      } else {
        // check candidate element
        var validCandidate = matches.call(element, candidateSelector);

        if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
          candidates.push(element);
        } // iterate over shadow content if possible


        var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
          typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
        var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);

        if (shadowRoot && validShadowRoot) {
          // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
          //  shadow exists, so look at light dom children as fallback BUT create a scope for any
          //  child candidates found because they're likely slotted elements (elements that are
          //  children of the web component element (which has the shadow), in the light dom, but
          //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
          //  _after_ we return from this recursive call
          var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);

          if (options.flatten) {
            candidates.push.apply(candidates, _nestedCandidates);
          } else {
            candidates.push({
              scope: element,
              candidates: _nestedCandidates
            });
          }
        } else {
          // there's not shadow so just dig into the element's (light dom) children
          //  __without__ giving the element special scope treatment
          elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
      }
    }

    return candidates;
  };

  var getTabindex = function getTabindex(node, isScope) {
    if (node.tabIndex < 0) {
      // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
      // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
      // yet they are still part of the regular tab order; in FF, they get a default
      // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
      // order, consider their tab index to be 0.
      // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
      // so if they don't have a tabindex attribute specifically set, assume it's 0.
      //
      // isScope is positive for custom element with shadow root or slot that by default
      // have tabIndex -1, but need to be sorted by document order in order for their
      // content to be inserted in the correct position
      if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
        return 0;
      }
    }

    return node.tabIndex;
  };

  var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };

  var isInput = function isInput(node) {
    return node.tagName === 'INPUT';
  };

  var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  };

  var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === 'SUMMARY';
    });
    return r;
  };

  var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };

  var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) {
      return true;
    }

    var radioScope = node.form || getRootNode(node);

    var queryRadios = function queryRadios(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };

    var radioSet;

    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
      }
    }

    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };

  var isRadio = function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  };

  var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };

  var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  };

  var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot;

    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') {
      return true;
    }

    var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
      return true;
    } // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.


    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);

    if (!displayCheck || displayCheck === 'full') {
      if (typeof getShadowRoot === 'function') {
        // figure out if we should consider the node to be in an undisclosed shadow and use the
        //  'non-zero-area' fallback
        var originalNode = node;

        while (node) {
          var parentElement = node.parentElement;
          var rootNode = getRootNode(node);

          if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
          ) {
            // node has an undisclosed shadow which means we can only treat it as a black box, so we
            //  fall back to a non-zero-area test
            return isZeroArea(node);
          } else if (node.assignedSlot) {
            // iterate up slot
            node = node.assignedSlot;
          } else if (!parentElement && rootNode !== node.ownerDocument) {
            // cross shadow boundary
            node = rootNode.host;
          } else {
            // iterate up normal dom
            node = parentElement;
          }
        }

        node = originalNode;
      } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
      //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
      //  it might be a falsy value, which means shadow DOM support is disabled
      // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
      //  now we can just test to see if it would normally be visible or not, provided it's
      //  attached to the main document.
      // NOTE: We must consider case where node is inside a shadow DOM and given directly to
      //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.


      if (nodeIsAttached) {
        // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
      } // Else, the node isn't attached to the document, which means the `getClientRects()`
      //  API will __always__ return zero rects (this can happen, for example, if React
      //  is used to render nodes onto a detached tree, as confirmed in this thread:
      //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
      //
      // It also means that even window.getComputedStyle(node).display will return `undefined`
      //  because styles are only computed for nodes that are in the document.
      //
      // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
      //  somehow. Though it was never stated officially, anyone who has ever used tabbable
      //  APIs on nodes in detached containers has actually implicitly used tabbable in what
      //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
      //  considering __everything__ to be visible because of the innability to determine styles.

    } else if (displayCheck === 'non-zero-area') {
      // NOTE: Even though this tests that the node's client rect is non-zero to determine
      //  whether it's displayed, and that a detached node will __always__ have a zero-area
      //  client rect, we don't special-case for whether the node is attached or not. In
      //  this mode, we do want to consider nodes that have a zero area to be hidden at all
      //  times, and that includes attached or not.
      return isZeroArea(node);
    } // visible, as far as we can tell, or per current `displayCheck` mode


    return false;
  }; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
  //  unless they are in the _first_ <legend> element of the top-most disabled
  //  fieldset


  var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
      var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>

      while (parentNode) {
        if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
          // look for the first <legend> among the children of the disabled <fieldset>
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i); // when the first <legend> (in document order) is found

            if (child.tagName === 'LEGEND') {
              // if its parent <fieldset> is not nested in another disabled <fieldset>,
              // return whether `node` is a descendant of its first <legend>
              return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
            }
          } // the disabled <fieldset> containing `node` has no <legend>


          return true;
        }

        parentNode = parentNode.parentElement;
      }
    } // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state


    return false;
  };

  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
      isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }

    return true;
  };

  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
      return false;
    }

    return true;
  };

  var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);

    if (isNaN(tabIndex) || tabIndex >= 0) {
      return true;
    } // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.


    return false;
  };
  /**
   * @param {Array.<Element|CandidatesScope>} candidates
   * @returns Element[]
   */


  var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function (item, i) {
      var isScope = !!item.scope;
      var element = isScope ? item.scope : item;
      var candidateTabindex = getTabindex(element, isScope);
      var elements = isScope ? sortByOrder(item.candidates) : element;

      if (candidateTabindex === 0) {
        isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          item: item,
          isScope: isScope,
          content: elements
        });
      }
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
      sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
      return acc;
    }, []).concat(regularTabbables);
  };

  var tabbable = function tabbable(el, options) {
    options = options || {};
    var candidates;

    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([el], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
      });
    } else {
      candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    }

    return sortByOrder(candidates);
  };

  var focusable = function focusable(el, options) {
    options = options || {};
    var candidates;

    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([el], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
      });
    } else {
      candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    }

    return candidates;
  };

  var isTabbable = function isTabbable(node, options) {
    options = options || {};

    if (!node) {
      throw new Error('No node provided');
    }

    if (matches.call(node, candidateSelector) === false) {
      return false;
    }

    return isNodeMatchingSelectorTabbable(options, node);
  };

  var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

  var isFocusable = function isFocusable(node, options) {
    options = options || {};

    if (!node) {
      throw new Error('No node provided');
    }

    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }

    return isNodeMatchingSelectorFocusable(options, node);
  };

  exports.focusable = focusable;
  exports.isFocusable = isFocusable;
  exports.isTabbable = isTabbable;
  exports.tabbable = tabbable;

  Object.defineProperty(exports, '__esModule', { value: true });

}));

/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('tabbable')) :
    typeof define === 'function' && define.amd ? define(['exports', 'tabbable'], factory) :
      (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
        var current = global.focusTrap;
        var exports = global.focusTrap = {};
        factory(exports, global.tabbable);
        exports.noConflict = function () { global.focusTrap = current; return exports; };
      })());
})(this, (function (exports, tabbable) {
  'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var activeFocusTraps = function () {
    var trapQueue = [];
    return {
      activateTrap: function activateTrap(trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1];

          if (activeTrap !== trap) {
            activeTrap.pause();
          }
        }

        var trapIndex = trapQueue.indexOf(trap);

        if (trapIndex === -1) {
          trapQueue.push(trap);
        } else {
          // move this existing trap to the front of the queue
          trapQueue.splice(trapIndex, 1);
          trapQueue.push(trap);
        }
      },
      deactivateTrap: function deactivateTrap(trap) {
        var trapIndex = trapQueue.indexOf(trap);

        if (trapIndex !== -1) {
          trapQueue.splice(trapIndex, 1);
        }

        if (trapQueue.length > 0) {
          trapQueue[trapQueue.length - 1].unpause();
        }
      }
    };
  }();

  var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
  };

  var isEscapeEvent = function isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
  };

  var isTabEvent = function isTabEvent(e) {
    return e.key === 'Tab' || e.keyCode === 9;
  };

  var delay = function delay(fn) {
    return setTimeout(fn, 0);
  }; // Array.find/findIndex() are not supported on IE; this replicates enough
  //  of Array.findIndex() for our needs


  var findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function (value, i) {
      if (fn(value)) {
        idx = i;
        return false; // break
      }

      return true; // next
    });
    return idx;
  };
  /**
   * Get an option's value when it could be a plain value, or a handler that provides
   *  the value.
   * @param {*} value Option's value to check.
   * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
   * @returns {*} The `value`, or the handler's returned value.
   */


  var valueOrHandler = function valueOrHandler(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    return typeof value === 'function' ? value.apply(void 0, params) : value;
  };

  var getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
  };

  var createFocusTrap = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true
    }, userOptions);

    var state = {
      // containers given to createFocusTrap()
      // @type {Array<HTMLElement>}
      containers: [],
      // list of objects identifying tabbable nodes in `containers` in the trap
      // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
      //  is active, but the trap should never get to a state where there isn't at least one group
      //  with at least one tabbable node in it (that would lead to an error condition that would
      //  result in an error being thrown)
      // @type {Array<{
      //   container: HTMLElement,
      //   tabbableNodes: Array<HTMLElement>, // empty if none
      //   focusableNodes: Array<HTMLElement>, // empty if none
      //   firstTabbableNode: HTMLElement|null,
      //   lastTabbableNode: HTMLElement|null,
      //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
      // }>}
      containerGroups: [],
      // same order/length as `containers` list
      // references to objects in `containerGroups`, but only those that actually have
      //  tabbable nodes in them
      // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
      //  the same length
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      // timer ID for when delayInitialFocus is true and initial focus in this trap
      //  has been delayed during activation
      delayInitialFocusTimer: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

    /**
     * Gets a configuration option value.
     * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
     *  value will be taken from this object. Otherwise, value will be taken from base configuration.
     * @param {string} optionName Name of the option whose value is sought.
     * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
     *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
     */

    var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
     * Finds the index of the container that contains the element.
     * @param {HTMLElement} element
     * @returns {number} Index of the container in either `state.containers` or
     *  `state.containerGroups` (the order/length of these lists are the same); -1
     *  if the element isn't found.
     */


    var findContainerIndex = function findContainerIndex(element) {
      // NOTE: search `containerGroups` because it's possible a group contains no tabbable
      //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
      //  and we still need to find the element in there
      return state.containerGroups.findIndex(function (_ref) {
        var container = _ref.container,
          tabbableNodes = _ref.tabbableNodes;
        return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
          //  web components if the `tabbableOptions.getShadowRoot` option was used for
          //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
          //  look inside web components even if open)
          tabbableNodes.find(function (node) {
            return node === element;
          });
      });
    };
    /**
     * Gets the node for the given option, which is expected to be an option that
     *  can be either a DOM node, a string that is a selector to get a node, `false`
     *  (if a node is explicitly NOT given), or a function that returns any of these
     *  values.
     * @param {string} optionName
     * @returns {undefined | false | HTMLElement | SVGElement} Returns
     *  `undefined` if the option is not specified; `false` if the option
     *  resolved to `false` (node explicitly not given); otherwise, the resolved
     *  DOM node.
     * @throws {Error} If the option is set, not `false`, and is not, or does not
     *  resolve to a node.
     */


    var getNodeForOption = function getNodeForOption(optionName) {
      var optionValue = config[optionName];

      if (typeof optionValue === 'function') {
        for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }

        optionValue = optionValue.apply(void 0, params);
      }

      if (optionValue === true) {
        optionValue = undefined; // use default value
      }

      if (!optionValue) {
        if (optionValue === undefined || optionValue === false) {
          return optionValue;
        } // else, empty string (invalid), null (invalid), 0 (invalid)


        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }

      var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

      if (typeof optionValue === 'string') {
        node = doc.querySelector(optionValue); // resolve to node, or null if fails

        if (!node) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
      }

      return node;
    };

    var getInitialFocusNode = function getInitialFocusNode() {
      var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

      if (node === false) {
        return false;
      }

      if (node === undefined) {
        // option not specified: use fallback options
        if (findContainerIndex(doc.activeElement) >= 0) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

          node = firstTabbableNode || getNodeForOption('fallbackFocus');
        }
      }

      if (!node) {
        throw new Error('Your focus-trap needs to have at least one focusable element');
      }

      return node;
    };

    var updateTabbableNodes = function updateTabbableNodes() {
      state.containerGroups = state.containers.map(function (container) {
        var tabbableNodes = tabbable.tabbable(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
        //  are a superset of tabbable nodes

        var focusableNodes = tabbable.focusable(container, config.tabbableOptions);
        return {
          container: container,
          tabbableNodes: tabbableNodes,
          focusableNodes: focusableNodes,
          firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
          lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,

          /**
           * Finds the __tabbable__ node that follows the given node in the specified direction,
           *  in this container, if any.
           * @param {HTMLElement} node
           * @param {boolean} [forward] True if going in forward tab order; false if going
           *  in reverse.
           * @returns {HTMLElement|undefined} The next tabbable node, if any.
           */
          nextTabbableNode: function nextTabbableNode(node) {
            var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            // NOTE: If tabindex is positive (in order to manipulate the tab order separate
            //  from the DOM order), this __will not work__ because the list of focusableNodes,
            //  while it contains tabbable nodes, does not sort its nodes in any order other
            //  than DOM order, because it can't: Where would you place focusable (but not
            //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
            // Support for positive tabindex is already broken and hard to manage (possibly
            //  not supportable, TBD), so this isn't going to make things worse than they
            //  already are, and at least makes things better for the majority of cases where
            //  tabindex is either 0/unset or negative.
            // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
            var nodeIdx = focusableNodes.findIndex(function (n) {
              return n === node;
            });

            if (nodeIdx < 0) {
              return undefined;
            }

            if (forward) {
              return focusableNodes.slice(nodeIdx + 1).find(function (n) {
                return tabbable.isTabbable(n, config.tabbableOptions);
              });
            }

            return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
              return tabbable.isTabbable(n, config.tabbableOptions);
            });
          }
        };
      });
      state.tabbableGroups = state.containerGroups.filter(function (group) {
        return group.tabbableNodes.length > 0;
      }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either

      if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
      ) {
        throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
      }
    };

    var tryFocus = function tryFocus(node) {
      if (node === false) {
        return;
      }

      if (node === doc.activeElement) {
        return;
      }

      if (!node || !node.focus) {
        tryFocus(getInitialFocusNode());
        return;
      }

      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;

      if (isSelectableInput(node)) {
        node.select();
      }
    };

    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
      var node = getNodeForOption('setReturnFocus', previousActiveElement);
      return node ? node : node === false ? false : previousActiveElement;
    }; // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.


    var checkPointerDown = function checkPointerDown(e) {
      var target = getActualTarget(e);

      if (findContainerIndex(target) >= 0) {
        // allow the click since it ocurred inside the trap
        return;
      }

      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        // immediately deactivate the trap
        trap.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: config.returnFocusOnDeactivate && !tabbable.isFocusable(target, config.tabbableOptions)
        });
        return;
      } // This is needed for mobile devices.
      // (If we'll only let `click` events through,
      // then on mobile they will be blocked anyways if `touchstart` is blocked.)


      if (valueOrHandler(config.allowOutsideClick, e)) {
        // allow the click outside the trap to take place
        return;
      } // otherwise, prevent the click


      e.preventDefault();
    }; // In case focus escapes the trap for some strange reason, pull it back in.


    var checkFocusIn = function checkFocusIn(e) {
      var target = getActualTarget(e);
      var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.

      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        // escaped! pull it back in to where it just left
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    }; // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.


    var checkTab = function checkTab(e) {
      var target = getActualTarget(e);
      updateTabbableNodes();
      var destinationNode = null;

      if (state.tabbableGroups.length > 0) {
        // make sure the target is actually contained in a group
        // NOTE: the target may also be the container itself if it's focusable
        //  with tabIndex='-1' and was given initial focus
        var containerIndex = findContainerIndex(target);
        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;

        if (containerIndex < 0) {
          // target not found in any group: quite possible focus has escaped the trap,
          //  so bring it back in to...
          if (e.shiftKey) {
            // ...the last node in the last group
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            // ...the first node in the first group
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (e.shiftKey) {
          // REVERSE
          // is the target the first tabbable node in a group?
          var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
            var firstTabbableNode = _ref2.firstTabbableNode;
            return target === firstTabbableNode;
          });

          if (startOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
            // an exception case where the target is either the container itself, or
            //  a non-tabbable node that was given focus (i.e. tabindex is negative
            //  and user clicked on it or node was programmatically given focus)
            //  and is not followed by any other tabbable node, in which
            //  case, we should handle shift+tab as if focus were on the container's
            //  first tabbable node, and go to the last tabbable node of the LAST group
            startOfGroupIndex = containerIndex;
          }

          if (startOfGroupIndex >= 0) {
            // YES: then shift+tab should go to the last tabbable node in the
            //  previous group (and wrap around to the last tabbable node of
            //  the LAST group if it's the first tabbable node of the FIRST group)
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = destinationGroup.lastTabbableNode;
          }
        } else {
          // FORWARD
          // is the target the last tabbable node in a group?
          var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
            var lastTabbableNode = _ref3.lastTabbableNode;
            return target === lastTabbableNode;
          });

          if (lastOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
            // an exception case where the target is the container itself, or
            //  a non-tabbable node that was given focus (i.e. tabindex is negative
            //  and user clicked on it or node was programmatically given focus)
            //  and is not followed by any other tabbable node, in which
            //  case, we should handle tab as if focus were on the container's
            //  last tabbable node, and go to the first tabbable node of the FIRST group
            lastOfGroupIndex = containerIndex;
          }

          if (lastOfGroupIndex >= 0) {
            // YES: then tab should go to the first tabbable node in the next
            //  group (and wrap around to the first tabbable node of the FIRST
            //  group if it's the last tabbable node of the LAST group)
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = _destinationGroup.firstTabbableNode;
          }
        }
      } else {
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
      }

      if (destinationNode) {
        e.preventDefault();
        tryFocus(destinationNode);
      } // else, let the browser take care of [shift+]tab and move the focus

    };

    var checkKey = function checkKey(e) {
      if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
        e.preventDefault();
        trap.deactivate();
        return;
      }

      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    };

    var checkClick = function checkClick(e) {
      var target = getActualTarget(e);

      if (findContainerIndex(target) >= 0) {
        return;
      }

      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }

      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
    }; //
    // EVENT LISTENERS
    //


    var addListeners = function addListeners() {
      if (!state.active) {
        return;
      } // There can be only one listening focus trap at a time


      activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
      // that caused the focus trap activation.

      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
        tryFocus(getInitialFocusNode());
      }) : tryFocus(getInitialFocusNode());
      doc.addEventListener('focusin', checkFocusIn, true);
      doc.addEventListener('mousedown', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('touchstart', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('click', checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkKey, {
        capture: true,
        passive: false
      });
      return trap;
    };

    var removeListeners = function removeListeners() {
      if (!state.active) {
        return;
      }

      doc.removeEventListener('focusin', checkFocusIn, true);
      doc.removeEventListener('mousedown', checkPointerDown, true);
      doc.removeEventListener('touchstart', checkPointerDown, true);
      doc.removeEventListener('click', checkClick, true);
      doc.removeEventListener('keydown', checkKey, true);
      return trap;
    }; //
    // TRAP DEFINITION
    //


    trap = {
      get active() {
        return state.active;
      },

      get paused() {
        return state.paused;
      },

      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }

        var onActivate = getOption(activateOptions, 'onActivate');
        var onPostActivate = getOption(activateOptions, 'onPostActivate');
        var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }

        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;

        if (onActivate) {
          onActivate();
        }

        var finishActivation = function finishActivation() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }

          addListeners();

          if (onPostActivate) {
            onPostActivate();
          }
        };

        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }

        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }

        var options = _objectSpread2({
          onDeactivate: config.onDeactivate,
          onPostDeactivate: config.onPostDeactivate,
          checkCanReturnFocus: config.checkCanReturnFocus
        }, deactivateOptions);

        clearTimeout(state.delayInitialFocusTimer); // noop if undefined

        state.delayInitialFocusTimer = undefined;
        removeListeners();
        state.active = false;
        state.paused = false;
        activeFocusTraps.deactivateTrap(trap);
        var onDeactivate = getOption(options, 'onDeactivate');
        var onPostDeactivate = getOption(options, 'onPostDeactivate');
        var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
        var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');

        if (onDeactivate) {
          onDeactivate();
        }

        var finishDeactivation = function finishDeactivation() {
          delay(function () {
            if (returnFocus) {
              tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }

            if (onPostDeactivate) {
              onPostDeactivate();
            }
          });
        };

        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }

        finishDeactivation();
        return this;
      },
      pause: function pause() {
        if (state.paused || !state.active) {
          return this;
        }

        state.paused = true;
        removeListeners();
        return this;
      },
      unpause: function unpause() {
        if (!state.paused || !state.active) {
          return this;
        }

        state.paused = false;
        updateTabbableNodes();
        addListeners();
        return this;
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function (element) {
          return typeof element === 'string' ? doc.querySelector(element) : element;
        });

        if (state.active) {
          updateTabbableNodes();
        }

        return this;
      }
    }; // initialize container elements

    trap.updateContainerElements(elements);
    return trap;
  };

  exports.createFocusTrap = createFocusTrap;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
!function (t, e) { "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.aspnetValidation = e() : t.aspnetValidation = e() }(window, (function () { return function (t) { var e = {}; function r(n) { if (e[n]) return e[n].exports; var a = e[n] = { i: n, l: !1, exports: {} }; return t[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports } return r.m = t, r.c = e, r.d = function (t, e, n) { r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n }) }, r.r = function (t) { "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 }) }, r.t = function (t, e) { if (1 & e && (t = r(t)), 8 & e) return t; if (4 & e && "object" == typeof t && t && t.__esModule) return t; var n = Object.create(null); if (r.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var a in t) r.d(n, a, function (e) { return t[e] }.bind(null, a)); return n }, r.n = function (t) { var e = t && t.__esModule ? function () { return t.default } : function () { return t }; return r.d(e, "a", e), e }, r.o = function (t, e) { return Object.prototype.hasOwnProperty.call(t, e) }, r.p = "", r(r.s = 0) }([function (t, e, r) { "use strict"; r.r(e), r.d(e, "isValidatable", (function () { return s })), r.d(e, "MvcValidationProviders", (function () { return d })), r.d(e, "ValidationService", (function () { return f })); var n = function (t, e, r, n) { return new (r || (r = Promise))((function (a, i) { function s(t) { try { l(n.next(t)) } catch (t) { i(t) } } function o(t) { try { l(n.throw(t)) } catch (t) { i(t) } } function l(t) { var e; t.done ? a(t.value) : (e = t.value, e instanceof r ? e : new r((function (t) { t(e) }))).then(s, o) } l((n = n.apply(t, e || [])).next()) })) }, a = function (t, e) { var r, n, a, i, s = { label: 0, sent: function () { if (1 & a[0]) throw a[1]; return a[1] }, trys: [], ops: [] }; return i = { next: o(0), throw: o(1), return: o(2) }, "function" == typeof Symbol && (i[Symbol.iterator] = function () { return this }), i; function o(o) { return function (l) { return function (o) { if (r) throw new TypeError("Generator is already executing."); for (; i && (i = 0, o[0] && (s = 0)), s;)try { if (r = 1, n && (a = 2 & o[0] ? n.return : o[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, o[1])).done) return a; switch (n = 0, a && (o = [2 & o[0], a.value]), o[0]) { case 0: case 1: a = o; break; case 4: return s.label++, { value: o[1], done: !1 }; case 5: s.label++, n = o[1], o = [0]; continue; case 7: o = s.ops.pop(), s.trys.pop(); continue; default: if (!(a = s.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== o[0] && 2 !== o[0])) { s = 0; continue } if (3 === o[0] && (!a || o[1] > a[0] && o[1] < a[3])) { s.label = o[1]; break } if (6 === o[0] && s.label < a[1]) { s.label = a[1], a = o; break } if (a && s.label < a[2]) { s.label = a[2], s.ops.push(o); break } a[2] && s.ops.pop(), s.trys.pop(); continue }o = e.call(t, s) } catch (t) { o = [6, t], n = 0 } finally { r = a = 0 } if (5 & o[0]) throw o[1]; return { value: o[0] ? o[1] : void 0, done: !0 } }([o, l]) } } }, i = new (function () { function t() { this.warn = globalThis.console.warn } return t.prototype.log = function (t) { for (var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r] }, t }()), s = function (t) { return t instanceof HTMLInputElement || t instanceof HTMLSelectElement || t instanceof HTMLTextAreaElement }, o = ["input", "select", "textarea"], l = function (t) { return o.map((function (e) { return "".concat(e).concat(t || "") })).join(",") }; function u(t, e) { var r = t.name, n = e.substring(2), a = r.lastIndexOf("."); if (a > -1) { var i = r.substring(0, a) + "." + n, o = document.getElementsByName(i)[0]; if (s(o)) return o } return t.form.querySelector(l("[name=".concat(n, "]"))) } var d = function () { this.required = function (t, e, r) { var n = e.type.toLowerCase(); if ("checkbox" === n || "radio" === n) { for (var a = 0, i = Array.from(e.form.querySelectorAll(l("[name='".concat(e.name, "'][type='").concat(n, "']")))); a < i.length; a++) { var s = i[a]; if (s instanceof HTMLInputElement && !0 === s.checked) return !0 } if ("checkbox" === n) { var o = e.form.querySelector("input[name='".concat(e.name, "'][type='hidden']")); if (o instanceof HTMLInputElement && "false" === o.value) return !0 } return !1 } return Boolean(t) }, this.stringLength = function (t, e, r) { if (!t) return !0; if (r.min) { var n = parseInt(r.min); if (t.length < n) return !1 } if (r.max) { var a = parseInt(r.max); if (t.length > a) return !1 } return !0 }, this.compare = function (t, e, r) { if (!r.other) return !0; var n = u(e, r.other); return !n || n.value === t }, this.range = function (t, e, r) { if (!t) return !0; var n = parseFloat(t); return !isNaN(n) && (!(r.min && n < parseFloat(r.min)) && !(r.max && n > parseFloat(r.max))) }, this.regex = function (t, e, r) { return !t || !r.pattern || new RegExp(r.pattern).test(t) }, this.email = function (t, e, r) { return !t || /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/.test(t) }, this.creditcard = function (t, e, r) { if (!t) return !0; if (/[^0-9 \-]+/.test(t)) return !1; var n, a, i = 0, s = 0, o = !1; if ((t = t.replace(/\D/g, "")).length < 13 || t.length > 19) return !1; for (n = t.length - 1; n >= 0; n--)a = t.charAt(n), s = parseInt(a, 10), o && (s *= 2) > 9 && (s -= 9), i += s, o = !o; return i % 10 == 0 }, this.url = function (t, e, r) { if (!t) return !0; var n = t.toLowerCase(); return n.indexOf("http://") > -1 || n.indexOf("https://") > -1 || n.indexOf("ftp://") > -1 }, this.phone = function (t, e, r) { return !t || !/[\+\-\s][\-\s]/g.test(t) && /^\+?[0-9\-\s]+$/.test(t) }, this.remote = function (t, e, r) { if (!t) return !0; for (var n = r.additionalfields.split(","), a = {}, i = 0, s = n; i < s.length; i++) { var o = s[i], l = o.substr(2), d = u(e, o); Boolean(d && d.value) && (a[l] = d.value) } var f = r.url, c = []; for (var l in a) { var m = encodeURIComponent(l) + "=" + encodeURIComponent(a[l]); c.push(m) } var h = c.join("&"); return new Promise((function (t, e) { var n = new XMLHttpRequest; if ("Post" === r.type) { var i = new FormData; for (var s in a) i.append(s, a[s]); n.open("post", f), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.send(h) } else n.open("get", f + "?" + h), n.send(); n.onload = function (r) { if (n.status >= 200 && n.status < 300) { var a = JSON.parse(n.responseText); t(a) } else e({ status: n.status, statusText: n.statusText, data: n.responseText }) }, n.onerror = function (t) { e({ status: n.status, statusText: n.statusText, data: n.responseText }) } })) } }, f = function () { function t(t) { var e = this; this.providers = {}, this.messageFor = {}, this.elementUIDs = [], this.elementByUID = {}, this.formInputs = {}, this.validators = {}, this.elementEvents = {}, this.summary = {}, this.debounce = 300, this.allowHiddenFields = !1, this.validateForm = function (t, r) { var n = e.getElementUID(t), a = e.elementEvents[n]; a && a(void 0, r) }, this.preValidate = function (t) { t.preventDefault(), t.stopImmediatePropagation() }, this.handleValidated = function (t, r, n) { r ? e.submitValidForm(t, n) : e.focusFirstInvalid(t) }, this.submitValidForm = function (t, e) { var r = new SubmitEvent("submit", e); if (t.dispatchEvent(r)) { var n = e.submitter; if (n) { var a = n.getAttribute("name"); if (a) { var i = document.createElement("input"); i.type = "hidden", i.name = a, i.value = n.getAttribute("value"), t.appendChild(i) } } t.submit() } }, this.focusFirstInvalid = function (t) { var r = e.getElementUID(t), n = e.formInputs[r].filter((function (t) { return e.summary[t] })); if (n.length > 0) { var a = e.elementByUID[n[0]]; a && a.focus({ preventScroll: true }) } }, this.isValid = function (t, r, n) { void 0 === r && (r = !0), r && e.validateForm(t, n); var a = e.getElementUID(t); return 0 == e.formInputs[a].filter((function (t) { return e.summary[t] })).length }, this.isFieldValid = function (t, r, n) { if (void 0 === r && (r = !0), r) { var a = t.closest("form"); null != a && e.validateForm(a, n) } var i = e.getElementUID(t); return void 0 === e.summary[i] }, this.ValidationInputCssClassName = "input-validation-error", this.ValidationInputValidCssClassName = "input-validation-valid", this.ValidationMessageCssClassName = "field-validation-error", this.ValidationMessageValidCssClassName = "field-validation-valid", this.ValidationSummaryCssClassName = "validation-summary-errors", this.ValidationSummaryValidCssClassName = "validation-summary-valid", this.logger = t || i } return t.prototype.addProvider = function (t, e) { this.providers[t] || (this.logger.log("Registered provider: %s", t), this.providers[t] = e) }, t.prototype.addMvcProviders = function () { var t = new d; this.addProvider("required", t.required), this.addProvider("length", t.stringLength), this.addProvider("maxlength", t.stringLength), this.addProvider("minlength", t.stringLength), this.addProvider("equalto", t.compare), this.addProvider("range", t.range), this.addProvider("regex", t.regex), this.addProvider("creditcard", t.creditcard), this.addProvider("email", t.email), this.addProvider("url", t.url), this.addProvider("phone", t.phone), this.addProvider("remote", t.remote) }, t.prototype.scanMessages = function (t, e) { void 0 === e && (e = !1); for (var r = 0, n = Array.from(t.querySelectorAll("span[form]")); r < n.length; r++) { var a = n[r]; (u = document.getElementById(a.getAttribute("form"))) && (e ? this.removeValidationMessageSpan(u, a) : this.pushValidationMessageSpan(u, a)) } var i = Array.from(t.querySelectorAll("form")); t instanceof HTMLFormElement && i.push(t); var s = t instanceof Element ? t.closest("form") : null; s && i.push(s); for (var o = 0, l = i; o < l.length; o++)for (var u = l[o], d = 0, f = Array.from(u.querySelectorAll("[data-valmsg-for]")); d < f.length; d++) { a = f[d]; e ? this.removeValidationMessageSpan(u, a) : this.pushValidationMessageSpan(u, a) } }, t.prototype.pushValidationMessageSpan = function (t, e) { var r = this.getElementUID(t), n = "".concat(r, ":").concat(e.getAttribute("data-valmsg-for")), a = this.messageFor[n] || (this.messageFor[n] = []); a.indexOf(e) < 0 ? a.push(e) : this.logger.log("Validation element for '%s' is already tracked", n, e) }, t.prototype.removeValidationMessageSpan = function (t, e) { var r = this.getElementUID(t), n = "".concat(r, ":").concat(e.getAttribute("data-valmsg-for")), a = this.messageFor[n]; if (a) { var i = a.indexOf(e); i >= 0 ? a.splice(i, 1) : this.logger.log("Validation element for '%s' was already removed", n, e) } }, t.prototype.parseDirectives = function (t) { for (var e = {}, r = {}, n = "data-val-".length, a = 0; a < t.length; a++) { var i = t[a]; if (0 === i.name.indexOf("data-val-")) { var s = i.name.substr(n); r[s] = i.value } } var o = function (t) { if (-1 === t.indexOf("-")) { for (var n = Object.keys(r).filter((function (e) { return e !== t && 0 === e.indexOf(t) })), a = { error: r[t], params: {} }, i = (t + "-").length, s = 0; s < n.length; s++) { var o = r[n[s]], l = n[s].substr(i); a.params[l] = o } e[t] = a } }; for (var s in r) o(s); return e }, t.prototype.guid4 = function () { return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (function (t) { var e = 16 * Math.random() | 0; return ("x" == t ? e : 3 & e | 8).toString(16) })) }, t.prototype.getElementUID = function (t) { var e = this.elementUIDs.filter((function (e) { return e.node === t }))[0]; if (e) return e.uid; var r = this.guid4(); return this.elementUIDs.push({ node: t, uid: r }), this.elementByUID[r] = t, r }, t.prototype.getFormValidationTask = function (t) { var e = this.formInputs[t]; if (!e || 0 === e.length) return Promise.resolve(!0); for (var r = [], n = 0; n < e.length; n++) { var a = e[n], i = this.validators[a]; i && r.push(i) } var s = r.map((function (t) { return t() })); return Promise.all(s).then((function (t) { return t.every((function (t) { return t })) })) }, t.prototype.getMessageFor = function (t) { if (!t.form) return []; var e = this.getElementUID(t.form), r = "".concat(e, ":").concat(t.name); return this.messageFor[r] }, t.prototype.shouldValidate = function (t) { return !(t && t.submitter && t.submitter.formNoValidate) }, t.prototype.trackFormInput = function (t, e) { var r = this, i = this.getElementUID(t); if (this.formInputs[i] || (this.formInputs[i] = []), -1 === this.formInputs[i].indexOf(e) ? this.formInputs[i].push(e) : this.logger.log("Form input for UID '%s' is already tracked", e), !this.elementEvents[i]) { var s = !1, o = function (e, o) { if (!s && r.shouldValidate(e)) { var l = r.getFormValidationTask(i); l && (e && r.preValidate(e), s = !0, r.logger.log("Validating", t), l.then((function (i) { return n(r, void 0, void 0, (function () { var r; return a(this, (function (n) { switch (n.label) { case 0: return this.logger.log("Validated (success = %s)", i, t), o ? (o(i), [2]) : (r = new CustomEvent("validation", { detail: { valid: i } }), t.dispatchEvent(r), [4, new Promise((function (t) { return setTimeout(t, 0) }))]); case 1: return n.sent(), this.handleValidated(t, i, e), [2] } })) })) })).catch((function (t) { r.logger.log("Validation error", t) })).finally((function () { s = !1 }))) } }; t.addEventListener("submit", o), t.addEventListener("reset", (function (t) { for (var e = 0, n = r.formInputs[i]; e < n.length; e++) { var a = n[e], s = r.elementByUID[a]; s.classList.contains(r.ValidationInputCssClassName) && s.classList.remove(r.ValidationInputCssClassName), s.classList.contains(r.ValidationInputValidCssClassName) && s.classList.remove(r.ValidationInputValidCssClassName); var o = r.getMessageFor(s); if (o) for (var l = 0; l < o.length; l++)o[l].innerHTML = ""; delete r.summary[a] } r.renderSummary() })), this.elementEvents[i] = o } }, t.prototype.untrackFormInput = function (t, e) { var r = this.getElementUID(t); if (this.formInputs[r]) { var n = this.formInputs[r].indexOf(e); n >= 0 ? this.formInputs[r].splice(n, 1) : this.logger.log("Form input for UID '%s' was already removed", e) } }, t.prototype.addInput = function (t) { var e = this, r = this.getElementUID(t), n = this.parseDirectives(t.attributes); if (this.validators[r] = this.createValidator(t, n), t.form && this.trackFormInput(t.form, r), !this.elementEvents[r]) { var a, i = function (t) { var n = e.validators[r]; clearTimeout(a), a = setTimeout(n, e.debounce) }, s = "select" === t.tagName.toLowerCase(), o = t.dataset.valEvent; s ? t.addEventListener("change", i) : o ? t.addEventListener(o, i) : t.addEventListener("input", i), this.elementEvents[r] = i } }, t.prototype.removeInput = function (t) { var e = this.getElementUID(t); delete this.summary[e], delete this.elementEvents[e], delete this.validators[e], t.form && this.untrackFormInput(t.form, e) }, t.prototype.scanInputs = function (t, e) { void 0 === e && (e = !1); var r = Array.from(t.querySelectorAll(l('[data-val="true"]'))); s(t) && "true" === t.getAttribute("data-val") && r.push(t); for (var n = 0; n < r.length; n++) { var a = r[n]; e ? this.removeInput(a) : this.addInput(a) } }, t.prototype.createSummaryDOM = function () { if (!Object.keys(this.summary).length) return null; var t = [], e = document.createElement("ul"); for (var r in this.summary) { var n = this.elementByUID[r]; if ((!(n instanceof HTMLInputElement) || "checkbox" !== n.type && "radio" !== n.type || n.className !== this.ValidationInputValidCssClassName) && !(t.indexOf(this.summary[r]) > -1)) { var a = document.createElement("li"); a.innerHTML = this.summary[r], e.appendChild(a), t.push(this.summary[r]) } } return e }, t.prototype.renderSummary = function () { var t = document.querySelectorAll('[data-valmsg-summary="true"]'); if (t.length) { var e = JSON.stringify(this.summary, Object.keys(this.summary).sort()); if (e !== this.renderedSummaryJSON) { this.renderedSummaryJSON = e; for (var r = this.createSummaryDOM(), n = 0; n < t.length; n++) { for (var a = t[n], i = a.querySelectorAll("ul"), s = 0; s < i.length; s++)i[s].remove(); r && r.hasChildNodes() ? (this.swapClasses(a, this.ValidationSummaryCssClassName, this.ValidationSummaryValidCssClassName), a.appendChild(r.cloneNode(!0))) : this.swapClasses(a, this.ValidationSummaryValidCssClassName, this.ValidationSummaryCssClassName) } } } }, t.prototype.addError = function (t, e) { var r = this.getMessageFor(t); if (r) for (var n = 0; n < r.length; n++) { r[n]; r[n].innerHTML = e, this.swapClasses(r[n], this.ValidationMessageCssClassName, this.ValidationMessageValidCssClassName) } if (this.swapClasses(t, this.ValidationInputCssClassName, this.ValidationInputValidCssClassName), t.form) { var a = t.form.querySelectorAll(l('[name="'.concat(t.name, '"]'))); for (n = 0; n < a.length; n++) { this.swapClasses(a[n], this.ValidationInputCssClassName, this.ValidationInputValidCssClassName); var i = this.getElementUID(a[n]); this.summary[i] = e } } this.renderSummary() }, t.prototype.removeError = function (t) { var e = this.getMessageFor(t); if (e) for (var r = 0; r < e.length; r++)e[r].innerHTML = "", this.swapClasses(e[r], this.ValidationMessageValidCssClassName, this.ValidationMessageCssClassName); if (this.swapClasses(t, this.ValidationInputValidCssClassName, this.ValidationInputCssClassName), t.form) { var n = t.form.querySelectorAll(l('[name="'.concat(t.name, '"]'))); for (r = 0; r < n.length; r++) { this.swapClasses(n[r], this.ValidationInputValidCssClassName, this.ValidationInputCssClassName); var a = this.getElementUID(n[r]); delete this.summary[a] } } this.renderSummary() }, t.prototype.createValidator = function (t, e) { var r = this; return function () { return n(r, void 0, void 0, (function () { var r, n, i, s, o, l, u, d, f, c, m; return a(this, (function (a) { switch (a.label) { case 0: if (this.isHidden(t)) return [3, 7]; for (i in n = [], r = e) n.push(i); s = 0, a.label = 1; case 1: return s < n.length ? (i = n[s]) in r ? (l = e[o = i], (u = this.providers[o]) ? (this.logger.log("Running %s validator on element", o, t), d = u(t.value, t, l.params), f = !1, c = l.error, "boolean" != typeof d ? [3, 2] : (f = d, [3, 5])) : (this.logger.log("aspnet-validation provider not implemented: %s", o), [3, 6])) : [3, 6] : [3, 7]; case 2: return "string" != typeof d ? [3, 3] : (f = !1, c = d, [3, 5]); case 3: return [4, d]; case 4: "boolean" == typeof (m = a.sent()) ? f = m : (f = !1, c = m), a.label = 5; case 5: if (!f) return this.addError(t, c), [2, !1]; a.label = 6; case 6: return s++, [3, 1]; case 7: return this.removeError(t), [2, !0] } })) })) } }, t.prototype.isHidden = function (t) { return !(this.allowHiddenFields || t.offsetWidth || t.offsetHeight || t.getClientRects().length) }, t.prototype.swapClasses = function (t, e, r) { t.classList.contains(e) || t.classList.add(e), t.classList.contains(r) && t.classList.remove(r) }, t.prototype.bootstrap = function (t) { var e = this; t = t || {}, this.addMvcProviders(); var r = window.document, n = t.root || r.body, a = function () { e.scan(n), t.watch && e.watch(n) }; "complete" === r.readyState || "interactive" === r.readyState ? a() : r.addEventListener("DOMContentLoaded", a) }, t.prototype.scan = function (t) { this.logger.log("Scanning", t), this.scanMessages(t), this.scanInputs(t) }, t.prototype.remove = function (t) { this.logger.log("Removing", t), this.scanMessages(t, !0), this.scanInputs(t, !0) }, t.prototype.watch = function (t) { var e = this; this.observer = new MutationObserver((function (t) { t.forEach((function (t) { e.observed(t) })) })), this.observer.observe(t, { attributes: !0, childList: !0, subtree: !0 }), this.logger.log("Watching for mutations") }, t.prototype.observed = function (t) { var e, r, n; if ("childList" === t.type) { for (var a = 0; a < t.addedNodes.length; a++) { var i = t.addedNodes[a]; this.logger.log("Added node", i), i instanceof HTMLElement && this.scan(i) } for (a = 0; a < t.removedNodes.length; a++) { i = t.removedNodes[a]; this.logger.log("Removed node", i), i instanceof HTMLElement && this.remove(i) } } else if ("attributes" === t.type && t.target instanceof HTMLElement) { var s = null !== (e = t.oldValue) && void 0 !== e ? e : "", o = null !== (n = null === (r = t.target.attributes[t.attributeName]) || void 0 === r ? void 0 : r.value) && void 0 !== n ? n : ""; this.logger.log("Attribute '%s' changed from '%s' to '%s'", t.attributeName, s, o, t.target), s !== o && this.scan(t.target) } }, t }() }]) }));


var Intersection = (function () {

    function Intersection() {

        this.attributeName = 'data-intersection-observer';

        this.intersectionElements = document.querySelectorAll('[' + this.attributeName + ']');

        if (!this.intersectionElements.length)

            return;

        this.setup();

    }

    Intersection.prototype.setup = function () {

        var self = this;

        if (self.isSupported()) {

            self.observer = new IntersectionObserver(function (entries) {

                Helpers.scopedLoop(entries, function (entry, i, context) {

                    if (entry.isIntersecting) {

                        entry.target.setAttribute(self.attributeName, 'visible');

                    }

                }, self);

            }, {

                threshold: 0.25

            });

            Helpers.scopedLoop(self.intersectionElements, function (element, i, context) {

                self.observer.observe(element);

            }, self);

            return;

        }

        Helpers.scopedLoop(self.intersectionElements, function (element, i, context) {

            element.setAttribute(self.attributeName, 'visible');

        }, self);

    };

    Intersection.prototype.isSupported = function () {

        return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;

    };

    return Intersection;

}());

new Intersection();


var BackgroundImage = (function () {
    function BackgroundImage() {
        this.backgroundImageElements = document.querySelectorAll('[data-background-image]');
        this.backgroundImagePrefix = 'data-background-image-';
        this.webPSupport = localStorage.getItem('webPSupport');
        if (!this.backgroundImageElements.length)
            return;
        var self = this;
        if (self.webPSupport) {
            self.backgroundImagePrefix += 'webp-';
            self.init(self);
            return;
        }
        self.checkWebPSupport('lossy', function (feature, isSupported) {
            if (isSupported) {
                self.backgroundImagePrefix += 'webp-';
                localStorage.setItem('webPSupport', 'true');
            }
            self.init(self);
        });
    }
    BackgroundImage.prototype.checkWebPSupport = function (feature, callback) {
        var kTestImages = {
            lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
            lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
            alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
            animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
        };
        var img = new Image();
        img.onload = function () {
            var result = (img.width > 0) && (img.height > 0);
            callback(feature, result);
        };
        img.onerror = function () { callback(feature, false); };
        img.src = "data:image/webp;base64," + kTestImages[feature];
    };
    BackgroundImage.prototype.init = function (self) {
        var changeBackgrounds = Helpers.debounce(function () {
            Helpers.scopedLoop(self.backgroundImageElements, function (backgroundImageElement, i, context) {
                context.changeBackground(backgroundImageElement, self);
            }, self);
        }, 100);
        changeBackgrounds();
        window.addEventListener('resize', changeBackgrounds);
    };
    BackgroundImage.prototype.changeBackground = function (backgroundImageElement, self) {
        var imageUrl = backgroundImageElement.getAttribute(self.backgroundImagePrefix + 'small');
        if (self.isLarge()) {
            imageUrl = backgroundImageElement.getAttribute(self.backgroundImagePrefix + 'large');
        }
        else if (self.isMedium()) {
            imageUrl = backgroundImageElement.getAttribute(self.backgroundImagePrefix + 'medium');
        }
        backgroundImageElement.style.backgroundImage = "url(".concat(imageUrl, ")");
        backgroundImageElement.setAttribute('data-background-image', 'loaded');
    };
    BackgroundImage.prototype.isMedium = function () {
        return window.matchMedia('(min-width: 500px)').matches;
    };
    BackgroundImage.prototype.isLarge = function () {
        return window.matchMedia('(min-width: 1100px)').matches;
    };
    return BackgroundImage;
}());
new BackgroundImage();

var Video = (function () {
    function Video(videoElement) {
        this.intersectionObserverSupported = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        if (!videoElement)
            return;
        this.setup(videoElement);
    }
    Video.prototype.setup = function (videoElement) {
        var context = this;
        var videoSmallSource = videoElement.getAttribute('data-video-small-source');
        var videoLargeSource = videoElement.getAttribute('data-video-large-source');
        var videoClass = videoElement.hasAttribute('data-video-class') ? videoElement.getAttribute('data-video-class') : '';
        var videoMuted = videoElement.hasAttribute('data-video-muted') && videoElement.getAttribute('data-video-muted').toLowerCase() === 'true';
        var videoLoops = videoElement.hasAttribute('data-video-loops') && videoElement.getAttribute('data-video-loops').toLowerCase() === 'true';
        var videoControls = videoElement.hasAttribute('data-video-controls') && videoElement.getAttribute('data-video-controls').toLowerCase() === 'true';
        var videoAutoplay = videoElement.hasAttribute('data-video-autoplay') && videoElement.getAttribute('data-video-autoplay').toLowerCase() === 'true';
        var videoEventListener = videoElement.hasAttribute('data-video-event-listener') ? videoElement.getAttribute('data-video-event-listener') : '';
        var videoPlayInView = videoElement.hasAttribute('data-video-play-in-view') && videoElement.getAttribute('data-video-play-in-view').toLowerCase() === 'true';
        var videoSource = window.matchMedia('(min-width: 641px)').matches ? videoLargeSource : videoSmallSource;
        var videoMarkUp = "\n\t\t<video class=\"".concat(videoClass, "\" preload=\"metadata\" playsinline poster=\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\"").concat(videoControls ? ' controls' : ' tabindex="-1"').concat(videoMuted ? ' muted' : '').concat(videoAutoplay ? ' autoplay' : '', ">\n\t\t\t<source src=\"").concat(videoSource, "\" type=\"video/mp4\" />\n\t\t</video>\n\t\t");
        videoElement.insertAdjacentHTML('beforeend', videoMarkUp);
        var actualVideoElement = videoElement.querySelector('video');
        if (videoPlayInView) {
            context.setupPlayInView(actualVideoElement);
        }
        if (videoMuted) {
            actualVideoElement.muted = true;
        }
        if (videoLoops) {
            actualVideoElement.addEventListener('ended', function () {
                actualVideoElement.play();
            });
        }
        if (videoEventListener !== '') {
            var timeHasUpdated_1 = false;
            actualVideoElement.addEventListener('timeupdate', function () {
                if (timeHasUpdated_1)
                    return;
                var playEvent = Helpers.createCustomEventForDispatch(videoEventListener, { type: 'play' });
                document.dispatchEvent(playEvent);
                timeHasUpdated_1 = true;
            }, { once: true });
            if (!videoLoops) {
                actualVideoElement.addEventListener('ended', function () {
                    var endedEvent = Helpers.createCustomEventForDispatch(videoEventListener, { type: 'ended' });
                    document.dispatchEvent(endedEvent);
                });
            }
        }
        if (videoAutoplay) {
            actualVideoElement.play();
        }
    };
    Video.prototype.setupPlayInView = function (actualVideoElement) {
        var context = this;
        if (!context.intersectionObserverSupported) {
            actualVideoElement.play();
            return;
        }
        var observerVideo = new IntersectionObserver(function (entries) {
            Helpers.scopedLoop(entries, function (entry, i, context) {
                var video = entry.target;
                if (entry.isIntersecting) {
                    video.play();
                }
                else {
                    video.pause();
                }
            }, this);
        }, { threshold: 0.25 });
        observerVideo.observe(actualVideoElement);
    };
    return Video;
}());
var videoElements = document.querySelectorAll('[data-video]');
for (var i_1 = 0; i_1 < videoElements.length; i_1++) {
    new Video(videoElements[i_1]);
}

var Header = (function () {
    function Header() {
        var _this = this;
        this.headerElement = document.querySelector('[data-header]');
        this.navVisibleClass = 'nav-is-visible';
        this.subItemOpenClass = 'c-nav__item--open';
        this.navOpen = false;
        this.canHover = true;
        this.subItemOpen = false;
        if (!this.headerElement)
            return;
        this.toggleElement = document.querySelector('[data-header-toggle]');
        this.navElement = document.querySelector('[data-header-nav]');
        if (!this.toggleElement)
            return;
        if (!this.navElement)
            return;
        this.toggleElement.addEventListener('click', function () { _this.toggle(); });
        this.mobileDesktopTransition();
        this.subItems = document.querySelectorAll('[data-header-nav-item]');
        this.subItemButtons = document.querySelectorAll('[data-header-nav-button]');
        if (!this.subItems.length)
            return;
        if (!this.subItemButtons.length)
            return;
        this.detectHover();
        this.setupSubItems();
        this.setupSubItemButtons();
        this.additionalCloseEvents();
        this.additionalStyles();
        this.hashItems = this.navElement.querySelectorAll('a[href*="#"]');
        if (!this.hashItems.length)
            return;
        this.setupHashItems();
    }
    Header.prototype.detectHover = function () {
        var _this = this;
        window.addEventListener('touchstart', function () { _this.canHover = false; }, false);
        var debouncedMouseover = Helpers.debounce(function () { _this.canHover = true; }, 500);
        this.headerElement.addEventListener('mouseover', debouncedMouseover, false);
    };
    Header.prototype.setupHashItems = function () {
        Helpers.scopedLoop(this.hashItems, function (item, i, context) {
            item.addEventListener('click', function () {
                if (!context.isDesktopNav()) {
                    context.toggle();
                }
            });
        }, this);
    };
    Header.prototype.setupSubItems = function () {
        Helpers.scopedLoop(this.subItems, function (item, i, context) {
            var button = item.querySelector('[data-header-nav-button]');
            if (button) {
                item.addEventListener('mouseover', function () {
                    clearTimeout(context.mouseOutTimeout);
                    if (context.isDesktopNav() && context.canHover && !item.classList.contains(context.subItemOpenClass)) {
                        context.clearOtherSubNavItems(item);
                        item.classList.add(context.subItemOpenClass);
                        button.setAttribute('aria-expanded', 'true');
                        context.subItemOpen = true;
                    }
                });
                item.addEventListener('mouseout', function () {
                    if (context.isDesktopNav() && context.canHover) {
                        context.mouseOutTimeout = setTimeout(function () {
                            item.classList.remove(context.subItemOpenClass);
                            button.setAttribute('aria-expanded', 'false');
                            context.subItemOpen = false;
                        }, 300);
                    }
                });
            }
        }, this);
    };
    Header.prototype.setupSubItemButtons = function () {
        Helpers.scopedLoop(this.subItemButtons, function (button, i, context) {
            button.addEventListener('click', function (e) {
                var item = button.closest('[data-header-nav-item]');
                if (item.classList.contains(context.subItemOpenClass)) {
                    button.setAttribute('aria-expanded', 'false');
                    item.classList.remove(context.subItemOpenClass);
                    context.subItemOpen = false;
                    return;
                }
                context.clearOtherSubNavItems(item);
                if (item.classList.contains(context.subItemOpenClass)) {
                    button.setAttribute('aria-expanded', 'false');
                    item.classList.remove(context.subItemOpenClass);
                    context.subItemOpen = false;
                }
                else {
                    button.setAttribute('aria-expanded', 'true');
                    item.classList.add(context.subItemOpenClass);
                    context.subItemOpen = true;
                }
            });
        }, this);
    };
    Header.prototype.clearOtherSubNavItems = function (currentItem) {
        Helpers.scopedLoop(this.subItems, function (item, i, context) {
            if (item !== currentItem) {
                var button = item.querySelector('[data-header-nav-button]');
                if (button) {
                    button.setAttribute('aria-expanded', 'false');
                    item.classList.remove(context.subItemOpenClass);
                }
            }
        }, this);
    };
    Header.prototype.additionalCloseEvents = function () {
        var context = this;
        document.addEventListener('click', function (e) {
            var target = e.target;
            if (context.subItemOpen &&
                context.isDesktopNav() &&
                !target.closest('[data-header-nav-item="withSub"]')) {
                context.clearOtherSubNavItems();
            }
        });
    };
    Header.prototype.mobileDesktopTransition = function () {
        var _this = this;
        var debouncedMobileDesktopTransition = Helpers.debounce(function () {
            if (_this.isDesktopNav()) {
                _this.toggleElement.setAttribute('aria-expanded', 'false');
                _this.navElement.classList.remove(_this.navVisibleClass);
                _this.headerElement.classList.remove(_this.navVisibleClass);
                bodyScrollLock.enableBodyScroll(_this.navElement, { reserveScrollBarGap: true });
            }
        }, 200);
        window.addEventListener('resize', debouncedMobileDesktopTransition);
    };
    Header.prototype.toggle = function () {
        if (this.navOpen) {
            this.toggleElement.setAttribute('aria-expanded', 'false');
            this.navElement.classList.remove(this.navVisibleClass);
            this.headerElement.classList.remove(this.navVisibleClass);
            bodyScrollLock.enableBodyScroll(this.navElement, { reserveScrollBarGap: true });
        }
        else {
            this.toggleElement.setAttribute('aria-expanded', 'true');
            this.navElement.classList.add(this.navVisibleClass);
            this.headerElement.classList.add(this.navVisibleClass);
            bodyScrollLock.disableBodyScroll(this.navElement, { reserveScrollBarGap: true });
        }
        this.navOpen = !this.navOpen;
    };
    Header.prototype.isDesktopNav = function () {
        return window.matchMedia('(min-width: 1180px)').matches;
    };
    Header.prototype.additionalStyles = function () {
        var activeSecondaryItems = document.querySelectorAll('.c-nav__item__sub__link--active');
        if (!activeSecondaryItems.length)
            return;
        Helpers.scopedLoop(activeSecondaryItems, function (item, i, context) {
            var parent = item.closest('[data-header-nav-item]');
            if (parent) {
                var button = parent.querySelector('[data-header-nav-button]');
                if (button)
                    button.classList.add('c-nav__link--active');
            }
        }, this);
    };
    return Header;
}());
new Header();

var SlideToggle = (function () {
    function SlideToggle() {
        this.slideToggleElements = document.querySelectorAll('[data-slide-toggle]');
        if (!this.slideToggleElements.length)
            return;
        Helpers.scopedLoop(this.slideToggleElements, function (slideToggleElement, i, context) {
            context.setupSlideToggle(slideToggleElement);
        }, this);
    }
    SlideToggle.prototype.setupSlideToggle = function (slideToggleElement) {
        var _this = this;
        var textElement = slideToggleElement.querySelector('[data-slide-toggle-text]');
        var openText = textElement ? textElement.innerText : '';
        var closedText = slideToggleElement.getAttribute('data-slide-toggle');
        var canToggleText = openText && closedText;
        slideToggleElement.addEventListener('click', function (e) {
            var isExpanded = slideToggleElement.getAttribute('aria-expanded') === 'true';
            var shouldOpen = !isExpanded;
            var ariaControls = slideToggleElement.getAttribute('aria-controls');
            var target = document.querySelector('#' + ariaControls);
            var transitionTime = slideToggleElement.getAttribute('data-transition-time') ? parseInt(slideToggleElement.getAttribute('data-transition-time')) : 500;
            if (shouldOpen) {
                _this.open(target, slideToggleElement);
                if (canToggleText)
                    textElement.textContent = closedText;
            }
            else {
                _this.close(target, slideToggleElement);
                if (canToggleText)
                    textElement.textContent = openText;
            }
            e.preventDefault();
        });
    };
    SlideToggle.prototype.open = function (target, slideToggleElement) {
        if (!target)
            return;
        var transitionTime = slideToggleElement.getAttribute('data-transition-time') ? parseInt(slideToggleElement.getAttribute('data-transition-time')) : 500;
        var height = target.scrollHeight;
        target.style.height = height + 'px';
        target.classList.add('is-open');
        target.setAttribute('aria-hidden', 'false');
        if (target.closest('[data-slide-toggle-group]')) {
            this.closeOthersInGroup(target.closest('[data-slide-toggle-group]'), target);
        }
        setTimeout(function () { target.style.height = 'auto'; }, transitionTime);
        slideToggleElement.setAttribute('aria-expanded', 'true');
    };
    SlideToggle.prototype.close = function (target, slideToggleElement) {
        var transitionTime = slideToggleElement.getAttribute('data-transition-time') ? parseInt(slideToggleElement.getAttribute('data-transition-time')) : 500;
        var height = target.scrollHeight;
        var targetTransition = target.style.transition;
        target.style.transition = '';
        requestAnimationFrame(function () {
            target.style.height = height + 'px';
            target.style.transition = targetTransition;
            requestAnimationFrame(function () {
                target.style.height = 0 + 'px';
            });
        });
        setTimeout(function () { target.classList.remove('is-open'); target.setAttribute('aria-hidden', 'true'); }, transitionTime);
        slideToggleElement.setAttribute('aria-expanded', 'flase');
    };
    SlideToggle.prototype.closeOthersInGroup = function (groupContainer, target) {
        var elementsToClose = groupContainer.querySelectorAll("[data-slide-toggle]");
        for (var i = 0; i < elementsToClose.length; i++) {
            var currentElement = elementsToClose[i];
            var ariaControls = currentElement.getAttribute('aria-controls');
            var accordionTarget = document.querySelector('#' + ariaControls);
            if (ariaControls === target.id) {
                continue;
            }
            if (accordionTarget.getAttribute('aria-hidden') === "false") {
                this.close(accordionTarget, currentElement);
            }
        }
    };
    return SlideToggle;
}());
new SlideToggle();

var Hero = (function () {
    function Hero() {
        var _this = this;
        this.heroElement = document.querySelector('[data-hero]');
        if (!this.heroElement)
            return;
        this.setupVideo();
        if (this.heroElement.classList.contains('c-hero--text-banner')) {
            this.setTextPositionOnMobile();
            var debouncedSetTextPositionOnMobile = Helpers.debounce(function () { return _this.setTextPositionOnMobile(); }, 100);
            window.addEventListener('resize', debouncedSetTextPositionOnMobile);
        }
    }
    Hero.prototype.setupVideo = function () {
        var context = this;
        document.addEventListener('heroVideo', function (e) {
            if (e.detail.type === 'play') {
                context.heroElement.classList.add('video-is-playing');
                return;
            }
            if (e.detail.type === 'ended') {
                context.heroElement.classList.remove('video-is-playing');
                return;
            }
        });
    };
    Hero.prototype.setTextPositionOnMobile = function () {
        var heroContent = this.heroElement.querySelector('[data-hero-content]');
        if (!heroContent) {
            return;
        }
        if (window.matchMedia("(min-width: 980px)").matches) {
            this.heroElement.style.marginBottom = "0px";
            return;
        }
        this.heroElement.style.marginBottom = heroContent.scrollHeight + "px";
    };
    return Hero;
}());
new Hero();

var Logos = (function () {
    function Logos() {
        this.logoElements = document.querySelectorAll('[data-logos]');
        if (!this.logoElements.length)
            return;
        Helpers.scopedLoop(this.logoElements, function (logoElement, i, context) {
            context.setupLogos(logoElement);
        }, this);
    }
    Logos.prototype.setupLogos = function (logoElement) {
        var list = logoElement.querySelector('[data-logos-list]');
        var numberOfLogos = logoElement.querySelectorAll('.c-logos__list__image').length;
        var tnsInstance = tns({
            container: list,
            mouseDrag: true,
            controls: true,
            nav: true,
            loop: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: 30,
            controlsPosition: 'bottom',
            items: 3,
            disable: numberOfLogos <= 3,
            gutter: 0,
            slideBy: 1,
            responsive: {
                500: {
                    items: 4,
                    disable: numberOfLogos <= 4
                },
                1000: {
                    items: 6,
                    disable: numberOfLogos <= 6
                },
                1500: {
                    disable: true
                }
            }
        });
    };
    return Logos;
}());
new Logos();

var ProductsCards = (function () {
    function ProductsCards() {
        this.productCardsElements = document.querySelectorAll('[data-product-cards]');
        if (!this.productCardsElements.length)
            return;
        Helpers.scopedLoop(this.productCardsElements, function (productCardsElement, i, context) {
            context.setupProductCards(productCardsElement);
        }, this);
    }
    ProductsCards.prototype.setupProductCards = function (productCardsElement) {
        var list = productCardsElement.querySelector('[data-product-cards-list]');
        var items = list.querySelectorAll('[data-product-cards-list-item]');
        for (var i_1 = 0, len = items.length; i_1 < len; i_1++) {
            items[i_1].setAttribute('data-mparticle-tracking-position', (i_1 + 1).toString());
        }
        var tnsInstance = tns({
            container: list,
            mouseDrag: true,
            controls: true,
            nav: true,
            loop: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: 30,
            controlsPosition: 'bottom',
            items: 1,
            gutter: 0,
            slideBy: 1,
            responsive: {
                700: {
                    items: 2
                },
                1180: {
                    disable: true
                }
            }
        });
    };
    return ProductsCards;
}());
new ProductsCards();

var FeatureCards = (function () {
    function FeatureCards() {
        this.featureCardsElements = document.querySelectorAll("[data-feature-cards]");
        if (!this.featureCardsElements.length)
            return;
        Helpers.scopedLoop(this.featureCardsElements, function (featureCardsElement, i, context) {
            context.setupFeatureCards(featureCardsElement);
        }, this);
    }
    FeatureCards.prototype.setupFeatureCards = function (featureCardsElement) {
        var list = featureCardsElement.querySelector("[data-feature-cards-list]");
        var items = list.querySelectorAll("[data-feature-cards-list-item]");
        for (var i_1 = 0, len = items.length; i_1 < len; i_1++) {
            items[i_1].setAttribute("data-mparticle-tracking-position", (i_1 + 1).toString());
        }
    };
    return FeatureCards;
}());
new FeatureCards();

var CrossFadeImage = (function () {
    function CrossFadeImage(container) {
        this.container = container;
        this.outputContainer = container.querySelector('[data-cross-fade-image-output]');
        this.triggerElements = container.querySelectorAll('[data-cross-fade-image]');
        this.currentImage = this.triggerElements[0].getAttribute('data-cross-fade-image');
        this.oldImage = this.triggerElements[0].getAttribute('data-cross-fade-image');
        this.renderImages();
        this.attachClickEvents();
    }
    CrossFadeImage.prototype.renderImages = function () {
        var _this = this;
        this.outputContainer.innerHTML = "";
        this.outputContainer.innerHTML = "\n            <picture class=\"c-cross-fade__picture c-cross-fade__picture--current\">\n                ".concat(this.renderImageSources(this.currentImage), "\n            </picture>\n            <picture class=\"c-cross-fade__picture c-cross-fade__picture--old\" style=\"opacity: 0.99\">\n                ").concat(this.renderImageSources(this.oldImage), "\n            </picture>\n        ");
        setTimeout(function () {
            var oldPicture = _this.outputContainer.querySelector('.c-cross-fade__picture--old');
            oldPicture.style.opacity = "0";
        }, 20);
    };
    CrossFadeImage.prototype.renderImageSources = function (imageURL) {
        return "\n            <source media=\"(min-width:1400px)\" srcset=\"".concat(imageURL, "?width=850&amp;height=850&amp;quality=80\" type=\"image/webp\">\n            <source media=\"(min-width:1400px)\" srcset=\"").concat(imageURL, "?width=850&amp;height=850&amp;quality=80\">\n            <source media=\"(min-width:980px)\" srcset=\"").concat(imageURL, "?width=980&amp;height=980&amp;quality=80\" type=\"image/webp\">\n            <source media=\"(min-width:980px)\" srcset=\"").concat(imageURL, "?width=980&amp;height=980&amp;quality=80\">\n            <source media=\"(min-width:601px)\" srcset=\"").concat(imageURL, "?width=601&amp;height=601&amp;quality=80\" type=\"image/webp\">\n            <source media=\"(min-width:601px)\" srcset=\"").concat(imageURL, "?width=601&amp;height=601&amp;quality=80\">\n            <source media=\"(min-width:0px)\" srcset=\"").concat(imageURL, "?width=390&amp;height=390&amp;quality=80\" type=\"image/webp\">\n            <img src=\"").concat(imageURL, "?height=390&amp;width=390&amp;mode=crop&amp;quality=80\" alt=\"\" class=\"c-cross-fade__image\" loading=\"lazy\" width=\"390\" height=\"390\">\n        ");
    };
    CrossFadeImage.prototype.attachClickEvents = function () {
        Helpers.scopedLoop(this.triggerElements, function (triggerElement, i, context) {
            triggerElement.addEventListener('click', function () {
                var newImage = triggerElement.getAttribute('data-cross-fade-image');
                if (newImage !== context.currentImage) {
                    context.oldImage = context.currentImage;
                    context.currentImage = triggerElement.getAttribute('data-cross-fade-image');
                    context.renderImages();
                }
            });
        }, this);
    };
    return CrossFadeImage;
}());
var crossFadeGroups = document.querySelectorAll('[data-cross-fade-image-group]');
for (var i = 0; i < crossFadeGroups.length; i++) {
    new CrossFadeImage(crossFadeGroups[i]);
}

var KeyFacts = (function () {
    function KeyFacts() {
        this.keyFactsElements = document.querySelectorAll('[data-key-facts]');
        this.autoplayClass = 'c-key-facts--autoplay';
        this.interactedClass = 'c-key-facts--interacted';
        if (!this.keyFactsElements.length)
            return;
        Helpers.scopedLoop(this.keyFactsElements, function (keyFactsElement, i, context) {
            context.setupKeyFacts(keyFactsElement);
        }, this);
    }
    KeyFacts.prototype.setupKeyFacts = function (keyFactsElement) {
        var context = this;
        var slideCount = parseInt(keyFactsElement.getAttribute('data-key-facts'));
        if (slideCount <= 1)
            return;
        var list = keyFactsElement.querySelector('[data-key-facts-list]');
        var tnsInstance = tns({
            container: list,
            mouseDrag: true,
            controls: true,
            nav: true,
            loop: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: 30,
            controlsPosition: 'bottom',
            items: 1,
            gutter: 0,
            slideBy: 1,
            mode: 'gallery',
            autoplay: true,
            autoplayTimeout: 7500
        });
        tnsInstance.pause();
        var navButtons = keyFactsElement.querySelectorAll('.tns-nav button');
        tnsInstance.events.on('indexChanged', function () { context.handleIndexChanged(navButtons); });
        context.setHeight(tnsInstance);
        window.addEventListener('resize', Helpers.debounce(function () { context.setHeight(tnsInstance); }, 500));
        context.populatePagination(keyFactsElement, tnsInstance);
        context.populateNavigation(keyFactsElement);
        context.playIfInViewport(keyFactsElement, tnsInstance);
        context.pauseIfInteracted(keyFactsElement, tnsInstance);
    };
    KeyFacts.prototype.handleIndexChanged = function (navButtons) {
        Helpers.scopedLoop(navButtons, function (button, i, context) { button.removeAttribute('tabindex'); }, this);
    };
    KeyFacts.prototype.setHeight = function (tnsInstance) {
        var info = tnsInstance.getInfo();
        var maxHeight = 0;
        Helpers.scopedLoop(info.slideItems, function (slideItem, i, context) {
            slideItem.style.height = 'auto';
            if (slideItem.offsetHeight > maxHeight)
                maxHeight = slideItem.offsetHeight;
        }, this);
        info.container.style.height = maxHeight + 'px';
        Helpers.scopedLoop(info.slideItems, function (slideItem, i, context) { slideItem.style.height = maxHeight + 'px'; }, this);
    };
    KeyFacts.prototype.playIfInViewport = function (keyFactsElement, tnsInstance) {
        var context = this;
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries, self) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        observer.unobserve(keyFactsElement);
                        keyFactsElement.classList.add(context.autoplayClass);
                        tnsInstance.play();
                    }
                });
            }, {
                rootMargin: '0px 0px -50%'
            });
            observer.observe(keyFactsElement);
        }
        else {
            keyFactsElement.classList.add(context.autoplayClass);
            tnsInstance.play();
        }
    };
    KeyFacts.prototype.pauseIfInteracted = function (keyFactsElement, tnsInstance) {
        var context = this;
        tnsInstance.events.on('touchStart', function () {
            keyFactsElement.classList.add(context.interactedClass);
            tnsInstance.stop();
        });
        tnsInstance.events.on('dragStart', function () {
            keyFactsElement.classList.add(context.interactedClass);
            tnsInstance.stop();
        });
        keyFactsElement.addEventListener('click', function () {
            keyFactsElement.classList.add(context.interactedClass);
            tnsInstance.stop();
        });
    };
    KeyFacts.prototype.populatePagination = function (keyFactsElement, tnsInstance) {
        var buttons = keyFactsElement.querySelectorAll('.tns-nav button');
        var slides = tnsInstance.getInfo().slideItems;
        Helpers.scopedLoop(buttons, function (button, i, context) {
            var valueElement = slides[i].querySelector('[data-key-facts-value]');
            var suffixElement = slides[i].querySelector('[data-key-facts-suffix]');
            var innerHtml = '';
            if (valueElement)
                innerHtml += "<span class=\"c-key-facts__pagination-button__value\">".concat(valueElement.innerHTML, "</span>");
            if (suffixElement)
                innerHtml += "<span class=\"c-key-facts__pagination-button__suffix\">".concat(suffixElement.innerHTML, "</span>");
            button.classList.add('c-key-facts__pagination-button');
            button.innerHTML = innerHtml;
            button.removeAttribute('tabindex');
        }, this);
    };
    KeyFacts.prototype.populateNavigation = function (keyFactsElement) {
        var svg = "\n      <svg viewBox=\"0 0 15.972 15.972\">\n        <path d=\"m7.986 1.415 6.572 6.571-6.572 6.572\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" />\n      </svg>\n    ";
        var controlsElement = keyFactsElement.querySelector('.tns-controls');
        var prevElement = keyFactsElement.querySelector('[data-controls="prev"]');
        var nextElement = keyFactsElement.querySelector('[data-controls="next"]');
        if (controlsElement)
            controlsElement.removeAttribute('tabindex');
        if (prevElement) {
            prevElement.classList.add('c-key-facts__navigation-button');
            prevElement.classList.add('c-key-facts__navigation-button--prev');
            prevElement.innerHTML = "<span class=\"u-visuallyhidden\">Navigate to previous slide</span>".concat(svg);
        }
        if (nextElement) {
            nextElement.classList.add('c-key-facts__navigation-button');
            nextElement.classList.add('c-key-facts__navigation-button--next');
            nextElement.innerHTML = "<span class=\"u-visuallyhidden\">Navigate to next slide</span>".concat(svg);
        }
    };
    return KeyFacts;
}());
new KeyFacts();

var GridGallery = (function () {
    function GridGallery(gridGalleryElement) {
        this.bodyElement = document.getElementsByTagName('body')[0];
        if (!gridGalleryElement)
            return;
        this.setupGridGallery(gridGalleryElement);
    }
    GridGallery.prototype.setupGridGallery = function (gridGalleryElement) {
        var context = this;
        var gridGalleryItems = gridGalleryElement.querySelectorAll('[data-grid-gallery-item]');
        var htmlElement = gridGalleryElement.querySelector('[data-grid-gallery-html]');
        if (!gridGalleryItems || !htmlElement)
            return;
        var html = htmlElement.innerHTML;
        var name = gridGalleryElement.getAttribute('data-grid-gallery');
        Helpers.scopedLoop(gridGalleryItems, function (gridGalleryItem, i, context) {
            gridGalleryItem.addEventListener('click', function () {
                context.handleGridGalleryItemClick(gridGalleryItem, html, name);
            });
        }, this);
    };
    GridGallery.prototype.handleGridGalleryItemClick = function (gridGalleryItem, html, name) {
        var context = this;
        var itemIndex = parseInt(gridGalleryItem.getAttribute('data-grid-gallery-item')) - 1;
        context.bodyElement.insertAdjacentHTML('beforeend', html);
        var modal = document.querySelector('[data-modal="' + name + '"]');
        if (!modal)
            return;
        var videoElements = modal.querySelectorAll('[data-video]');
        Helpers.scopedLoop(videoElements, function (videoElement, i, context) {
            new Video(videoElement);
        }, this);
        var slideshowElement = modal.querySelector('[data-slideshow]');
        if (slideshowElement) {
            slideshowElement.setAttribute('data-slidehow-start-index', itemIndex.toString());
            new Slideshow(slideshowElement);
        }
        modal.classList.add('c-modal--show');
        var trap = focusTrap.createFocusTrap(modal);
        trap.activate();
        var close = modal.querySelector('[data-modal-close]');
        if (close) {
            close.addEventListener('click', function () {
                trap.deactivate();
                Helpers.removeElement(modal);
                modal = null;
            });
        }
        document.addEventListener('keyup', function (e) {
            var key = Helpers.getKeypressed(e);
            if (key === 'Escape' || key === 'Esc' || key === 27) {
                if (!modal)
                    return;
                trap.deactivate();
                Helpers.removeElement(modal);
                modal = null;
            }
        });
    };
    return GridGallery;
}());
var gridGalleryElements = document.querySelectorAll('[data-grid-gallery]');
for (var i_1 = 0; i_1 < gridGalleryElements.length; i_1++) {
    new GridGallery(gridGalleryElements[i_1]);
}

var Slideshow = (function () {
    function Slideshow(slideshowElement) {
        if (!slideshowElement)
            return;
        this.prevButtonSprite = slideshowElement.getAttribute('data-next-button-sprite') || '';
        this.nextButtonSprite = slideshowElement.getAttribute('data-previous-button-sprite') || '';
        this.prevButtonImage = slideshowElement.getAttribute('data-next-button-image') || '';
        this.nextButtonImage = slideshowElement.getAttribute('data-previous-button-image') || '';
        this.loop = slideshowElement.hasAttribute('data-slideshow-loop');
        this.autoplay = document.getElementsByTagName('html')[0].classList.contains('prefers-reduce-motion') ? false : slideshowElement.hasAttribute('data-slideshow-autoplay');
        this.setup(slideshowElement);
    }
    Slideshow.prototype.generateButtonMarkup = function (text, css, icon, image) {
        if (icon === '' && image === '') {
            console.error('Missing button image/icon');
        }
        if (icon === '') {
            return "\n\t\t\t\t<span class=\"u-visuallyhidden\">".concat(text, "</span>\n\t\t\t\t<img src=\"").concat(image, "\" alt=\"\" class=\"c-slideshow__control-icon c-slideshow__control-icon--").concat(css, "\" />\n\t\t\t");
        }
        return "\n\t\t\t<span class=\"u-visuallyhidden\">".concat(text, "</span>\n\t\t\t<svg class=\"c-slideshow__control-icon c-slideshow__control-icon--").concat(css, "\">\n\t\t\t\t<use xlink:href=\"").concat(icon, "\"></use>\n\t\t\t</svg>\n    ");
    };
    Slideshow.prototype.setup = function (slideshowElement) {
        var context = this;
        var list = slideshowElement.querySelector('[data-slideshow-list]');
        var startIndex = slideshowElement.hasAttribute('data-slidehow-start-index') ? parseInt(slideshowElement.getAttribute('data-slidehow-start-index')) : 0;
        var tnsInstance = tns({
            container: list,
            mouseDrag: true,
            controls: true,
            nav: true,
            loop: this.loop,
            autoplay: this.autoplay,
            autoplayButtonOutput: false,
            preventScrollOnTouch: 'auto',
            swipeAngle: 30,
            controlsPosition: 'top',
            items: 1,
            slideBy: 1,
            startIndex: startIndex,
            controlsText: [context.generateButtonMarkup('Previous slide', 'prev', context.prevButtonSprite, context.prevButtonImage), context.generateButtonMarkup('Next slide', 'next', context.nextButtonSprite, context.nextButtonImage)],
            navPosition: 'bottom'
        });
        context.adjustAccessibilityAttributes(slideshowElement);
        tnsInstance.events.on('transitionEnd', function () { context.adjustAccessibilityAttributes(slideshowElement); });
        slideshowElement.addEventListener('click', function () {
            tnsInstance.stop();
        });
        var videoElements = slideshowElement.querySelectorAll('[data-video]');
        if (!videoElements.length)
            return;
        tnsInstance.events.on('indexChanged', function () {
            context.controlVideos(videoElements, tnsInstance);
            context.loadImages(tnsInstance);
            context.moveFocus(tnsInstance);
        });
        context.controlVideos(videoElements, tnsInstance);
        context.loadImages(tnsInstance);
    };
    Slideshow.prototype.adjustAccessibilityAttributes = function (slideshowElement) {
        var controlsElement = slideshowElement.querySelector('.tns-controls');
        if (controlsElement)
            controlsElement.removeAttribute('tabindex');
        var navElementButtons = slideshowElement.querySelectorAll('.tns-nav button');
        if (!navElementButtons.length)
            return;
        Helpers.scopedLoop(navElementButtons, function (buttonElement, i, context) {
            buttonElement.removeAttribute('tabindex');
        }, this);
    };
    Slideshow.prototype.controlVideos = function (videoElements, tnsInstance) {
        Helpers.scopedLoop(videoElements, function (videoElement, i, context) {
            var actualVideoElement = videoElement.querySelector('video');
            actualVideoElement.pause();
            actualVideoElement.controls = false;
        }, this);
        var slideshowInfo = tnsInstance.getInfo();
        var currentVideoElement = slideshowInfo.slideItems[slideshowInfo.index].querySelector('[data-video]');
        if (!currentVideoElement)
            return;
        var actualCurrentVideoElement = currentVideoElement.querySelector('video');
        if (!actualCurrentVideoElement)
            return;
        var videoControls = currentVideoElement.hasAttribute('data-video-controls') && currentVideoElement.getAttribute('data-video-controls').toLowerCase() === 'true';
        if (videoControls)
            actualCurrentVideoElement.controls = true;
        actualCurrentVideoElement.play();
    };
    Slideshow.prototype.loadImages = function (tnsInstance) {
        var slideshowInfo = tnsInstance.getInfo();
        var currentIndex = slideshowInfo.index;
        var prevIndex = currentIndex - 1;
        var nextIndex = currentIndex + 1;
        var slideItemsIndex = slideshowInfo.slideCount - 1;
        if (prevIndex >= 0) {
            var prevImage = slideshowInfo.slideItems[prevIndex].querySelector('img');
            if (prevImage)
                prevImage.setAttribute('loading', 'eager');
        }
        if (nextIndex <= slideItemsIndex) {
            var nextImage = slideshowInfo.slideItems[nextIndex].querySelector('img');
            if (nextImage)
                nextImage.setAttribute('loading', 'eager');
        }
    };
    Slideshow.prototype.moveFocus = function (tnsInstance) {
        var slideshowInfo = tnsInstance.getInfo();
        var currentIndex = slideshowInfo.index;
        var slideItemsIndex = slideshowInfo.slideCount - 1;
        if (currentIndex === 0) {
            var next = slideshowInfo.controlsContainer.querySelector('[data-controls="next"]');
            if (next)
                next.focus();
        }
        if (currentIndex === slideItemsIndex) {
            var prev = slideshowInfo.controlsContainer.querySelector('[data-controls="prev"]');
            if (prev)
                prev.focus();
        }
    };
    return Slideshow;
}());
var slideshowElements = document.querySelectorAll('[data-slideshow]');
for (var i_1 = 0; i_1 < slideshowElements.length; i_1++) {
    new Slideshow(slideshowElements[i_1]);
}

var ProductsCardsExpanded = (function () {
    function ProductsCardsExpanded() {
        this.productCardsElementAttribute = "data-product-cards-expanded";
        this.productCardsElements = document.querySelectorAll("[" + this.productCardsElementAttribute + "]");
        if (!this.productCardsElements.length)
            return;
        Helpers.scopedLoop(this.productCardsElements, function (productCardsElement, i, context) {
            context.setupProductCards(productCardsElement);
        }, this);
    }
    ProductsCardsExpanded.prototype.generateButtonMarkup = function (text, css, src) {
        if (src === "") {
            console.error("Missing button image/icon");
        }
        return "\n\t\t\t\t<span class=\"u-visuallyhidden\">".concat(text, "</span>\n\t\t\t\t<img src=\"").concat(src, "\" alt=\"\" class=\"c-slideshow__control-icon c-slideshow__control-icon--").concat(css, "\" />\n\t\t\t");
    };
    ProductsCardsExpanded.prototype.setupProductCards = function (productCardsElement) {
        var context = this;
        var list = productCardsElement.querySelector('[data-product-cards-expanded-list]');
        var items = list.querySelectorAll('[data-product-cards-expanded-list-item]');
        for (var i_1 = 0, len = items.length; i_1 < len; i_1++) {
            items[i_1].setAttribute('data-mparticle-tracking-position', (i_1 + 1).toString());
        }
        var responsive = {
            700: {
                items: 2
            },
            768: {
                disable: true
            }
        };
        var settings = JSON.parse(productCardsElement.getAttribute(context.productCardsElementAttribute));
        if (settings['tabletCarousel'] !== null &&
            settings['tabletCarousel'].toLowerCase() === 'true') {
            delete responsive['768']['disable'];
            responsive['768']['items'] = 2;
            responsive['1180'] = {
                items: 3
            };
        }
        var tnsInstance = tns({
            container: list,
            mouseDrag: true,
            controls: true,
            nav: false,
            loop: true,
            preventScrollOnTouch: "auto",
            swipeAngle: 30,
            controlsPosition: "bottom",
            items: 1,
            gutter: 0,
            slideBy: 1,
            autoplay: false,
            responsive: responsive,
            controlsText: [
                context.generateButtonMarkup("Previous slide", "prev", "/frontend/img/icon-triple-chevron-right-alt-2.svg"),
                context.generateButtonMarkup("Next slide", "next", "/frontend/img/icon-triple-chevron-right-alt-2.svg"),
            ]
        });
    };
    return ProductsCardsExpanded;
}());
new ProductsCardsExpanded();

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Tracking = (function () {
    function Tracking(element) {
        this.element = element;
        var mode = this.element.getAttribute('data-mparticle-tracking');
        if (mode === 'collection') {
            this.trackCollection();
            return;
        }
        if (mode === 'click') {
            this.trackClick();
        }
    }
    Tracking.prototype.trackCollection = function () {
        var eventName = this.element.getAttribute('data-mparticle-tracking-event');
        var collectionName = this.element.getAttribute('data-mparticle-collection-name');
        var collectionItems = this.element.querySelectorAll('[data-mparticle-tracking-item]');
        if (!collectionItems.length)
            return;
        var collectionData = [];
        var addedPositions = [];
        Helpers.scopedLoop(collectionItems, function (collectionItem, i, context) {
            var itemData = collectionItem.getAttribute('data-mparticle-tracking-item');
            if (itemData) {
                var parsedItemData = JSON.parse(itemData);
                var position = collectionItem.getAttribute('data-mparticle-tracking-position');
                if (addedPositions.indexOf(position) === -1) {
                    parsedItemData.position = position;
                    collectionData.push(parsedItemData);
                    addedPositions.push(position);
                }
            }
        }, this);
        var hasAdditionalData = this.element.hasAttribute('data-mparticle-collection-data');
        var data = hasAdditionalData ? JSON.parse(this.element.getAttribute('data-mparticle-collection-data')) : {};
        data.event = eventName;
        data[collectionName] = collectionData;
        if (!data[collectionName].length)
            return;
        this.sendToDataLayer(data);
    };
    Tracking.prototype.trackClick = function () {
        var _this = this;
        var eventName = this.element.getAttribute('data-mparticle-tracking-event');
        var rawData = this.element.getAttribute('data-mparticle-tracking-data');
        if (!rawData)
            return;
        var data = JSON.parse(rawData);
        data.event = eventName;
        var parentCollection = this.element.closest('[data-mparticle-tracking="collection"]');
        if (parentCollection) {
            var hasAdditionalParentData = parentCollection.hasAttribute('data-mparticle-collection-data');
            if (hasAdditionalParentData) {
                var additionalParentData = JSON.parse(parentCollection.getAttribute('data-mparticle-collection-data'));
                data = __assign(__assign({}, data), additionalParentData);
            }
        }
        var allowClickTracking = true;
        this.element.addEventListener('click', function () {
            if (allowClickTracking) {
                allowClickTracking = false;
                _this.sendToDataLayer(data);
                setTimeout(function () { allowClickTracking = true; }, 250);
            }
        });
        this.element.addEventListener('auxclick', function (e) {
            if (e.button && e.button == 1) {
                if (allowClickTracking) {
                    allowClickTracking = false;
                    _this.sendToDataLayer(data);
                    setTimeout(function () { allowClickTracking = true; }, 250);
                }
            }
        });
    };
    Tracking.prototype.sendToDataLayer = function (data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    };
    return Tracking;
}());
var mparticleTrackingItems = document.querySelectorAll('[data-mparticle-tracking]');
for (var i = 0; i < mparticleTrackingItems.length; i++) {
    new Tracking(mparticleTrackingItems[i]);
}

var Table = (function () {
    function Table() {
        this.tableElements = document.querySelectorAll('.c-cms table');
        if (!this.tableElements.length)
            return;
        Helpers.scopedLoop(this.tableElements, function (tableElement, i, context) {
            var wrapper = document.createElement('div');
            wrapper.setAttribute('class', 'c-cms__responsive-table');
            Helpers.wrapElement(tableElement, wrapper);
        }, this);
    }
    return Table;
}());
new Table();

var Carousel = (function () {
    function Carousel(carouselElement) {
        this.userPrefersReducedMotion = document.getElementsByTagName('html')[0].classList.contains('prefers-reduce-motion');
        this.itemSelector = 'data-carousel-item';
        this.chevronSVG = "\n\t\t<svg viewBox=\"0 0 15.972 15.972\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n      <path d=\"m7.986 1.415 6.572 6.571-6.572 6.572\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" />\n    </svg>\n\t";
        if (!carouselElement)
            return;
        this.setupCarousel(carouselElement);
    }
    Carousel.prototype.setupCarousel = function (carouselElement) {
        var context = this;
        var carouselItems = carouselElement.querySelectorAll('[' + context.itemSelector + ']');
        if (carouselItems.length <= 1)
            return;
        context.ammendCarouselItemHTML(carouselItems);
        var tnsInstance = tns({
            container: carouselElement,
            mouseDrag: true,
            controls: true,
            nav: false,
            loop: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: 30,
            controlsPosition: 'top',
            items: 1,
            gutter: 0,
            slideBy: 1,
            autoplay: !context.userPrefersReducedMotion,
            controlsText: [
                "<span class=\"u-visuallyhidden\">Previous slide</span>".concat(context.chevronSVG),
                "<span class=\"u-visuallyhidden\">Next slide</span>".concat(context.chevronSVG)
            ],
            autoplayText: [
                '',
                ''
            ]
        });
        context.ammendCarouselHTML(tnsInstance);
        context.controlFocusableElements(carouselElement);
        tnsInstance.events.on('indexChanged', function () { context.controlFocusableElements(carouselElement); });
        context.additionalEvents(tnsInstance);
    };
    Carousel.prototype.ammendCarouselHTML = function (tnsInstance) {
        var info = tnsInstance.getInfo();
        info.controlsContainer.removeAttribute('tabindex');
    };
    Carousel.prototype.additionalEvents = function (tnsInstance) {
        var info = tnsInstance.getInfo();
        var controlButtons = info.controlsContainer.querySelectorAll('button');
        var controlButtonTimeout;
        var usingKeyboard = false;
        Helpers.scopedLoop(controlButtons, function (controlButton, i, context) {
            controlButton.addEventListener('keydown', function (e) {
                usingKeyboard = e.code === 'Enter';
            });
            controlButton.addEventListener('click', function (e) {
                tnsInstance.stop();
                clearTimeout(controlButtonTimeout);
                if (usingKeyboard) {
                    controlButtonTimeout = setTimeout(function () {
                        var activeItem = info.container.querySelector('.tns-slide-active');
                        var focusableElements = activeItem.querySelectorAll('a,button');
                        if (focusableElements.length) {
                            focusableElements[0].focus();
                        }
                    }, 250);
                }
                usingKeyboard = false;
            });
        }, this);
        tnsInstance.events.on('touchStart', function () { tnsInstance.stop(); });
        tnsInstance.events.on('dragStart', function () { tnsInstance.stop(); });
    };
    Carousel.prototype.controlFocusableElements = function (carouselElement) {
        var context = this;
        var carouselItems = carouselElement.querySelectorAll('[' + context.itemSelector + ']');
        Helpers.scopedLoop(carouselItems, function (carouselItem, i, context) {
            var isActive = carouselItem.classList.contains('tns-slide-active');
            var focusableElements = carouselItem.querySelectorAll('a,button');
            if (focusableElements.length) {
                Helpers.scopedLoop(focusableElements, function (focusableElement, i, context) {
                    if (isActive) {
                        focusableElement.removeAttribute('tabindex');
                    }
                    else {
                        focusableElement.setAttribute('tabindex', '-1');
                    }
                }, this);
            }
        }, this);
    };
    Carousel.prototype.ammendCarouselItemHTML = function (carouselItems) {
        var context = this;
        Helpers.scopedLoop(carouselItems, function (carouselItem, i, context) {
            carouselItem.setAttribute(context.itemSelector, i.toString());
        }, this);
    };
    return Carousel;
}());
var carouselElements = document.querySelectorAll('[data-carousel]');
for (var i_1 = 0; i_1 < carouselElements.length; i_1++) {
    new Carousel(carouselElements[i_1]);
}

var Form = (function () {
    function Form() {
        this.formElements = document.querySelectorAll('[data-form="validate"]');
        if (!this.formElements.length || typeof aspnetValidation === 'undefined')
            return;
        this.aspnetValidationInstance = new aspnetValidation.ValidationService();
        this.aspnetValidationInstance.bootstrap();
        this.addAdditionalValidationRules();
        this.radioInputCheck();
        Helpers.scopedLoop(this.formElements, function (formElement, i, context) {
            formElement.addEventListener('validation', function (e) {
                context.handleFormValidation(e, formElement);
            });
        }, this);
    }
    Form.prototype.handleFormValidation = function (e, formElement) {
        var isValid = this.aspnetValidationInstance.isValid(formElement, false);
        if (!isValid)
            this.scrollToFirstError(formElement);
    };
    Form.prototype.scrollToFirstError = function (formElement) {
        var errors = formElement.querySelectorAll('.input-validation-error');
        if (!errors.length)
            return;
        var scrollBehaviour = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        Helpers.scrollToElement(errors[0], scrollBehaviour, 0, 15);
    };
    Form.prototype.addAdditionalValidationRules = function () {
        this.aspnetValidationInstance.addProvider('futuredate', function (value, element, params) {
            if (!value)
                return true;
            var parsedDate = Date.parse(value);
            return parsedDate > Date.now();
        });
        this.aspnetValidationInstance.addProvider('radiocheck', function (value, element, params) {
            var radioGroupName = element.getAttribute('name');
            if (!radioGroupName)
                return true;
            var checkedRadio = document.querySelector("input[name=\"".concat(radioGroupName, "\"]:checked"));
            var otherChecked = checkedRadio && checkedRadio.value === 'other';
            if (!otherChecked)
                return true;
            var textInputId = checkedRadio.getAttribute('data-radio-other');
            var textInput = document.querySelector("[data-radio-other-input=\"".concat(textInputId, "\"]"));
            if (otherChecked && textInput && textInput.value.trim() === '') {
                return "Please enter how you heard of us.";
            }
            return true;
        });
    };
    Form.prototype.radioInputCheck = function () {
        var radioOthers = document.querySelectorAll('[data-radio-other]');
        radioOthers.forEach(function (radioOther) {
            var textInputId = radioOther.getAttribute('data-radio-other');
            var textInput = document.querySelector("[data-radio-other-input=\"".concat(textInputId, "\"]"));
            var radioGroupName = radioOther.getAttribute('name');
            if (textInput && radioGroupName) {
                var radioGroup_1 = document.querySelectorAll("input[name=\"".concat(radioGroupName, "\"]"));
                var otherTextInputValue_1 = "";
                var updateInputValue_1 = function () {
                    if (!textInput)
                        return;
                    var selectedRadio = Array.prototype.slice.call(radioGroup_1).find(function (radio) { return radio.checked; });
                    if (selectedRadio) {
                        if (selectedRadio.value === 'other' && textInput) {
                            textInput.value = textInput.value;
                        }
                        else {
                            textInput.value = selectedRadio.value;
                        }
                    }
                };
                var toggleTextInput_1 = function () {
                    var radioArray = Array.prototype.slice.call(radioGroup_1);
                    var isOtherChecked = radioArray.some(function (radio) { return radio.checked && radio === radioOther; });
                    if (isOtherChecked) {
                        textInput.value = otherTextInputValue_1;
                        textInput.type = 'text';
                    }
                    else {
                        textInput.type = 'hidden';
                    }
                    updateInputValue_1();
                };
                textInput.addEventListener('input', function () {
                    otherTextInputValue_1 = textInput.value;
                });
                var radioArray = Array.prototype.slice.call(radioGroup_1);
                radioArray.forEach(function (radio) {
                    radio.addEventListener('change', function () {
                        toggleTextInput_1();
                    });
                });
                toggleTextInput_1();
            }
        });
    };
    return Form;
}());
new Form();

var FeatureCardCarousel = (function () {
    function FeatureCardCarousel(slideshowElement) {
        if (!slideshowElement)
            return;
        this.buttonSrc = slideshowElement.getAttribute('data-button-src') || '';
        this.isSprite = slideshowElement.getAttribute('data-button-is-sprite') === 'true';
        this.setup(slideshowElement);
    }
    FeatureCardCarousel.prototype.generateButtonMarkup = function (text, css, src, isSprite) {
        if (src === '') {
            console.error('Missing button image/icon');
        }
        if (!isSprite) {
            return "\n\t\t\t\t<span class=\"u-visuallyhidden\">".concat(text, "</span>\n\t\t\t\t<img src=\"").concat(src, "\" alt=\"\" class=\"c-slideshow__control-icon c-slideshow__control-icon--").concat(css, "\" />\n\t\t\t");
        }
        return "\n\t\t\t<span class=\"u-visuallyhidden\">".concat(text, "</span>\n\t\t\t<svg class=\"c-slideshow__control-icon c-slideshow__control-icon--").concat(css, "\">\n\t\t\t\t<use xlink:href=\"").concat(src, "\"></use>\n\t\t\t</svg>\n    ");
    };
    FeatureCardCarousel.prototype.setup = function (slideshowElement) {
        var context = this;
        var list = slideshowElement.querySelector('[data-feature-carousel-list]');
        var numberOfCards = list.querySelectorAll('.c-feature-card').length;
        var tnsInstance = tns({
            container: list,
            mouseDrag: true,
            controls: true,
            nav: false,
            loop: true,
            autoplay: false,
            autoplayButtonOutput: false,
            preventScrollOnTouch: 'auto',
            swipeAngle: 30,
            controlsPosition: 'top',
            items: 1.2,
            slideBy: 1,
            controlsText: [context.generateButtonMarkup('Previous slide', 'prev', context.buttonSrc, context.isSprite), context.generateButtonMarkup('Next slide', 'next', context.buttonSrc, context.isSprite)],
            disabled: numberOfCards === 1,
            responsive: {
                700: {
                    items: 2.2,
                    disable: numberOfCards <= 2
                },
                1000: {
                    items: 3,
                    disable: numberOfCards <= 3
                }
            }
        });
        context.adjustAccessibilityAttributes(slideshowElement);
        tnsInstance.events.on('transitionEnd', function () { context.adjustAccessibilityAttributes(slideshowElement); });
        slideshowElement.addEventListener('click', function () {
            tnsInstance.stop();
        });
        slideshowElement.addEventListener('touchstart', function () {
            tnsInstance.stop();
        });
        slideshowElement.addEventListener('mousedown', function () {
            tnsInstance.stop();
        });
    };
    FeatureCardCarousel.prototype.adjustAccessibilityAttributes = function (slideshowElement) {
        var controlsElement = slideshowElement.querySelector('.tns-controls');
        if (controlsElement)
            controlsElement.removeAttribute('tabindex');
        var navElementButtons = slideshowElement.querySelectorAll('.tns-nav button');
        if (!navElementButtons.length)
            return;
        Helpers.scopedLoop(navElementButtons, function (buttonElement, i, context) {
            buttonElement.removeAttribute('tabindex');
        }, this);
    };
    return FeatureCardCarousel;
}());
var featureCarousels = document.querySelectorAll('[data-feature-carousel]');
for (var i_1 = 0; i_1 < featureCarousels.length; i_1++) {
    new FeatureCardCarousel(featureCarousels[i_1]);
}

var FeatureCardsFilter = (function () {
    function FeatureCardsFilter() {
        this.defaultCardsToShow = 15;
        this.section = document.querySelector('.c-feature-cards--filtered');
        if (!this.section) {
            return;
        }
        this.eventTypeSelect = this.section.querySelector('#eventType');
        this.monthFilterElements = this.section.querySelectorAll('.c-multi-select');
        this.cards = this.section.querySelectorAll('.c-feature-card');
        this.clearFiltersButton = this.section.querySelector('#clearFilters');
        this.showMoreButton = this.section.querySelector('.c-feature-cards-show-more-button');
        this.filtersToggleButton = this.section.querySelector('#filtersToggle');
        this.filtersPrimary = this.section.querySelector('#filtersPrimary');
        this.filtersToggleText = this.section.querySelector('#filtersToggleText');
        this.noResultsElement = this.section.querySelector('.c-feature-cards-no-results');
        this.filteredCards = [];
        this.cardsToShow = this.defaultCardsToShow;
        this.increment = 3;
        this.setupEventListeners();
        this.filterCards();
        this.updateClearFiltersButton();
    }
    FeatureCardsFilter.prototype.setupEventListeners = function () {
        var _this = this;
        var _a;
        if (this.filtersToggleButton) {
            this.filtersToggleButton.addEventListener('click', function () {
                _this.toggleFilters();
            });
        }
        if (this.clearFiltersButton) {
            this.clearFiltersButton.addEventListener('click', function () { return _this.handleClearClick(); });
        }
        if (this.eventTypeSelect) {
            this.eventTypeSelect.addEventListener('change', function () { return _this.filterCards(); });
        }
        this.monthFilterElements.forEach(function (element) {
            var checkboxes = element.querySelectorAll('.c-multi-select__item input[type="checkbox"]');
            checkboxes.forEach(function (checkbox) {
                checkbox.addEventListener('change', function () { return _this.filterCards(); });
            });
        });
        (_a = this.showMoreButton) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () { return _this.showMoreCards(); });
    };
    FeatureCardsFilter.prototype.toggleFilters = function () {
        if (this.filtersPrimary && this.filtersToggleButton) {
            var isOpen = this.filtersPrimary.classList.toggle('is-open');
            this.filtersToggleButton.classList.toggle('is-open', isOpen);
            if (this.filtersToggleText) {
                this.filtersToggleText.textContent = isOpen ? 'Hide filters' : 'Show filters';
            }
        }
    };
    FeatureCardsFilter.prototype.showMoreCards = function () {
        this.cardsToShow += this.increment;
        this.updateCardVisibility();
    };
    FeatureCardsFilter.prototype.filterCards = function () {
        var _this = this;
        var _a, _b, _c;
        var selectedEventType = ((_a = this.eventTypeSelect) === null || _a === void 0 ? void 0 : _a.value) || "";
        var filteredMonths = [];
        this.filteredCards = [];
        var selectedMonths = [];
        this.monthFilterElements.forEach(function (element) {
            var checkboxes = element.querySelectorAll('.c-multi-select__item input[type="checkbox"]:checked');
            checkboxes.forEach(function (checkbox) {
                selectedMonths.push(checkbox.value);
            });
        });
        this.cards.forEach(function (card) {
            var parentCardItem = card.closest('[data-feature-cards-list-item]');
            if (!parentCardItem)
                return;
            var eventDate = card.getAttribute('data-event-date');
            var eventKey = card.getAttribute('data-event-key');
            var eventTypes = eventKey ? eventKey.split(', ') : [];
            var matchesEventType = !selectedEventType || eventTypes.some(function (type) { return type === selectedEventType; });
            var matchesMonth = !selectedMonths.length || selectedMonths.indexOf(eventDate || "") > -1;
            if (matchesEventType) {
                if (eventDate && filteredMonths.indexOf(eventDate) === -1) {
                    filteredMonths.push(eventDate);
                }
            }
            if (matchesEventType && matchesMonth) {
                _this.filteredCards.push(card);
                parentCardItem.classList.remove('c-feature-card__container--hidden');
            }
            else {
                parentCardItem.classList.add('c-feature-card__container--hidden');
            }
        });
        this.updateDateDropdown(filteredMonths);
        if (this.filteredCards.length === 0) {
            (_b = this.noResultsElement) === null || _b === void 0 ? void 0 : _b.classList.remove('c-feature-cards-no-results--hidden');
        }
        else {
            (_c = this.noResultsElement) === null || _c === void 0 ? void 0 : _c.classList.add('c-feature-cards-no-results--hidden');
        }
        this.updateCardVisibility();
        this.updateClearFiltersButton();
    };
    FeatureCardsFilter.prototype.updateDateDropdown = function (filteredMonths) {
        var dateDropdown = document.getElementById('monthFilter');
        if (dateDropdown) {
            var checkboxes = dateDropdown.querySelectorAll('.c-multi-select__item input[type="checkbox"]');
            checkboxes.forEach(function (checkbox) {
                var _a, _b;
                var checkboxElement = checkbox;
                var monthValue = checkboxElement.value;
                if (filteredMonths.indexOf(monthValue) > -1) {
                    (_a = checkboxElement.parentElement) === null || _a === void 0 ? void 0 : _a.classList.remove('c-multi-select__item--hidden');
                }
                else {
                    (_b = checkboxElement.parentElement) === null || _b === void 0 ? void 0 : _b.classList.add('c-multi-select__item--hidden');
                    checkboxElement.checked = false;
                }
            });
            this.updateMultiSelectPlaceholder(dateDropdown);
        }
    };
    FeatureCardsFilter.prototype.updateCardVisibility = function () {
        var _this = this;
        var _a, _b;
        this.filteredCards.forEach(function (card, index) {
            var parentCardItem = card.closest('[data-feature-cards-list-item]');
            if (parentCardItem) {
                if (index < _this.cardsToShow) {
                    parentCardItem.classList.remove('c-feature-card__container--hidden');
                }
                else {
                    parentCardItem.classList.add('c-feature-card__container--hidden');
                }
            }
        });
        if (this.cardsToShow < this.filteredCards.length) {
            (_a = this.showMoreButton) === null || _a === void 0 ? void 0 : _a.classList.remove('c-feature-cards-show-more-button--hidden');
        }
        else {
            (_b = this.showMoreButton) === null || _b === void 0 ? void 0 : _b.classList.add('c-feature-cards-show-more-button--hidden');
        }
    };
    FeatureCardsFilter.prototype.handleClearClick = function () {
        var _this = this;
        if (this.eventTypeSelect) {
            this.eventTypeSelect.value = "";
        }
        this.monthFilterElements.forEach(function (element) {
            var checkboxes = element.querySelectorAll('.c-multi-select__item input[type="checkbox"]');
            checkboxes.forEach(function (checkbox) { return checkbox.checked = false; });
            _this.updateMultiSelectPlaceholder(element);
        });
        this.cardsToShow = this.defaultCardsToShow;
        this.filterCards();
    };
    FeatureCardsFilter.prototype.updateClearFiltersButton = function () {
        var _a;
        if (this.clearFiltersButton) {
            var isMonthSelected = Array.prototype.slice.call(this.monthFilterElements).some(function (element) {
                return element.querySelectorAll('.c-multi-select__item input[type="checkbox"]:checked').length > 0;
            });
            var isEventTypeSelected = ((_a = this.eventTypeSelect) === null || _a === void 0 ? void 0 : _a.value) !== "";
            if (isMonthSelected || isEventTypeSelected) {
                this.clearFiltersButton.style.display = 'inline-block';
            }
            else {
                this.clearFiltersButton.style.display = 'none';
            }
        }
    };
    FeatureCardsFilter.prototype.updateMultiSelectPlaceholder = function (element) {
        var labelElem = element.querySelector('.js-multi-select-label');
        var wrapperElem = element.querySelector('.c-multi-select__list-wrapper');
        if (!labelElem || !wrapperElem) {
            return;
        }
        var selectedCheckboxes = wrapperElem.querySelectorAll('input[type="checkbox"]:checked');
        var placeholderText;
        if (selectedCheckboxes.length === 0) {
            placeholderText = labelElem.getAttribute('data-none-selected-text') || 'Any';
        }
        else if (selectedCheckboxes.length === 1) {
            placeholderText = "1 option selected";
        }
        else {
            placeholderText = "".concat(selectedCheckboxes.length, " options selected");
        }
        var toggleInner = labelElem.querySelector('.c-multi-select__toggle__inner');
        if (toggleInner) {
            toggleInner.textContent = placeholderText;
        }
    };
    return FeatureCardsFilter;
}());
new FeatureCardsFilter();

var MultiSelect = (function () {
    function MultiSelect() {
        var _this = this;
        this.multiSelectElements = document.querySelectorAll('.c-multi-select');
        this.setupMultiSelects();
        document.addEventListener('click', function (event) { return _this.handleGlobalClick(event); });
    }
    MultiSelect.prototype.setupMultiSelects = function () {
        var _this = this;
        this.multiSelectElements.forEach(function (element) {
            var label = element.querySelector('.js-multi-select-label');
            var wrapper = element.querySelector('.c-multi-select__list-wrapper');
            if (label && wrapper) {
                label.addEventListener('click', function () { return _this.toggleDropdown(label, wrapper); });
                _this.setupCheckboxHandlers(element);
                _this.updateButtonText(label, wrapper);
            }
        });
    };
    MultiSelect.prototype.toggleDropdown = function (label, wrapper) {
        var isExpanded = wrapper.classList.contains('c-multi-select__list-wrapper--visible');
        document.querySelectorAll('.c-multi-select__list-wrapper').forEach(function (el) { return el.classList.remove('c-multi-select__list-wrapper--visible'); });
        document.querySelectorAll('.c-multi-select__toggle').forEach(function (el) { return el.classList.remove('c-multi-select__toggle--expanded'); });
        if (!isExpanded) {
            wrapper.classList.add('c-multi-select__list-wrapper--visible');
            label.classList.add('c-multi-select__toggle--expanded');
            label.setAttribute('aria-expanded', 'true');
        }
        else {
            label.classList.remove('c-multi-select__toggle--expanded');
            label.setAttribute('aria-expanded', 'false');
        }
    };
    MultiSelect.prototype.handleGlobalClick = function (event) {
        var target = event.target;
        if (!target.closest('.c-multi-select')) {
            document.querySelectorAll('.c-multi-select__list-wrapper').forEach(function (el) { return el.classList.remove('c-multi-select__list-wrapper--visible'); });
            document.querySelectorAll('.c-multi-select__toggle').forEach(function (el) { return el.classList.remove('c-multi-select__toggle--expanded'); });
        }
    };
    MultiSelect.prototype.setupCheckboxHandlers = function (element) {
        var _this = this;
        var checkboxes = element.querySelectorAll('.c-multi-select__item input[type="checkbox"]');
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () { return _this.handleCheckboxChange(element); });
        });
    };
    MultiSelect.prototype.handleCheckboxChange = function (element) {
        this.updateMultiSelectPlaceholder(element);
    };
    MultiSelect.prototype.updateMultiSelectPlaceholder = function (element) {
        var labelElem = element.querySelector('.js-multi-select-label');
        var wrapperElem = element.querySelector('.c-multi-select__list-wrapper');
        if (!labelElem || !wrapperElem) {
            console.error('Multi-select label or wrapper element not found.');
            return;
        }
        var selectedCheckboxes = wrapperElem.querySelectorAll('input[type="checkbox"]:checked');
        var placeholderText;
        if (selectedCheckboxes.length === 0) {
            placeholderText = labelElem.getAttribute('data-none-selected-text') || 'Any';
        }
        else if (selectedCheckboxes.length === 1) {
            placeholderText = "1 option selected";
        }
        else {
            placeholderText = "".concat(selectedCheckboxes.length, " options selected");
        }
        var toggleInner = labelElem.querySelector('.c-multi-select__toggle__inner');
        if (toggleInner) {
            toggleInner.textContent = placeholderText;
        }
    };
    MultiSelect.prototype.updateButtonText = function (label, wrapper) {
        this.multiSelectElements.forEach(function (element) {
            var labelElem = label || element.querySelector('.js-multi-select-label');
            var wrapperElem = wrapper || element.querySelector('.c-multi-select__list-wrapper');
            if (labelElem && wrapperElem) {
                var selectedCount = wrapperElem.querySelectorAll('input[type="checkbox"]:checked').length;
                var noneSelectedText = labelElem.getAttribute('data-none-selected-text') || 'Any';
                var buttonText = selectedCount > 0
                    ? "".concat(selectedCount, " options selected")
                    : noneSelectedText;
                var toggleInner = labelElem.querySelector('.c-multi-select__toggle__inner');
                if (toggleInner) {
                    toggleInner.textContent = buttonText;
                }
            }
        });
    };
    return MultiSelect;
}());
new MultiSelect();
